/**
 * Prefix
 * TC: Title Case
 * SC: Sentence Case
 * UC: UpperCase
 * LC: LowerCase
 */

export enum Translation {
  // Entity cardinalities
  SC_N_ITEMS = 'SC_N_ITEMS',
  SC_N_GROUPS = 'SC_N_GROUPS',
  SC_N_COLLATERALS = 'SC_N_COLLATERALS',
  SC_N_SECONDARY_COLLATERALS = 'SC_N_SECONDARY_COLLATERALS',
  SC_N_COLLATERAL_BASKETS = 'SC_N_COLLATERAL_BASKETS',
  SC_N_PRODUCT_SECTORS = 'SC_N_PRODUCT_SECTORS',
  SC_N_COLLECTIONS = 'SC_N_COLLECTIONS',
  SC_N_COUNTERPARTIES = 'SC_N_COUNTERPARTIES',
  SC_N_FUNDS = 'SC_N_FUNDS',
  SC_N_TRADING_ENTITIES = 'SC_N_TRADING_ENTITIES',
  SC_N_COUNTERPARTY_GROUPS = 'SC_N_COUNTERPARTY_GROUPS',
  SC_N_MASTER_LEGAL_AGREEMENTS = 'SC_N_MASTER_LEGAL_AGREEMENTS',

  // General Application
  SC_APP_DESCRIPTION = 'SC_APP_DESCRIPTION',

  // About Dialog
  TC_ABOUT = 'TC_ABOUT',
  TC_OVERVIEW = 'TC_OVERVIEW',
  TC_DIAGNOSTICS = 'TC_DIAGNOSTICS',
  TC_VERSION = 'TC_VERSION',
  TC_OPEN_FIN_VERSION = 'TC_OPEN_FIN_VERSION',
  TC_BUILD = 'TC_BUILD',
  SC_DIAGNOSTICS_SENT = 'SC_DIAGNOSTICS_SENT',

  // Navigation sections
  TC_SECTION_STAGING = 'TC_SECTION_STAGING',
  TC_SECTION_INITIATED = 'TC_SECTION_INITIATED',
  TC_SECTION_INITIATED_GRID_VIEW = 'TC_SECTION_INITIATED_GRID_VIEW',
  TC_SECTION_INCOMING = 'TC_SECTION_INCOMING',
  TC_SECTION_CURVES = 'TC_SECTION_CURVES',
  TC_SECTION_TRADES = 'TC_SECTION_TRADES',
  TC_SECTION_AXE_BOARD = 'TC_SECTION_AXE_BOARD',
  TC_SECTION_AXE_BOARD_INITIATOR = 'TC_SECTION_AXE_BOARD_INITIATOR',
  TC_SECTION_AXE_BOARD_RESPONDER = 'TC_SECTION_AXE_BOARD_RESPONDER',
  TC_SECTION_COLLATERAL_BASKETS = 'TC_SECTION_COLLATERAL_BASKETS',
  TC_SECTION_NEGOTIATION_HISTORY = 'TC_SECTION_NEGOTIATION_HISTORY',
  TC_SECTION_HISTORICAL = 'TC_SECTION_HISTORICAL',
  TC_SECTION_ADMIN = 'TC_SECTION_ADMIN',
  TC_SECTION_PRIME_BROKER_DEFAULTS = 'TC_SECTION_PRIME_BROKER_DEFAULTS',
  TC_SECTION_TRADING_ENTITY_DEFAULTS = 'TC_SECTION_TRADING_ENTITY_DEFAULTS',
  TC_SECTION_TRADING_ENTITY_ALIASES = 'TC_SECTION_TRADING_ENTITY_ALIASES',
  TC_SECTION_SALES_COVERAGE = 'TC_SECTION_SALES_COVERAGE',
  TC_SECTION_TRADING_LIMITS = 'TC_SECTION_TRADING_LIMITS',
  TC_SECTION_RESPONDER_SALES_COVERAGE = 'TC_SECTION_RESPONDER_SALES_COVERAGE',
  TC_SECTION_HAIRCUT = 'TC_SECTION_HAIRCUT',
  TC_SECTION_PLATFORM = 'TC_SECTION_PLATFORM',
  TC_SECTION_PLATFORM_CLIENT_LOGSTREAMS = 'TC_SECTION_PLATFORM_CLIENT_LOGSTREAMS',
  TC_SECTION_ORDER_RECORD_KEEPING = 'TC_SECTION_ORDER_RECORD_KEEPING',
  TC_SECTION_ORGANISATIONS = 'TC_SECTION_ORGANISATIONS',
  TC_SECTION_TRADING_ENTITIES = 'TC_SECTION_TRADING_ENTITIES',
  TC_SECTION_CLEARING_HOUSES = 'TC_SECTION_CLEARING_HOUSES',
  TC_SECTION_USERS = 'TC_SECTION_USERS',
  TC_SECTION_COLLATERALS = 'TC_SECTION_COLLATERALS',
  TC_SECTION_EU_MARKET = 'TC_SECTION_EU_MARKET',
  TC_SECTION_US_MARKET = 'TC_SECTION_US_MARKET',
  TC_SECTION_FAT_FINGER_LIMITS = 'TC_SECTION_FAT_FINGER_LIMITS',
  TC_SECTION_HOLIDAYS = 'TC_SECTION_HOLIDAYS',
  TC_SECTION_INDICES = 'TC_SECTION_INDICES',
  TC_SECTION_MID_POST_TRADE_EVENTS = 'TC_SECTION_MID_POST_TRADE_EVENTS',
  TC_SECTION_OPEN_REPO = 'TC_SECTION_OPEN_REPO',
  TC_SECTION_OPEN = 'TC_SECTION_OPEN',
  TC_SECTION_STRUCTURED = 'TC_SECTION_STRUCTURED',
  TC_SECTION_TRADING_CONTROL = 'TC_SECTION_TRADING_CONTROL',
  TC_SECTION_TRADE_SPLITS = 'TC_SECTION_TRADE_SPLITS',
  TC_SECTION_PRODUCTS = 'TC_SECTION_PRODUCTS',
  TC_SECTION_SECTORS = 'TC_SECTION_SECTORS',
  TC_SECTION_SECTOR_MAPPING = 'TC_SECTION_SECTOR_MAPPING',
  TC_SECTION_HISTORY = 'TC_SECTION_HISTORY',
  TC_SECTION_FX_RATES = 'TC_SECTION_FX_RATES',
  TC_SECTION_ROLLS = 'TC_SECTION_ROLLS',
  TC_SECTION_COMPLIANCE = 'TC_SECTION_COMPLIANCE',
  TC_SECTION_COMPLIANCE_ISSUER_ORGANISATIONS = 'TC_SECTION_COMPLIANCE_ISSUER_ORGANISATIONS',

  // Suspensions
  TC_SUSPENSIONS = 'TC_SUSPENSIONS',
  SC_MARKET_CLOSED = 'SC_MARKET_CLOSED',
  SC_MARKET_PRE_OPEN = 'SC_MARKET_PRE_OPEN',
  SC_PLATFORM_SUSPENDED = 'SC_PLATFORM_SUSPENDED',
  SC_ORGANISATION_SUSPENDED = 'SC_ORGANISATION_SUSPENDED',
  SC_USER_SUSPENDED = 'SC_USER_SUSPENDED',

  // Spreadsheet Upload
  TC_UPLOAD_DEFAULT = 'TC_UPLOAD_DEFAULT',
  TC_UPLOAD_FILE = 'TC_UPLOAD_FILE',
  TC_BROWSE_FILE = 'TC_BROWSE_FILE',
  TC_CHANGE_FILE = 'TC_CHANGE_FILE',
  SC_ORDER_PLACEHOLDER_NARRATIVE_1 = 'SC_ORDER_PLACEHOLDER_NARRATIVE_1',
  SC_ORDER_PLACEHOLDER_NARRATIVE_2 = 'SC_ORDER_PLACEHOLDER_NARRATIVE_2',
  SC_UPLOAD_DROPZONE_NARRATIVE = 'SC_UPLOAD_DROPZONE_NARRATIVE',
  SC_INCOMING_PLACEHOLDER_NARRATIVE = 'SC_INCOMING_PLACEHOLDER_NARRATIVE',
  SC_INCOMING_DROPZONE_NARRATIVE = 'SC_INCOMING_DROPZONE_NARRATIVE',
  SC_MTE_PLACEHOLDER_NARRATIVE = 'SC_MTE_PLACEHOLDER_NARRATIVE',
  SC_MTE_DROPZONE_NARRATIVE = 'SC_MTE_DROPZONE_NARRATIVE',
  SC_MTE_UPLOAD_PRELOADING_TRADES = 'SC_MTE_UPLOAD_PRELOADING_TRADES',
  SC_COLLATERAL_DROPZONE_NARRATIVE = 'SC_COLLATERAL_DROPZONE_NARRATIVE',
  SC_TRADING_ENTITY_DROPZONE_NARRATIVE = 'SC_TRADING_ENTITY_DROPZONE_NARRATIVE',
  SC_TRADING_ENTITY_PRODUCT_DROPZONE_NARRATIVE = 'SC_TRADING_ENTITY_PRODUCT_DROPZONE_NARRATIVE',
  SC_TRADING_RELATIONSHIP_DROPZONE_NARRATIVE = 'SC_TRADING_RELATIONSHIP_DROPZONE_NARRATIVE',
  SC_UPLOAD_SPREADSHEET_MAPPING_DROPZONE_NARRATIVE = 'SC_UPLOAD_SPREADSHEET_MAPPING_DROPZONE_NARRATIVE',
  SC_CLIPBOARD = 'SC_CLIPBOARD',
  TC_ADD_ASSETS = 'TC_ADD_ASSETS',
  TC_ADD_AXES = 'TC_ADD_AXES',
  TC_UPLOAD_PRICES = 'TC_UPLOAD_PRICES',
  TC_UPLOAD_MTE = 'TC_UPLOAD_MTE',
  TC_UPLOAD_COLLATERAL = 'TC_UPLOAD_COLLATERAL',
  TC_UPLOAD_TRADING_ENTITY = 'TC_UPLOAD_TRADING_ENTITY',
  TC_UPLOAD_TRADING_ENTITY_PRODUCT = 'TC_UPLOAD_TRADING_ENTITY_PRODUCT',
  TC_UPLOAD_TRADING_RELATIONSHIP = 'TC_UPLOAD_TRADING_RELATIONSHIP',
  TC_UPLOAD_SPREADSHEET_MAPPING = 'TC_UPLOAD_SPREADSHEET_MAPPING',
  TC_VALID_MTE = 'TC_VALID_MTE',
  TC_VALID = 'TC_VALID',
  TC_INVALID = 'TC_INVALID',
  TC_INVALID_MTE = 'TC_INVALID_MTE',
  SC_DOWNLOAD_TEMPLATE = 'SC_DOWNLOAD_TEMPLATE',
  TC_DOWNLOAD_INCOMING_TEMPLATE_FILENAME = 'TC_DOWNLOAD_INCOMING_TEMPLATE_FILENAME',
  TC_DOWNLOAD_CURVE_TEMPLATE_FILENAME = 'TC_DOWNLOAD_CURVE_TEMPLATE_FILENAME',
  TC_DOWNLOAD_ORDER_TEMPLATE_FILENAME = 'TC_DOWNLOAD_ORDER_TEMPLATE_FILENAME',
  TC_DOWNLOAD_AXE_TEMPLATE_FILENAME = 'TC_DOWNLOAD_AXE_TEMPLATE_FILENAME',
  TC_DOWNLOAD_MTE_TEMPLATE_FILENAME = 'TC_DOWNLOAD_MTE_TEMPLATE_FILENAME',
  TC_DOWNLOAD_MTE_RESPONSE_TEMPLATE_FILENAME = 'TC_DOWNLOAD_MTE_RESPONSE_TEMPLATE_FILENAME',
  TC_DOWNLOAD_COLLATERAL_TEMPLATE_FILENAME = 'TC_DOWNLOAD_COLLATERAL_TEMPLATE_FILENAME',
  TC_DOWNLOAD_TRADING_ENTITY_TEMPLATE_FILENAME = 'TC_DOWNLOAD_TRADING_ENTITY_TEMPLATE_FILENAME',
  TC_DOWNLOAD_TRADING_ENTITY_PRODUCT_TEMPLATE_FILENAME = 'TC_DOWNLOAD_TRADING_ENTITY_PRODUCT_TEMPLATE_FILENAME',
  TC_DOWNLOAD_TRADING_RELATIONSHIP_TEMPLATE_FILENAME = 'TC_DOWNLOAD_TRADING_RELATIONSHIP_TEMPLATE_FILENAME',
  SC_REPLACE_EXISTING_BONDS = 'SC_REPLACE_EXISTING_BONDS',
  SC_AXE_SPREADSHEET_SUCCESS = 'SC_AXE_SPREADSHEET_SUCCESS',
  SC_AXE_SPREADSHEET_ERROR = 'SC_AXE_SPREADSHEET_ERROR',
  SC_ORDER_SPREADSHEET_SUCCESS = 'SC_ORDER_SPREADSHEET_SUCCESS',
  SC_ORDER_SPREADSHEET_ERROR = 'SC_ORDER_SPREADSHEET_ERROR',
  SC_COLLATERAL_BASKET_ALLOCATION_SPREADSHEET_SUCCESS = 'SC_COLLATERAL_BASKET_ALLOCATION_SPREADSHEET_SUCCESS',
  SC_COLLATERAL_BASKET_ALLOCATION_SPREADSHEET_ERROR = 'SC_COLLATERAL_BASKET_ALLOCATION_SPREADSHEET_ERROR',
  SC_INCOMING_SPREADSHEET_SUCCESS = 'SC_INCOMING_SPREADSHEET_SUCCESS',
  SC_INCOMING_SPREADSHEET_ERROR = 'SC_INCOMING_SPREADSHEET_ERROR',
  SC_MTE_SPREADSHEET_SUCCESS = 'SC_MTE_SPREADSHEET_SUCCESS',
  SC_MTE_SPREADSHEET_ERROR = 'SC_MTE_SPREADSHEET_ERROR',
  SC_COLLATERAL_SPREADSHEET_SUCCESS = 'SC_COLLATERAL_SPREADSHEET_SUCCESS',
  SC_COLLATERAL_SPREADSHEET_ERROR = 'SC_COLLATERAL_SPREADSHEET_ERROR',
  SC_TRADING_ENTITY_SPREADSHEET_SUCCESS = 'SC_TRADING_ENTITY_SPREADSHEET_SUCCESS',
  SC_TRADING_ENTITY_SPREADSHEET_ERROR = 'SC_TRADING_ENTITY_SPREADSHEET_ERROR',
  SC_TRADING_ENTITY_PRODUCT_SPREADSHEET_SUCCESS = 'SC_TRADING_ENTITY_PRODUCT_SPREADSHEET_SUCCESS',
  SC_TRADING_ENTITY_PRODUCT_SPREADSHEET_ERROR = 'SC_TRADING_ENTITY_PRODUCT_SPREADSHEET_ERROR',
  SC_TRADING_RELATIONSHIP_SPREADSHEET_SUCCESS = 'SC_TRADING_RELATIONSHIP_SPREADSHEET_SUCCESS',
  SC_TRADING_RELATIONSHIP_SPREADSHEET_ERROR = 'SC_TRADING_RELATIONSHIP_SPREADSHEET_ERROR',
  SC_UPLOAD_ERROR_NARRATIVE = 'SC_UPLOAD_ERROR_NARRATIVE',
  SC_UPLOAD_ERROR_NARRATIVE_MAPPING = 'SC_UPLOAD_ERROR_NARRATIVE_MAPPING',
  SC_UPLOAD_ERROR_SPREADSHEET_MAPPING = 'SC_UPLOAD_ERROR_SPREADSHEET_MAPPING',
  SC_UPLOAD_ERROR_NARRATIVE_MAPPING_NO_ITEMS = 'SC_UPLOAD_ERROR_NARRATIVE_MAPPING_NO_ITEMS',
  SC_SAVED_MAPPINGS = 'SC_SAVED_MAPPINGS',
  TC_COLUMN_MAPPINGS = 'TC_COLUMN_MAPPINGS',
  TC_PENDING_PRICE_UPLOADS = 'TC_PENDING_PRICE_UPLOADS',
  TC_PENDING_MID_TRADE_EVENTS = 'TC_PENDING_MID_TRADE_EVENTS',
  TC_PENDING_COLLATERALS = 'TC_PENDING_COLLATERALS',
  TC_PENDING_TRADING_ENTITIES = 'TC_PENDING_TRADING_ENTITIES',
  TC_PENDING_TRADING_ENTITY_PRODUCTS = 'TC_PENDING_TRADING_ENTITY_PRODUCTS',
  TC_PENDING_TRADING_RELATIONSHIPS = 'TC_PENDING_TRADING_RELATIONSHIPS',
  SC_SYSTEM_MAPPING = 'SC_SYSTEM_MAPPING',
  SC_COLUMN_HEADING = 'SC_COLUMN_HEADING',
  SC_AMOUNT_FORMAT = 'SC_AMOUNT_FORMAT',
  SC_DATE_FORMAT = 'SC_DATE_FORMAT',
  SC_RATE_FORMAT = 'SC_RATE_FORMAT',
  SC_REF_RATE_FORMAT = 'SC_REF_RATE_FORMAT',
  TC_ORDER_FIELD = 'TC_ORDER_FIELD',
  TC_COLLATERAL_BASKET_ALLOCATION_FIELD = 'TC_COLLATERAL_BASKET_ALLOCATION_FIELD',
  TC_INCOMING_FIELD = 'TC_INCOMING_FIELD',
  TC_MID_TRADE_EVENTS_FIELD = 'TC_MID_TRADE_EVENTS_FIELD',
  TC_COLLATERAL_FIELD = 'TC_COLLATERAL_FIELD',
  TC_TRADING_ENTITY_FIELD = 'TC_TRADING_ENTITY_FIELD',
  TC_TRADING_ENTITY_PRODUCT_FIELD = 'TC_TRADING_ENTITY_PRODUCT_FIELD',
  TC_TRADING_RELATIONSHIP_FIELD = 'TC_TRADING_RELATIONSHIP_FIELD',
  TC_SPREADSHEET_COLUMN = 'TC_SPREADSHEET_COLUMN',
  TC_CREATE_MAPPING = 'TC_CREATE_MAPPING',
  TC_UPDATE_MAPPING = 'TC_UPDATE_MAPPING',
  SC_DISPLAY_NAME = 'SC_DISPLAY_NAME',
  TC_PROMPT_TITLE_DELETE_SPREADSHEET_MAPPING = 'TC_PROMPT_TITLE_DELETE_SPREADSHEET_MAPPING',
  SC_PROMPT_MSG_DELETE_SPREADSHEET_MAPPING = 'SC_PROMPT_MSG_DELETE_SPREADSHEET_MAPPING',
  SC_DERIVE_FROM_AMOUNTS = 'SC_DERIVE_FROM_AMOUNTS',
  SC_POSITIVE_IS_BUY = 'SC_POSITIVE_IS_BUY',
  SC_POSITIVE_IS_SELL = 'SC_POSITIVE_IS_SELL',
  SC_ENUM_VALUE_PREFIX = 'SC_ENUM_VALUE_PREFIX',
  SC_EXCEL_DATE_COLUMN = 'SC_EXCEL_DATE_COLUMN',
  TC_CLIPBOARD_ERROR_TITLE = 'TC_CLIPBOARD_ERROR_TITLE',
  SC_CLIPBOARD_ERROR_MESSAGE = 'SC_CLIPBOARD_ERROR_MESSAGE',
  TC_UPLOAD_ERROR_TITLE = 'TC_UPLOAD_ERROR_TITLE',
  SC_UPLOAD_ERROR_MESSAGE = 'SC_UPLOAD_ERROR_MESSAGE',
  SC_UPLOAD_PRELOAD_FAILED = 'SC_UPLOAD_PRELOAD_FAILED',
  SC_REPORT_MAPPING_REQUESTED = 'SC_REPORT_MAPPING_REQUESTED',
  SC_DUPLICATE_TRADE_ID = 'SC_DUPLICATE_TRADE_ID',
  SC_MISSING_TRADE_ID = 'SC_MISSING_TRADE_ID',
  SC_INVALID_TRADE_ID = 'SC_INVALID_TRADE_ID',
  SC_MISSING_ACTION_TYPE = 'SC_MISSING_ACTION_TYPE',
  SC_MISSING_RESPONSE_TYPE = 'SC_MISSING_RESPONSE_TYPE',
  SC_INVALID_SERVICING_TRADE_ID = 'SC_INVALID_SERVICING_TRADE_ID',
  SC_INVALID_SEND_ON_TERMINATE = 'SC_INVALID_SEND_ON_TERMINATE',
  SC_DUPLICATE_RFQ_ID = 'SC_DUPLICATE_RFQ_ID',
  SC_DUPLICATE_NEGOTIATION_ID = 'SC_DUPLICATE_NEGOTIATION_ID',
  SC_MISSING_RFQ_AND_NEGOTIATION_ID = 'SC_MISSING_RFQ_AND_NEGOTIATION_ID',
  SC_MISSING_COLLECTION_ID = 'SC_MISSING_COLLECTION_ID',
  SC_MISSING_TERM = 'SC_MISSING_TERM',
  SC_MISSING_START_DATE = 'SC_MISSING_START_DATE',
  SC_MISSING_END_DATE = 'SC_MISSING_END_DATE',
  SC_DUPLICATE_UPLOAD = 'SC_DUPLICATE_UPLOAD',
  SC_CUSTOM_TERM = 'SC_CUSTOM_TERM',
  SC_MULTIPLE_MATCHES = 'SC_MULTIPLE_MATCHES',
  SC_NO_MATCHES = 'SC_NO_MATCHES',
  SC_INVALID_RFQ_ID = 'SC_INVALID_RFQ_ID',
  SC_INVALID_NEGOTIATION_ID = 'SC_INVALID_NEGOTIATION_ID',
  SC_NEGOTIATION_ID_RFQ_ID_CLASH = 'SC_NEGOTIATION_ID_RFQ_ID_CLASH',
  SC_MISSING_RATE = 'SC_MISSING_RATE',
  SC_VALUE_REQUIRED = 'SC_VALUE_REQUIRED',
  SC_INVALID_TRADING_ENTITY = 'SC_INVALID_TRADING_ENTITY',
  SC_INVALID_PRODUCT_SECTOR = 'SC_INVALID_PRODUCT_SECTOR',
  SC_DUPLICATE_TRADING_ENTITY_PRODUCT = 'SC_DUPLICATE_TRADING_ENTITY_PRODUCT',
  SC_INVALID_BUY_ORGANISATION = 'SC_INVALID_BUY_ORGANISATION',
  SC_INVALID_SELL_ORGANISATION = 'SC_INVALID_SELL_ORGANISATION',
  SC_DUPLICATE_TRADING_RELATIONSHIP = 'SC_DUPLICATE_TRADING_RELATIONSHIP',
  SC_SAME_ORGANISATION_ERROR = 'SC_SAME_ORGANISATION_ERROR',
  SC_MISSING_DEFAULT_AGREEMENT = 'SC_MISSING_DEFAULT_AGREEMENT',
  SC_INVALID_DEFAULT_AGREEMENT = 'SC_INVALID_DEFAULT_AGREEMENT',
  SC_INVALID_STOCK_BORROWING_LENDING_ID = 'SC_INVALID_STOCK_BORROWING_LENDING_ID',
  SC_SETTLEMENT_TYPE_NOT_EDITABLE = 'SC_SETTLEMENT_TYPE_NOT_EDITABLE',
  SC_BUTTON_SET_AS_DEFAULT = 'SC_BUTTON_SET_AS_DEFAULT',

  // Activity Monitor
  TC_ACTIVITY_MONITOR = 'TC_ACTIVITY_MONITOR',
  SC_NO_ACTIVITIES = 'SC_NO_ACTIVITIES',
  SC_ORDER_BY_TIME_REMAINING = 'SC_ORDER_BY_TIME_REMAINING',
  SC_CLEARING_FAILED_TRADES = 'SC_CLEARING_FAILED_TRADES',

  // Tickets
  SC_NEGOTIATION_NOT_EXIST = 'SC_NEGOTIATION_NOT_EXIST',
  SC_DEAL_NOT_EXIST = 'SC_DEAL_NOT_EXIST',
  SC_COMPETITORS = 'SC_COMPETITORS',
  TC_TICKET_QUICK_SUMMARY = 'TC_TICKET_QUICK_SUMMARY',
  TC_TICKET_SWIFT_INTERACTIONS = 'TC_TICKET_SWIFT_INTERACTIONS',
  TC_TICKET_AMOUNT = 'TC_TICKET_AMOUNT',
  TC_TICKET_PRICING = 'TC_TICKET_PRICING',
  TC_TICKET_TERM = 'TC_TICKET_TERM',
  TC_TICKET_TIMERS = 'TC_TICKET_TIMERS',
  TC_TICKET_INSTRUMENT = 'TC_TICKET_INSTRUMENT',
  TC_TICKET_PARTIES = 'TC_TICKET_PARTIES',
  TC_TICKET_FLAGS = 'TC_TICKET_FLAGS',
  TC_TICKET_AUDIT = 'TC_TICKET_AUDIT',
  TC_TICKET_INTERNAL_BOOKING = 'TC_TICKET_INTERNAL_BOOKING',
  TC_NOTIONAL_ORIGINAL = 'TC_NOTIONAL_ORIGINAL',
  TC_NOTIONAL_ORIGINAL_SHORT = 'TC_NOTIONAL_ORIGINAL_SHORT',
  TC_RATE_TARGET = 'TC_RATE_TARGET',
  TC_HAIRCUT_TARGET = 'TC_HAIRCUT_TARGET',
  TC_START_DATE_TARGET = 'TC_START_DATE_TARGET',
  TC_END_DATE_TARGET = 'TC_END_DATE_TARGET',
  TC_CONTACT = 'TC_CONTACT',
  SC_ORIGINAL_RFQ_CANCELLED = 'SC_ORIGINAL_RFQ_CANCELLED',
  SC_ORIGINAL_RFQ_TIME_REMAINING = 'SC_ORIGINAL_RFQ_TIME_REMAINING',
  SC_TICKET_MODIFIED_NARRATIVE = 'SC_TICKET_MODIFIED_NARRATIVE',
  SC_TICKET_LAST_LOOK_NARRATIVE = 'SC_TICKET_LAST_LOOK_NARRATIVE',
  SC_TICKET_QUOTE_SUBJECT_NARRATIVE = 'SC_TICKET_QUOTE_SUBJECT_NARRATIVE',
  SC_TICKET_WITHDRAWN_ACTOR_NARRATIVE = 'SC_TICKET_WITHDRAWN_ACTOR_NARRATIVE',
  SC_TICKET_WITHDRAWN_RECEIVER_NARRATIVE = 'SC_TICKET_WITHDRAWN_RECEIVER_NARRATIVE',
  SC_TICKET_CANCELLED_INITIATOR_NARRATIVE = 'SC_TICKET_CANCELLED_INITIATOR_NARRATIVE',
  SC_TICKET_CANCELLED_RESPONDER_NARRATIVE = 'SC_TICKET_CANCELLED_RESPONDER_NARRATIVE',
  SC_ORIGINAL_DEAL_CANCELLED = 'SC_ORIGINAL_DEAL_CANCELLED',
  SC_TICKET_CANCELLED_ADMIN_NARRATIVE = 'SC_TICKET_CANCELLED_ADMIN_NARRATIVE',
  SC_TICKET_CANCELED_BY_USER = 'SC_TICKET_CANCELED_BY_USER',

  // action/message types
  TC_UNPREPARED = 'TC_UNPREPARED',
  TC_ERROR = 'TC_ERROR',
  TC_READY = 'TC_READY',
  TC_READY_TO_SEND = 'TC_READY_TO_SEND',
  TC_DRAFT = 'TC_DRAFT',
  TC_AWAITING_RESPONSE = 'TC_AWAITING_RESPONSE',
  TC_AWAITING = 'TC_AWAITING',
  TC_NEW_REQUEST = 'TC_NEW_REQUEST',
  TC_PRICED = 'TC_PRICED',
  TC_PRICED_NEW = 'TC_PRICED_NEW',
  TC_UNPRICED = 'TC_UNPRICED',
  TC_QUOTED = 'TC_QUOTED',
  TC_COUNTERED = 'TC_COUNTERED',
  TC_COUNTER_IN = 'TC_COUNTER_IN',
  TC_REFRESHED = 'TC_REFRESHED',
  TC_QUOTE_SUBJECT = 'TC_QUOTE_SUBJECT',
  TC_SENT = 'TC_SENT',
  TC_SUBMITTED = 'TC_SUBMITTED',
  TC_ACCEPTED = 'TC_ACCEPTED',
  TC_REJECTED = 'TC_REJECTED',
  TC_WITHDRAWN = 'TC_WITHDRAWN',
  TC_SUBJECT = 'TC_SUBJECT',
  TC_LAST_LOOK = 'TC_LAST_LOOK',
  TC_CANCELLED = 'TC_CANCELLED',
  TC_EXPIRED = 'TC_EXPIRED',
  TC_TRADED_AWAY = 'TC_TRADED_AWAY',
  TC_MISSED = 'TC_MISSED',
  TC_TOTAL = 'TC_TOTAL',
  TC_DONE = 'TC_DONE',
  TC_AMENDED = 'TC_AMENDED',
  TC_AMENDING = 'TC_AMENDING',
  TC_CANCELLING = 'TC_CANCELLING',
  TC_COMPLETED = 'TC_COMPLETED',
  TC_ONGOING = 'TC_ONGOING',
  TC_ACTIVE = 'TC_ACTIVE',
  TC_SUSPENDED = 'TC_SUSPENDED',
  TC_PENDING = 'TC_PENDING',
  TC_PENDING_FAILED = 'TC_PENDING_FAILED',
  TC_PENDING_AWAITING_PRICE = 'TC_PENDING_AWAITING_PRICE',
  TC_ENABLED = 'TC_ENABLED',
  TC_DISABLED = 'TC_DISABLED',
  TC_DELETED = 'TC_DELETED',
  TC_PRE_OPEN = 'TC_PRE_OPEN',
  TC_OPEN = 'TC_OPEN',
  TC_CLOSED = 'TC_CLOSED',
  TC_CLEARING_FAILED = 'TC_CLEARING_FAILED',
  TC_CLEARING_PENDING = 'TC_CLEARING_PENDING',
  TC_CLEARING_REJECTED = 'TC_CLEARING_REJECTED',
  TC_CLEARING_REQUIRED = 'TC_CLEARING_REQUIRED',
  TC_SPONSORED_SUFFIX = 'TC_SPONSORED_SUFFIX',
  TC_UNASSIGNED = 'TC_UNASSIGNED',
  TC_ASSIGNED = 'TC_ASSIGNED',
  TC_UNALLOCATED = 'TC_UNALLOCATED',
  TC_ALLOCATED = 'TC_ALLOCATED',
  TC_EXPIRED_ALLOCATION = 'TC_EXPIRED_ALLOCATION',
  TC_SUBSTITUTION = 'TC_SUBSTITUTION',
  TC_SUBSTITUTION_PENDING = 'TC_SUBSTITUTION_PENDING',
  TC_RERATE = 'TC_RERATE',
  TC_CLOSE_OPEN = 'TC_CLOSE_OPEN',
  TC_RETURN_RECALL = 'TC_RETURN_RECALL',
  TC_TERMINATION = 'TC_TERMINATION',
  TC_TERMINATE = 'TC_TERMINATE',
  TC_ROLL_IN_PLACE = 'TC_ROLL_IN_PLACE',
  TC_AMEND_TRADE = 'TC_AMEND_TRADE',
  TC_NEW_DEAL = 'TC_NEW_DEAL',
  TC_CANCEL_TRADE = 'TC_CANCEL_TRADE',
  TC_COUNTERED_REFRESHED = 'TC_COUNTERED_REFRESHED',
  TC_ALL = 'TC_ALL',
  TC_NONE = 'TC_NONE',
  TC_ROLLED = 'TC_ROLLED',

  // Hero panel labels
  TC_HERO_STAGING = 'TC_HERO_STAGING',
  TC_HERO_INITIATED = 'TC_HERO_INITIATED',
  TC_HERO_INCOMING = 'TC_HERO_INCOMING',
  TC_HERO_CURVES = 'TC_HERO_CURVES',
  TC_HERO_DEALS = 'TC_HERO_DEALS',
  TC_HERO_MID_POST_TRADE_EVENTS = 'TC_HERO_MID_POST_TRADE_EVENTS',
  TC_HERO_OPEN_REPO = 'TC_HERO_OPEN_REPO',
  TC_HERO_STRUCTURED = 'TC_HERO_STRUCTURED',
  TC_HERO_COLLATERAL_BASKETS = 'TC_HERO_COLLATERAL_BASKETS',
  TC_HERO_NEGOTIATION_HISTORY = 'TC_HERO_NEGOTIATION_HISTORY',
  TC_HERO_HISTORICAL = 'TC_HERO_HISTORICAL',
  TC_HERO_PRIME_BROKER_DEFAULTS = 'TC_HERO_PRIME_BROKER_DEFAULTS',
  TC_HERO_TRADING_ENTITY_DEFAULTS = 'TC_HERO_TRADING_ENTITY_DEFAULTS',
  TC_HERO_TRADING_ENTITY_ALIASES = 'TC_HERO_TRADING_ENTITY_ALIASES',
  TC_HERO_SALES_COVERAGE = 'TC_HERO_SALES_COVERAGE',
  TC_HERO_TRADING_LIMITS = 'TC_HERO_TRADING_LIMITS',
  TC_HERO_RESPONDER_SALES_COVERAGE = 'TC_HERO_RESPONDER_SALES_COVERAGE',
  TC_HERO_HAIRCUT = 'TC_HERO_HAIRCUT',
  TC_HERO_PLATFORM = 'TC_HERO_PLATFORM',
  TC_HERO_ORDER_RECORD_KEEPING = 'TC_HERO_ORDER_RECORD_KEEPING',
  TC_HERO_ORGANISATIONS = 'TC_HERO_ORGANISATIONS',
  TC_HERO_TRADING_ENTITIES = 'TC_HERO_TRADING_ENTITIES',
  TC_HERO_CLEARING_HOUSES = 'TC_HERO_CLEARING_HOUSES',
  TC_HERO_USERS = 'TC_HERO_USERS',
  TC_HERO_COLLATERALS = 'TC_HERO_COLLATERALS',
  TC_HERO_FAT_FINGER_LIMITS = 'TC_HERO_FAT_FINGER_LIMITS',
  TC_HERO_TRADING_CONTROL_LIMITS = 'TC_HERO_TRADING_CONTROL_LIMITS',
  TC_HERO_HOLIDAYS = 'TC_HERO_HOLIDAYS',
  TC_HERO_INDICES = 'TC_HERO_INDICES',
  TC_HERO_PRODUCTS = 'TC_HERO_PRODUCTS',
  TC_HERO_SECTORS = 'TC_HERO_SECTORS',
  TC_HERO_SECTOR_MAPPING = 'TC_HERO_SECTOR_MAPPING',
  TC_HERO_DRAFT_SECTOR_MAPPING = 'TC_HERO_SECTOR_DRAFT_MAPPING',
  TC_HERO_FX_RATES = 'TC_HERO_FX_RATES',
  TC_HERO_SUMMARY = 'TC_HERO_SUMMARY',
  TC_HERO_STATUS = 'TC_HERO_STATUS',
  TC_HERO_CASH_AMOUNTS = 'TC_HERO_CASH_AMOUNTS',
  TC_HERO_ALL = 'TC_HERO_ALL',
  TC_HERO_NOTIONAL = 'TC_HERO_NOTIONAL',
  TC_DEALS = 'TC_DEALS',
  TC_NET_CASH = 'TC_NET_CASH',
  TC_TADJ_CASH = 'TC_TADJ_CASH',
  TC_HERO_ROLLS = 'TC_HERO_ROLLS',
  TC_HERO_INITIATED_AXE = 'TC_HERO_INITIATED_AXE',
  TC_HERO_INCOMING_AXE = 'TC_HERO_INCOMING_AXE',
  TC_HERO_ABSOLUTE = 'TC_HERO_ABSOLUTE',
  TC_HERO_NET = 'TC_HERO_NET',
  TC_HERO_ISSUER_ORGANISATIONS = 'TC_HERO_ISSUER_ORGANISATIONS',

  // Axe
  TC_AXE_NEW = 'TC_AXE_NEW',
  TC_AXE_SEND = 'TC_AXE_SEND',
  TC_AXE_CANCEL = 'TC_AXE_CANCEL',
  TC_AXE_CLONE = 'TC_AXE_CLONE',
  TC_AXE_STAGE = 'TC_AXE_STAGE',
  TC_AXE_STAGE_TITLE = 'TC_AXE_STAGE_TITLE',
  TC_AXE_STAGE_SELECT_FUND_COLLATERAL = 'TC_AXE_STAGE_SELECT_FUND_COLLATERAL',
  TC_AXE_STAGE_NO_TRADING_ENTITIES = 'TC_AXE_STAGE_NO_TRADING_ENTITIES',
  TC_AXE_ID = 'TC_AXE_ID',
  TC_EXTERNAL_AXE_ID = 'TC_EXTERNAL_AXE_ID',
  SC_AXE_ENTER_DETAILS = 'SC_AXE_ENTER_DETAILS',
  SC_AXE_UPLOAD_TRADING_ENTITY_NOT_FOUND = 'SC_AXE_UPLOAD_TRADING_ENTITY_NOT_FOUND',

  // Send RFQ Panel
  TC_ASSETS = 'TC_ASSETS',
  SC_ASSETS_OVERWRITE_WARNING_COUNT = 'SC_ASSETS_OVERWRITE_WARNING_COUNT',
  SC_ASSETS_OVERWRITE_WARNING_MESSAGE = 'SC_ASSETS_OVERWRITE_WARNING_MESSAGE',
  SC_ASSETS_OVERWRITE_READONLY_WARNING_MESSAGE = 'SC_ASSETS_OVERWRITE_READONLY_WARNING_MESSAGE',
  TC_DETAILS = 'TC_DETAILS',
  TC_PREPARE_RFQ = 'TC_PREPARE_RFQ',
  TC_SEND_ALL = 'TC_SEND_ALL',
  TC_PREPARE_BASKET = 'TC_PREPARE_BASKET',
  TC_DURATION_HOURS_MINS = 'TC_DURATION_HOURS_MINS',
  TC_CALLABLE_PERIOD = 'TC_CALLABLE_PERIOD',
  TC_SETTLEMENT = 'TC_SETTLEMENT',
  SC_BILATERAL_SETTLEMENT = 'SC_BILATERAL_SETTLEMENT',
  SC_DIRECT_CLEARING_SETTLEMENT = 'SC_DIRECT_CLEARING_SETTLEMENT',
  SC_SPONSORED_CLEARING_SETTLEMENT = 'SC_SPONSORED_CLEARING_SETTLEMENT',
  SC_TRIPARTY_SETTLEMENT = 'SC_TRIPARTY_SETTLEMENT',
  TC_CSD = 'TC_CSD',
  TC_CCP = 'TC_CCP',
  TC_SPONSOR = 'TC_SPONSOR',
  TC_SHOW_COMPETITION = 'TC_SHOW_COMPETITION',
  SC_DURATION_HOURS = 'SC_DURATION_HOURS',
  SC_DURATION_MINUTES = 'SC_DURATION_MINUTES',
  SC_DETAILS_SUMMARY = 'SC_DETAILS_SUMMARY',
  TC_COUNTERPARTIES = 'TC_COUNTERPARTIES',
  TC_POSITIONS = 'TC_POSITIONS',
  TC_GROUPS = 'TC_GROUPS',
  SC_SELECTED_COUNTERPARTIES_SIZE = 'SC_SELECTED_COUNTERPARTIES_SIZE',
  SC_COUNTERPARTIES_SUMMARY = 'SC_COUNTERPARTIES_SUMMARY',
  SC_SELECT_COUNTERPARTY = 'SC_SELECT_COUNTERPARTY',
  SC_REMOVE_COUNTERPARTIES = 'SC_REMOVE_COUNTERPARTIES',
  SC_SELECT_TRADING_ENTITY = 'SC_SELECT_TRADING_ENTITY',
  SC_REMOVE_TRADING_ENTITIES = 'SC_REMOVE_TRADING_ENTITIES',
  SC_POSITION_SUMMARY = 'SC_POSITION_SUMMARY',
  SC_SELECT_A_GROUPING = 'SC_SELECT_A_GROUPING',
  SC_GROUP_BY_ASSETS = 'SC_GROUP_BY_ASSETS',
  SC_GROUP_BY_COUNTERPARTIES = 'SC_GROUP_BY_COUNTERPARTIES',
  SC_MBS_COLLATERAL_ERROR_MESSAGE = 'SC_MBS_COLLATERAL_ERROR_MESSAGE',
  SC_MISSING_GFID_ERROR_MESSAGE = 'SC_MISSING_GFID_ERROR_MESSAGE',

  // Login / logout
  TC_LOGIN_TITLE = 'TC_LOGIN_TITLE',
  TC_LOGOUT_TITLE = 'TC_LOGOUT_TITLE',
  SC_LOGOUT_PROMPT = 'SC_LOGOUT_PROMPT',
  SC_CLOSECODE_SESSION_EXPIRED = 'SC_CLOSECODE_SESSION_EXPIRED',
  SC_CLOSECODE_USER_DISABLED = 'SC_CLOSECODE_USER_DISABLED',

  // User Preferences
  TC_USER_PREFERENCE = 'TC_USER_PREFERENCE',
  TC_USER_PREFERENCE_GENERAL = 'TC_USER_PREFERENCE_GENERAL',
  TC_USER_PREFERENCE_NOTIFICATIONS = 'TC_USER_PREFERENCE_NOTIFICATIONS',
  TC_USER_PREFERENCE_BROWSER_NOTIFICATIONS = 'TC_USER_PREFERENCE_BROWSER_NOTIFICATIONS',
  TC_USER_PREFERENCE_PREPARE = 'TC_USER_PREFERENCE_PREPARE',
  TC_USER_PREFERENCE_COUNTERPARTY_GROUPS = 'TC_USER_PREFERENCE_COUNTERPARTY_GROUPS',
  TC_USER_PREFERENCE_NEGOTIATION = 'TC_USER_PREFERENCE_NEGOTIATION',
  TC_USER_PREFERENCE_REGULATORY = 'TC_USER_PREFERENCE_REGULATORY',
  SC_DIRECTION_FORMAT = 'SC_DIRECTION_FORMAT',
  SC_DEFAULT_MARKET = 'SC_DEFAULT_MARKET',
  SC_DATE_FORMAT_DEFAULT = 'SC_DATE_FORMAT_DEFAULT',
  SC_PRIMARY_IDENTIFIER = 'SC_PRIMARY_IDENTIFIER',
  SC_AMOUNT_FORMAT_DEFAULT = 'SC_AMOUNT_FORMAT_DEFAULT',
  SC_INITIATED_GRID_VIEW = 'SC_INITIATED_GRID_VIEW',
  SC_BOOK_DEFAULT = 'SC_BOOK_DEFAULT',
  SC_STRATEGY_DEFAULT = 'SC_STRATEGY_DEFAULT',
  SC_CALLABLE_DEFAULT = 'SC_CALLABLE_DEFAULT',
  SC_CALLABLE_DAYS_DEFAULT = 'SC_CALLABLE_DAYS_DEFAULT',
  SC_SETTLEMENT_DEFAULT = 'SC_SETTLEMENT_DEFAULT',
  SC_SHOW_COMPETITION_DEFAULT = 'SC_SHOW_COMPETITION_DEFAULT',
  SC_SHOW_TOAST_NOTIFICATIONS = 'SC_SHOW_TOAST_NOTIFICATIONS',
  SC_SHOW_BROWSER_NOTIFICATIONS = 'SC_SHOW_BROWSER_NOTIFICATIONS',
  SC_PLAY_ALERT_ON_NOTIFICATION = 'SC_PLAY_ALERT_ON_NOTIFICATION',
  SC_RFQ_DURATION_DEFAULT = 'SC_RFQ_DURATION_DEFAULT',
  SC_RFQ_TYPE_DEFAULT = 'SC_RFQ_TYPE_DEFAULT',
  SC_GROUP_NAME = 'SC_GROUP_NAME',
  SC_MEMBERS = 'SC_MEMBERS',
  SC_NO_COUNTERPARTY_GROUPS = 'SC_NO_COUNTERPARTY_GROUPS',
  SC_OTW_DURATION_DEFAULT = 'SC_OTW_DURATION_DEFAULT',
  SC_DEFAULT_HAIRCUT_TYPE = 'SC_DEFAULT_HAIRCUT_TYPE',
  SC_BUY_SELL = 'SC_BUY_SELL',
  SC_RVP_RP = 'SC_RVP_RP',
  SC_BID_OFFER = 'SC_BID_OFFER',
  SC_BORROW_LEND = 'SC_BORROW_LEND',
  SC_EU_DATE = 'SC_EU_DATE',
  SC_US_DATE = 'SC_US_DATE',
  SC_DD_MMM_YYYY = 'SC_DD_MMM_YYYY',
  SC_ACTUAL = 'SC_ACTUAL',
  SC_THOUSANDS = 'SC_THOUSANDS',
  SC_MILLIONS = 'SC_MILLIONS',
  SC_DEFAULT_INVESTMENT_DECISION_MAKER = 'SC_DEFAULT_INVESTMENT_DECISION_MAKER',
  SC_DEFAULT_EXECUTION_DECISION_MAKER = 'SC_DEFAULT_EXECUTION_DECISION_MAKER',
  TC_EU = 'TC_EU',
  TC_US = 'TC_US',
  TC_CUSTOM = 'TC_CUSTOM',
  SC_HAIRCUT_SIGN = 'SC_HAIRCUT_SIGN',
  SC_BASKET_ALLOCATION_TIME = 'SC_BASKET_ALLOCATION_TIME',
  TC_COPY_PASTE_FORMAT = 'TC_COPY_PASTE_FORMAT',
  TC_TABULAR = 'TC_TABULAR',
  TC_PLAIN_TEXT = 'TC_PLAIN_TEXT',

  // Platform Admin
  TC_EU_MARKET = 'TC_EU_MARKET',
  TC_US_MARKET = 'TC_US_MARKET',
  TC_MARKET_TRADE_DATE_INFO = 'TC_MARKET_TRADE_DATE_INFO',
  TC_PROMPT_TITLE_SUSPEND_PLATFORM_EU = 'TC_PROMPT_TITLE_SUSPEND_PLATFORM_EU',
  SC_PROMPT_MSG_SUSPEND_PLATFORM_EU = 'SC_PROMPT_MSG_SUSPEND_PLATFORM_EU',
  TC_PROMPT_TITLE_ACTIVATE_PLATFORM_EU = 'TC_PROMPT_TITLE_ACTIVATE_PLATFORM_EU',
  SC_PROMPT_MSG_ACTIVATE_PLATFORM_EU = 'SC_PROMPT_MSG_ACTIVATE_PLATFORM_EU',
  TC_PROMPT_TITLE_END_DAY_EU = 'TC_PROMPT_TITLE_END_DAY_EU',
  SC_PROMPT_MSG_END_DAY_EU = 'SC_PROMPT_MSG_END_DAY_EU',
  TC_PROMPT_TITLE_START_DAY_EU = 'TC_PROMPT_TITLE_START_DAY_EU',
  TC_PROMPT_TITLE_START_DAY_EU_TOMORROW = 'TC_PROMPT_TITLE_START_DAY_EU_TOMORROW',
  SC_PROMPT_MSG_START_DAY_EU = 'SC_PROMPT_MSG_START_DAY_EU',
  SC_PROMPT_MSG_START_DAY_EU_TOMORROW = 'SC_PROMPT_MSG_START_DAY_EU_TOMORROW',
  TC_PROMPT_TITLE_SUSPEND_PLATFORM_US = 'TC_PROMPT_TITLE_SUSPEND_PLATFORM_US',
  SC_PROMPT_MSG_SUSPEND_PLATFORM_US = 'SC_PROMPT_MSG_SUSPEND_PLATFORM_US',
  TC_PROMPT_TITLE_ACTIVATE_PLATFORM_US = 'TC_PROMPT_TITLE_ACTIVATE_PLATFORM_US',
  SC_PROMPT_MSG_ACTIVATE_PLATFORM_US = 'SC_PROMPT_MSG_ACTIVATE_PLATFORM_US',
  TC_PROMPT_TITLE_END_DAY_US = 'TC_PROMPT_TITLE_END_DAY_US',
  SC_PROMPT_MSG_END_DAY_US = 'SC_PROMPT_MSG_END_DAY_US',
  TC_PROMPT_TITLE_START_DAY_US = 'TC_PROMPT_TITLE_START_DAY_US',
  SC_PROMPT_MSG_START_DAY_US = 'SC_PROMPT_MSG_START_DAY_US',
  TC_PROMPT_TITLE_PRE_START_DAY_US = 'TC_PROMPT_TITLE_PRE_START_DAY_US',
  SC_PROMPT_MSG_PRE_START_DAY_US = 'SC_PROMPT_MSG_PRE_START_DAY_US',
  SC_NARRATIVE_PLATFORM_WARNING = 'SC_NARRATIVE_PLATFORM_WARNING',
  TC_PLATFORM_FEATURE = 'TC_PLATFORM_FEATURE',
  TC_ALLOW_PARTIAL_FILLS = 'TC_ALLOW_PARTIAL_FILLS',
  TC_FIX_TRADE_QUERIES = 'TC_FIX_TRADE_QUERIES',
  TC_FIX_FIELD_DISABLED = 'TC_FIX_FIELD_DISABLED',
  TC_ENABLE_CURVE_COLLECTIONS = 'TC_ENABLE_CURVE_COLLECTIONS',
  TC_ENABLE_START_CONSIDERATION_OVERRIDE = 'TC_ENABLE_START_CONSIDERATION_OVERRIDE',
  TC_ENABLE_BATCHING = 'TC_ENABLE_BATCHING',
  TC_ENABLE_LIGHT_WEIGHT_PRICE = 'TC_ENABLE_LIGHT_WEIGHT_PRICE',
  TC_ENABLE_LIGHT_WEIGHT_PRICE_WEB = 'TC_ENABLE_LIGHT_WEIGHT_PRICE_WEB',
  TC_ENABLE_FIRDS = 'TC_ENABLE_FIRDS',
  TC_ENABLE_CORPORATES = 'TC_ENABLE_CORPORATES',
  TC_ENABLE_EVERGREENS = 'TC_ENABLE_EVERGREENS',
  TC_ENABLE_MBS = 'TC_ENABLE_MBS',
  TC_ENABLE_SPREADSHEET_UNKNOWN_COLLATERAL = 'TC_ENABLE_SPREADSHEET_UNKNOWN_COLLATERAL',
  TC_ENABLE_REAL_TIME_PURGE = 'TC_ENABLE_REAL_TIME_PURGE',
  TC_ENABLE_NEGOTIATION_INFLIGHT = 'TC_ENABLE_NEGOTIATION_INFLIGHT',
  TC_ENABLE_FIX_PERCENTAGE_FORMAT = 'TC_ENABLE_FIX_PERCENTAGE_FORMAT',
  TC_PLATFORM_FEATURE_TOGGLES = 'TC_PLATFORM_FEATURE_TOGGLES',
  TC_PROMPT_TITLE_TOGGLE_ALLOW_PARTIAL = 'TC_PROMPT_TITLE_TOGGLE_ALLOW_PARTIAL',
  SC_PROMPT_MSG_TOGGLE_ALLOW_PARTIAL = 'SC_PROMPT_MSG_TOGGLE_ALLOW_PARTIAL',
  TC_PROMPT_TITLE_TOGGLE_FIX_TRADE_QUERIES = 'TC_PROMPT_TITLE_TOGGLE_FIX_TRADE_QUERIES',
  TC_PROMPT_TITLE_TOGGLE_CLUSTER_BATCHING = 'TC_PROMPT_TITLE_TOGGLE_CLUSTER_BATCHING',
  TC_PROMPT_TITLE_TOGGLE_LIGHT_WEIGHT_PRICE = 'TC_PROMPT_TITLE_TOGGLE_LIGHT_WEIGHT_PRICE',
  TC_PROMPT_TITLE_TOGGLE_LIGHT_WEIGHT_PRICE_WEB = 'TC_PROMPT_TITLE_TOGGLE_LIGHT_WEIGHT_PRICE_WEB',
  TC_PROMPT_TITLE_TOGGLE_FIRDS = 'TC_PROMPT_TITLE_TOGGLE_FIRDS',
  TC_PROMPT_TITLE_TOGGLE_CORPORATES = 'TC_PROMPT_TITLE_TOGGLE_CORPORATES',
  TC_PROMPT_TITLE_TOGGLE_EVERGREENS = 'TC_PROMPT_TITLE_TOGGLE_EVERGREENS',
  TC_PROMPT_TITLE_TOGGLE_MBS = 'TC_PROMPT_TITLE_TOGGLE_MBS',
  TC_PROMPT_TITLE_TOGGLE_SPREADSHEET_UNKNOWN_COLLATERAL = 'TC_PROMPT_TITLE_TOGGLE_SPREADSHEET_UNKNOWN_COLLATERAL',
  TC_PROMPT_TITLE_TOGGLE_REAL_TIME_PURGE = 'TC_PROMPT_TITLE_TOGGLE_REAL_TIME_PURGE',
  TC_PROMPT_TITLE_TOGGLE_NEGOTIATION_INFLIGHT = 'TC_PROMPT_TITLE_TOGGLE_NEGOTIATION_INFLIGHT',
  SC_PROMPT_MSG_TOGGLE_FIX_TRADE_QUERIES = 'SC_PROMPT_MSG_TOGGLE_FIX_TRADE_QUERIES',
  SC_PROMPT_MSG_TOGGLE_CLUSTER_BATCHING = 'SC_PROMPT_MSG_TOGGLE_CLUSTER_BATCHING',
  SC_PROMPT_MSG_TOGGLE_LIGHT_WEIGHT_PRICE = 'SC_PROMPT_MSG_TOGGLE_LIGHT_WEIGHT_PRICE',
  SC_PROMPT_MSG_TOGGLE_LIGHT_WEIGHT_PRICE_WEB = 'SC_PROMPT_MSG_TOGGLE_LIGHT_WEIGHT_PRICE_WEB',
  SC_PROMPT_MSG_TOGGLE_FIRDS = 'SC_PROMPT_MSG_TOGGLE_FIRDS',
  SC_PROMPT_MSG_TOGGLE_CORPORATES = 'SC_PROMPT_MSG_TOGGLE_CORPORATES',
  SC_PROMPT_MSG_TOGGLE_EVERGREENS = 'SC_PROMPT_MSG_TOGGLE_EVERGREENS',
  SC_PROMPT_MSG_TOGGLE_MBS = 'SC_PROMPT_MSG_TOGGLE_MBS',
  SC_PROMPT_MSG_TOGGLE_SPREADSHEET_UNKNOWN_COLLATERAL = 'SC_PROMPT_MSG_TOGGLE_SPREADSHEET_UNKNOWN_COLLATERAL',
  SC_PROMPT_MSG_TOGGLE_REAL_TIME_PURGE = 'SC_PROMPT_MSG_TOGGLE_REAL_TIME_PURGE',
  SC_PROMPT_MSG_TOGGLE_NEGOTIATION_INFLIGHT = 'SC_PROMPT_MSG_TOGGLE_NEGOTIATION_INFLIGHT',
  TC_PROMPT_TITLE_TOGGLE_ENABLE_CURVE_COLLECTIONS = 'TC_PROMPT_TITLE_TOGGLE_ENABLE_CURVE_COLLECTIONS',
  SC_PROMPT_MSG_TOGGLE_ENABLE_CURVE_COLLECTIONS = 'SC_PROMPT_MSG_TOGGLE_ENABLE_CURVE_COLLECTIONS',
  TC_PROMPT_TITLE_TOGGLE_ENABLE_START_CONSIDERATION_OVERRIDE = 'TC_PROMPT_TITLE_TOGGLE_ENABLE_START_CONSIDERATION_OVERRIDE',
  SC_PROMPT_MSG_TOGGLE_ENABLE_START_CONSIDERATION_OVERRIDE = 'SC_PROMPT_MSG_TOGGLE_ENABLE_START_CONSIDERATION_OVERRIDE',
  SC_CLIENT_LOGSTREAM_GLOBAL_WARNING_MESSAGE = 'SC_CLIENT_LOGSTREAM_GLOBAL_WARNING_MESSAGE',
  TC_CLIENT_LOGSTREAM_SEVERITY_NONE = 'TC_CLIENT_LOGSTREAM_SEVERITY_NONE',
  TC_CLIENT_LOGSTREAM_SEVERITY_INFO = 'TC_CLIENT_LOGSTREAM_SEVERITY_INFO',
  TC_CLIENT_LOGSTREAM_SEVERITY_ERROR = 'TC_CLIENT_LOGSTREAM_SEVERITY_ERROR',
  TC_CLIENT_LOGSTREAM_SEVERITY_WARN = 'TC_CLIENT_LOGSTREAM_SEVERITY_WARN',
  TC_CLIENT_LOGSTREAM_LABEL_GLOBAL = 'TC_CLIENT_LOGSTREAM_LABEL_GLOBAL',
  TC_CLIENT_LOGSTREAM_LABEL_ENTITYUPDATES = 'TC_CLIENT_LOGSTREAM_LABEL_ENTITYUPDATES',

  // Refinitiv price request
  TC_PROMPT_TITLE_REFINITIV_PRICE_REQUEST = 'TC_PROMPT_TITLE_REFINITIV_PRICE_REQUEST',
  SC_PROMPT_MSG_REFINITIV_PRICE_REQUEST = 'SC_PROMPT_MSG_REFINITIV_PRICE_REQUEST',

  // Refinitiv collateral request
  TC_PROMPT_TITLE_REFINITIV_COLLATERAL_REQUEST = 'TC_PROMPT_TITLE_REFINITIV_COLLATERAL_REQUEST',
  SC_PROMPT_MSG_REFINITIV_COLLATERAL_REQUEST = 'SC_PROMPT_MSG_REFINITIV_COLLATERAL_REQUEST',

  // Refinitiv ric code request
  TC_PROMPT_TITLE_REFINITIV_RIC_CODE_REQUEST = 'TC_PROMPT_TITLE_REFINITIV_RIC_CODE_REQUEST',
  SC_PROMPT_MSG_REFINITIV_RIC_CODE_REQUEST = 'SC_PROMPT_MSG_REFINITIV_RIC_CODE_REQUEST',

  // Refinitiv ric code request
  TC_PROMPT_TITLE_REFINITIV_ISSUER_REFRESH_REQUEST = 'TC_PROMPT_TITLE_REFINITIV_ISSUER_REFRESH_REQUEST',
  SC_PROMPT_MSG_REFINITIV_ISSUER_REFRESH_REQUEST = 'SC_PROMPT_MSG_REFINITIV_ISSUER_REFRESH_REQUEST',

  // Refinitiv new fields request
  TC_PROMPT_TITLE_REFINITIV_NEW_FIELDS_REQUEST = 'TC_PROMPT_TITLE_REFINITIV_NEW_FIELDS_REQUEST',
  SC_PROMPT_MSG_REFINITIV_NEW_FIELDS_REQUEST = 'SC_PROMPT_MSG_REFINITIV_NEW_FIELDS_REQUEST',

  // Refinitiv corps refresh request
  TC_PROMPT_TITLE_REFINITIV_CORPS_REFRESH_REQUEST = 'TC_PROMPT_TITLE_REFINITIV_CORPS_REFRESH_REQUEST',
  SC_PROMPT_MSG_REFINITIV_CORPS_REFRESH_REQUEST = 'SC_PROMPT_MSG_REFINITIV_CORPS_REFRESH_REQUEST',

  // Order Record Keeping Admin
  TC_PROMPT_TITLE_TRIGGER_ORK_DUMP = 'TC_PROMPT_TITLE_TRIGGER_ORK_DUMP',
  SC_PROMPT_MSG_TRIGGER_ORK_DUMP = 'SC_PROMPT_MSG_TRIGGER_ORK_DUMP',

  // Transaction reporting admin
  TC_PROMPT_TITLE_TRIGGER_TRANSACTION_REPORTING_DUMP = 'TC_PROMPT_TITLE_TRIGGER_TRANSACTION_REPORTING_DUMP',
  SC_PROMPT_MSG_TRIGGER_TRANSACTION_REPORTING_DUMP = 'SC_PROMPT_MSG_TRIGGER_TRANSACTION_REPORTING_DUMP',

  // Transaction reporting admin
  TC_PROMPT_TITLE_TRIGGER_NEGOTIATION_EXPORT_DUMP = 'TC_PROMPT_TITLE_TRIGGER_NEGOTIATION_EXPORT_DUMP',
  SC_PROMPT_MSG_TRIGGER_NEGOTIATION_EXPORT_DUMP = 'SC_PROMPT_MSG_TRIGGER_NEGOTIATION_EXPORT_DUMP',

  // Refinitiv import report
  TC_PROMPT_TITLE_TRIGGER_REFINITIV_IMPORT_REPORT = 'TC_PROMPT_TITLE_TRIGGER_REFINITIV_IMPORT_REPORT',
  SC_PROMPT_MSG_TRIGGER_REFINITIV_IMPORT_REPORT = 'SC_PROMPT_MSG_TRIGGER_REFINITIV_IMPORT_REPORT',

  // Transaction deal admin
  TC_PROMPT_TITLE_TRIGGER_DEAL_EXPORT_DUMP = 'TC_PROMPT_TITLE_TRIGGER_DEAL_EXPORT_DUMP',
  SC_PROMPT_MSG_TRIGGER_DEAL_EXPORT_DUMP = 'SC_PROMPT_MSG_TRIGGER_DEAL_EXPORT_DUMP',

  // State of the world admin
  TC_PROMPT_TITLE_TRIGGER_SOTW = 'TC_PROMPT_TITLE_TRIGGER_SOTW',
  SC_PROMPT_MSG_TRIGGER_SOTW = 'SC_PROMPT_MSG_TRIGGER_SOTW',

  // End consideration calculation admin
  TC_PROMPT_TRIGGER_CALCULATE_END_CONSIDERATION = 'TC_PROMPT_TRIGGER_CALCULATE_END_CONSIDERATION',
  SC_PROMPT_MSG_TRIGGER_CALCULATE_END_CONSIDERATION = 'SC_PROMPT_MSG_TRIGGER_CALCULATE_END_CONSIDERATION',

  // End consideration calculation admin
  TC_PROMPT_TRIGGER_COMPLETE_DEALS = 'TC_PROMPT_TRIGGER_COMPLETE_DEALS',
  SC_PROMPT_MSG_TRIGGER_COMPLETE_DEALS = 'SC_PROMPT_MSG_TRIGGER_COMPLETE_DEALS',

  // Retry failed exports admin
  TC_PROMPT_TRIGGER_FAILED_EXPORTS_RETRY = 'TC_PROMPT_TRIGGER_FAILED_EXPORTS_RETRY',
  SC_PROMPT_MSG_TRIGGER_FAILED_EXPORTS_RETRY = 'SC_PROMPT_MSG_TRIGGER_FAILED_EXPORTS_RETRY',

  // Delete failed exports admin
  TC_PROMPT_TRIGGER_FAILED_EXPORTS_DELETE = 'TC_PROMPT_TRIGGER_FAILED_EXPORTS_DELETE',
  SC_PROMPT_MSG_TRIGGER_FAILED_EXPORTS_DELETE = 'SC_PROMPT_MSG_TRIGGER_FAILED_EXPORTS_DELETE',

  // Purge trade data
  TC_PROMPT_TRIGGER_PURGE_TRADE_DATA = 'TC_PROMPT_TRIGGER_PURGE_TRADE_DATA',
  SC_PROMPT_MSG_TRIGGER_PURGE_TRADE_DATA = 'SC_PROMPT_MSG_TRIGGER_PURGE_TRADE_DATA',

  // Reset test data
  TC_PROMPT_TRIGGER_RESET_TEST_DATA = 'TC_PROMPT_TRIGGER_RESET_TEST_DATA',
  SC_PROMPT_MSG_TRIGGER_RESET_TEST_DATA = 'SC_PROMPT_MSG_TRIGGER_RESET_TEST_DATA',

  // EOD Purge
  TC_PROMPT_TRIGGER_EOD_PURGE = 'TC_PROMPT_TRIGGER_EOD_PURGE',
  SC_PROMPT_MSG_TRIGGER_EOD_PURGE = 'SC_PROMPT_MSG_TRIGGER_EOD_PURGE',

  // Generate Firds Report
  TC_PROMPT_TRIGGER_FIRDS_REPORT = 'TC_PROMPT_TRIGGER_FIRDS_REPORT',
  SC_PROMPT_MSG_TRIGGER_FIRDS_REPORT = 'SC_PROMPT_MSG_TRIGGER_FIRDS_REPORT',

  // Trigger bond note update
  TC_PROMPT_TRIGGER_BOND_NOTE_UPDATE = 'TC_PROMPT_TRIGGER_BOND_NOTE_UPDATE',
  SC_PROMPT_MSG_TRIGGER_BOND_NOTE_UPDATE = 'SC_PROMPT_MSG_TRIGGER_BOND_NOTE_UPDATE',

  // Trigger increment ids
  TC_PROMPT_TRIGGER_INCREMENT_IDS = 'TC_PROMPT_TRIGGER_INCREMENT_IDS',
  SC_PROMPT_MSG_TRIGGER_INCREMENT_IDS = 'SC_PROMPT_MSG_TRIGGER_INCREMENT_IDS',

  // Generate Okta users Report
  TC_PROMPT_TRIGGER_OKTA_USERS_REPORT = 'TC_PROMPT_TRIGGER_OKTA_USERS_REPORT',
  SC_PROMPT_MSG_TRIGGER_OKTA_USERS_REPORT = 'SC_PROMPT_MSG_TRIGGER_OKTA_USERS_REPORT',

  // Generate Mortgage factors Report
  TC_PROMPT_TRIGGER_UPDATE_MORTGAGE_FACTORS = 'TC_PROMPT_TRIGGER_UPDATE_MORTGAGE_FACTORS',
  SC_PROMPT_MSG_TRIGGER_UPDATE_MORTGAGE_FACTORS = 'SC_PROMPT_MSG_TRIGGER_UPDATE_MORTGAGE_FACTORS',

  // Trigger collateral migration
  TC_PROMPT_TRIGGER_COLLATERAL_MIGRATION = 'TC_PROMPT_TRIGGER_COLLATERAL_MIGRATION',
  SC_PROMPT_MSG_TRIGGER_COLLATERAL_MIGRATION = 'SC_PROMPT_MSG_TRIGGER_COLLATERAL_MIGRATION',

  // Trigger collateral clear trade date
  TC_PROMPT_TRIGGER_COLLATERAL_CLEAR_TRADE_DATE = 'TC_PROMPT_TRIGGER_COLLATERAL_CLEAR_TRADE_DATE',
  SC_PROMPT_MSG_TRIGGER_COLLATERAL_CLEAR_TRADE_DATE = 'SC_PROMPT_MSG_TRIGGER_COLLATERAL_CLEAR_TRADE_DATE',

  // Trigger generate schedule report
  TC_PROMPT_TRIGGER_GENERATE_SCHEDULE_REPORT = 'TC_PROMPT_TRIGGER_GENERATE_SCHEDULE_REPORT',
  SC_PROMPT_MSG_TRIGGER_GENERATE_SCHEDULE_REPORT = 'SC_PROMPT_MSG_TRIGGER_GENERATE_SCHEDULE_REPORT',

  // Set current trade date
  TC_PROMPT_TRIGGER_SET_CURRENT_TRADE_DATE = 'TC_PROMPT_TRIGGER_SET_CURRENT_TRADE_DATE',
  SC_PROMPT_MSG_TRIGGER_SET_CURRENT_TRADE_DATE = 'SC_PROMPT_MSG_TRIGGER_SET_CURRENT_TRADE_DATE',

  // Set current trade date to previous business day
  TC_PROMPT_TRIGGER_SET_CURRENT_TRADE_DATE_TO_PREVIOUS_BUSINESS_DAY = 'TC_PROMPT_TRIGGER_SET_CURRENT_TRADE_DATE_TO_PREVIOUS_BUSINESS_DAY',
  SC_PROMPT_MSG_TRIGGER_SET_CURRENT_TRADE_DATE_TO_PREVIOUS_BUSINESS_DAY = 'SC_PROMPT_MSG_TRIGGER_SET_CURRENT_TRADE_DATE_TO_PREVIOUS_BUSINESS_DAY',

  // Skip all holiday dates
  TC_PROMPT_TRIGGER_SKIP_HOLIDAY_DATES = 'TC_PROMPT_TRIGGER_SKIP_HOLIDAY_DATES',
  SC_PROMPT_MSG_TRIGGER_SKIP_HOLIDAY_DATES = 'SC_PROMPT_MSG_TRIGGER_SKIP_HOLIDAY_DATES',

  // General Admin
  TC_PROMPT_TITLE_SUSPEND_TRADING = 'TC_PROMPT_TITLE_SUSPEND_TRADING',
  TC_PROMPT_TITLE_ACTIVATE_TRADING = 'TC_PROMPT_TITLE_ACTIVATE_TRADING',
  TC_PROMPT_TITLE_UPDATE_FROM_REFINITIV = 'TC_PROMPT_TITLE_UPDATE_FROM_REFINITIV',
  SC_TRADING = 'SC_TRADING',
  TC_PROMPT_TITLE_DELETE_ISSUER_ORGANISATION = 'TC_PROMPT_TITLE_DELETE_ISSUER_ORGANISATION',
  SC_DELETE_ISSUER_ORGANISATION_MESSAGE = 'SC_DELETE_ISSUER_ORGANISATION_MESSAGE',

  // Organisation Admin
  SC_PROMPT_MSG_SUSPEND_SINGLE_ORG = 'SC_PROMPT_MSG_SUSPEND_SINGLE_ORG',
  SC_PROMPT_MSG_SUSPEND_MULTI_ORG = 'SC_PROMPT_MSG_SUSPEND_MULTI_ORG',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_ORG = 'SC_PROMPT_MSG_ACTIVATE_SINGLE_ORG',
  SC_PROMPT_MSG_ACTIVATE_MULTI_ORG = 'SC_PROMPT_MSG_ACTIVATE_MULTI_ORG',
  TC_SHORT_CODE = 'TC_SHORT_CODE',

  // Trading Entity Admin
  SC_PROMPT_MSG_SUSPEND_SINGLE_TENT = 'SC_PROMPT_MSG_SUSPEND_SINGLE_TENT',
  SC_PROMPT_MSG_SUSPEND_MULTI_TENT = 'SC_PROMPT_MSG_SUSPEND_MULTI_TENT',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_TENT = 'SC_PROMPT_MSG_ACTIVATE_SINGLE_TENT',
  SC_PROMPT_MSG_ACTIVATE_MULTI_TENT = 'SC_PROMPT_MSG_ACTIVATE_MULTI_TENT',
  TC_PUBLISHED_NAME = 'TC_PUBLISHED_NAME',
  TC_SHORT_NAME = 'TC_SHORT_NAME',
  TC_SHORT_NAME_DEFAULT = 'TC_SHORT_NAME_DEFAULT',
  TC_FICC_NAME_DEFAULT = 'TC_FICC_NAME_DEFAULT',
  TC_TRADING_ENTITY_SHORT_NAME = 'TC_TRADING_ENTITY_SHORT_NAME',
  TC_GROUP = 'TC_GROUP',
  TC_CODE = 'TC_CODE',
  TC_PRODUCT_SECTORS = 'TC_PRODUCT_SECTORS',
  TC_SUPPORTED_COLLATERAL_BASKETS = 'TC_SUPPORTED_COLLATERAL_BASKETS',
  SC_NO_TRADING_ENTITY_CLEARINGS = 'SC_NO_TRADING_ENTITY_CLEARINGS',
  SC_NO_TRADING_ENTITY_RELATIONSHIPS = 'SC_NO_TRADING_ENTITY_RELATIONSHIPS',
  SC_NO_FAT_FINGER_LIMITS = 'SC_NO_FAT_FINGER_LIMITS',
  TC_SPONSORING_BANK = 'TC_SPONSORING_BANK',
  SC_NO_FAT_FINGER_SECTOR = 'SC_NO_FAT_FINGER_SECTOR',
  TC_US_SPONSORED_CLEARING = 'TC_US_SPONSORED_CLEARING',
  TC_US_SPONSORED_CLEARING_BY_DEFAULT = 'TC_US_SPONSORED_CLEARING_BY_DEFAULT',
  TC_INITIATOR_FICC_TO_INITIATOR_FIX = 'TC_INITIATOR_FICC_TO_INITIATOR_FIX',
  TC_INITIATOR_FICC_TO_RESPONDER_FIX = 'TC_INITIATOR_FICC_TO_RESPONDER_FIX',
  TC_RESPONDER_FICC_TO_INITIATOR_FIX = 'TC_RESPONDER_FICC_TO_INITIATOR_FIX',
  TC_RESPONDER_FICC_TO_RESPONDER_FIX = 'TC_RESPONDER_FICC_TO_RESPONDER_FIX',
  TC_INITIATOR_FICC_TO_INITIATOR_FIX_ABB = 'TC_INITIATOR_FICC_TO_INITIATOR_FIX_ABB',
  TC_INITIATOR_FICC_TO_RESPONDER_FIX_ABB = 'TC_INITIATOR_FICC_TO_RESPONDER_FIX_ABB',
  TC_RESPONDER_FICC_TO_INITIATOR_FIX_ABB = 'TC_RESPONDER_FICC_TO_INITIATOR_FIX_ABB',
  TC_RESPONDER_FICC_TO_RESPONDER_FIX_ABB = 'TC_RESPONDER_FICC_TO_RESPONDER_FIX_ABB',
  TC_MASTER_LEGAL_AGREEMENT_TYPE = 'TC_MASTER_LEGAL_AGREEMENT_TYPE',
  TC_MASTER_LEGAL_AGREEMENTS = 'TC_MASTER_LEGAL_AGREEMENTS',
  TC_DEFAULT_AGREEMENT = 'TC_DEFAULT_AGREEMENT',
  SC_SELECT_MASTER_LEGAL_AGREEMENT = 'SC_SELECT_MASTER_LEGAL_AGREEMENT',
  SC_REMOVE_MASTER_LEGAL_AGREEMENTS = 'SC_REMOVE_MASTER_LEGAL_AGREEMENTS',

  // Clearing House Admin
  TC_CLEARING_HOUSE_MIC = 'TC_CLEARING_HOUSE_MIC',
  TC_CLEARING_HOUSE_LEI = 'TC_CLEARING_HOUSE_LEI',
  TC_CLEARING_HOUSE_BIC = 'TC_CLEARING_HOUSE_BIC',
  TC_CLEARING_HOUSE_INTEGRATION_READY = 'TC_CLEARING_HOUSE_INTEGRATION_READY',

  // User Admin
  TC_PROMPT_TITLE_DISABLE_SINGLE_USER = 'TC_PROMPT_TITLE_DISABLE_SINGLE_USER',
  TC_PROMPT_TITLE_DISABLE_MULTI_USER = 'TC_PROMPT_TITLE_DISABLE_MULTI_USER',
  TC_PROMPT_TITLE_ENABLE_SINGLE_USER = 'TC_PROMPT_TITLE_ENABLE_SINGLE_USER',
  TC_PROMPT_TITLE_ENABLE_MULTI_USER = 'TC_PROMPT_TITLE_ENABLE_MULTI_USER',
  TC_PROMPT_TITLE_SIGN_OUT_SINGLE_USER = 'TC_PROMPT_TITLE_SIGN_OUT_SINGLE_USER',
  TC_PROMPT_TITLE_SIGN_OUT_MULTI_USER = 'TC_PROMPT_TITLE_SIGN_OUT_MULTI_USER',
  SC_PROMPT_MSG_SUSPEND_SINGLE_USER = 'SC_PROMPT_MSG_SUSPEND_SINGLE_USER',
  SC_PROMPT_MSG_SUSPEND_MULTI_USER = 'SC_PROMPT_MSG_SUSPEND_MULTI_USER',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_USER = 'SC_PROMPT_MSG_ACTIVATE_SINGLE_USER',
  SC_PROMPT_MSG_ACTIVATE_MULTI_USER = 'SC_PROMPT_MSG_ACTIVATE_MULTI_USER',
  SC_PROMPT_MSG_DISABLE_SINGLE_USER = 'SC_PROMPT_MSG_DISABLE_SINGLE_USER',
  SC_PROMPT_MSG_DISABLE_MULTI_USER = 'SC_PROMPT_MSG_DISABLE_MULTI_USER',
  SC_PROMPT_MSG_ENABLE_SINGLE_USER = 'SC_PROMPT_MSG_ENABLE_SINGLE_USER',
  SC_PROMPT_MSG_ENABLE_MULTI_USER = 'SC_PROMPT_MSG_ENABLE_MULTI_USER',
  SC_PROMPT_MSG_SIGN_OUT_SINGLE_USER = 'SC_PROMPT_MSG_SIGN_OUT_SINGLE_USER',
  SC_PROMPT_MSG_SIGN_OUT_MULTI_USER = 'SC_PROMPT_MSG_SIGN_OUT_MULTI_USER',
  TC_PRIMARY_MARKET_TYPE = 'TC_PRIMARY_MARKET_TYPE',
  TC_SECONDARY_MARKET_TYPE = 'TC_SECONDARY_MARKET_TYPE',

  // Collateral Admin
  SC_PROMPT_MSG_SUSPEND_SINGLE_COLLATERAL = 'SC_PROMPT_MSG_SUSPEND_SINGLE_COLLATERAL',
  SC_PROMPT_MSG_SUSPEND_MULTI_COLLATERAL = 'SC_PROMPT_MSG_SUSPEND_MULTI_COLLATERAL',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_COLLATERAL = 'SC_PROMPT_MSG_ACTIVATE_SINGLE_COLLATERAL',
  SC_PROMPT_MSG_ACTIVATE_MULTI_COLLATERAL = 'SC_PROMPT_MSG_ACTIVATE_MULTI_COLLATERAL',
  SC_PROMPT_MSG_UPDATE_FROM_REFINITIV = 'SC_PROMPT_MSG_UPDATE_FROM_REFINITIV',

  // Collateral Basket Admin
  SC_PROMPT_MSG_SUSPEND_SINGLE_COLLATERAL_BASKET = 'SC_PROMPT_MSG_SUSPEND_SINGLE_COLLATERAL_BASKET',
  SC_PROMPT_MSG_SUSPEND_MULTI_COLLATERAL_BASKET = 'SC_PROMPT_MSG_SUSPEND_MULTI_COLLATERAL_BASKET',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_COLLATERAL_BASKET = 'SC_PROMPT_MSG_ACTIVATE_SINGLE_COLLATERAL_BASKET',
  SC_PROMPT_MSG_ACTIVATE_MULTI_COLLATERAL_BASKET = 'SC_PROMPT_MSG_ACTIVATE_MULTI_COLLATERAL_BASKET',
  TC_PROMPT_TITLE_DELETE_COLLATERAL_BASKET = 'TC_PROMPT_TITLE_DELETE_COLLATERAL_BASKET',
  SC_PROMPT_MSG_DELETE_SINGLE_COLLATERAL_BASKET = 'SC_PROMPT_MSG_DELETE_SINGLE_COLLATERAL_BASKET',
  SC_PROMPT_MSG_DELETE_MULTI_COLLATERAL_BASKET = 'SC_PROMPT_MSG_DELETE_MULTI_COLLATERAL_BASKET',

  // Collateral Basket Type
  TC_BASKET_TYPE_DBV = 'TC_BASKET_TYPE_DBV',
  TC_BASKET_TYPE_EUROCLEAR = 'TC_BASKET_TYPE_EUROCLEAR',
  TC_BASKET_TYPE_GC_BESPOKE = 'TC_BASKET_TYPE_GC_BESPOKE',
  TC_BASKET_TYPE_BONY = 'TC_BASKET_TYPE_BONY',
  TC_BASKET_TYPE_GC_PLUS = 'TC_BASKET_TYPE_GC_PLUS',
  TC_BASKET_TYPE_CLEAR_STREAM = 'TC_BASKET_TYPE_CLEAR_STREAM',
  TC_BASKET_TYPE_CASH = 'TC_BASKET_TYPE_CASH',
  TC_BASKET_TYPE_COLLATERAL = 'TC_BASKET_TYPE_COLLATERAL',

  // Collateral Basket Trading Type
  TC_BASKET_TRADING_CASH = 'TC_BASKET_TRADING_CASH',
  TC_BASKET_TRADING_NOTIONAL = 'TC_BASKET_TRADING_NOTIONAL',
  TC_BASKET_TRADING_EITHER = 'TC_BASKET_TRADING_EITHER',

  // Fat Finger Limit Admin
  TC_PROMPT_TITLE_DELETE_FAT_FINGER_LIMIT = 'TC_PROMPT_TITLE_DELETE_FAT_FINGER_LIMIT',
  SC_PROMPT_MSG_DELETE_SINGLE_FAT_FINGER_LIMIT = 'SC_PROMPT_MSG_DELETE_SINGLE_FAT_FINGER_LIMIT',
  SC_PROMPT_MSG_DELETE_MULTI_FAT_FINGER_LIMIT = 'SC_PROMPT_MSG_DELETE_MULTI_FAT_FINGER_LIMIT',

  // Holiday Admin
  TC_PROMPT_TITLE_DELETE_HOLIDAY = 'TC_PROMPT_TITLE_DELETE_HOLIDAY',
  SC_PROMPT_MSG_DELETE_SINGLE_HOLIDAY = 'SC_PROMPT_MSG_DELETE_SINGLE_HOLIDAY',
  SC_PROMPT_MSG_DELETE_MULTI_HOLIDAY = 'SC_PROMPT_MSG_DELETE_MULTI_HOLIDAY',

  // Index Admin
  SC_PROMPT_MSG_SUSPEND_SINGLE_INDEX = 'SC_PROMPT_MSG_SUSPEND_SINGLE_INDEX',
  SC_PROMPT_MSG_SUSPEND_MULTI_INDEX = 'SC_PROMPT_MSG_SUSPEND_MULTI_INDEX',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_INDEX = 'SC_PROMPT_MSG_ACTIVATE_SINGLE_INDEX',
  SC_PROMPT_MSG_ACTIVATE_MULTI_INDEX = 'SC_PROMPT_MSG_ACTIVATE_MULTI_INDEX',
  TC_PROMPT_TITLE_DELETE_INDEX = 'TC_PROMPT_TITLE_DELETE_INDEX',
  SC_PROMPT_MSG_DELETE_SINGLE_INDEX = 'SC_PROMPT_MSG_DELETE_SINGLE_INDEX',
  SC_PROMPT_MSG_DELETE_MULTI_INDEX = 'SC_PROMPT_MSG_DELETE_MULTI_INDEX',

  // User Dialog
  TC_USER_DETAILS = 'TC_USER_DETAILS',
  TC_PRODUCTS = 'TC_PRODUCTS',
  TC_PERMISSIONS = 'TC_PERMISSIONS',
  TC_TRADING_ENTITIES = 'TC_TRADING_ENTITIES',
  TC_NOTES = 'TC_NOTES',
  TC_NEW_USER = 'TC_NEW_USER',
  TC_VIEW = 'TC_VIEW',
  TC_WRITE = 'TC_WRITE',
  TC_TRADE = 'TC_TRADE',
  TC_PASSPORT_UK = 'TC_PASSPORT_UK',
  TC_PASSPORT_EU = 'TC_PASSPORT_EU',
  TC_PASSPORT_NIUK = 'TC_PASSPORT_NIUK',
  TC_FEATURE_TOGGLE = 'TC_FEATURE_TOGGLE',
  SC_ORGANISATION = 'SC_ORGANISATION',
  SC_ORGANISATION_PLACEHOLDER = 'SC_ORGANISATION_PLACEHOLDER',
  SC_USER_STATUS = 'SC_USER_STATUS',
  SC_FIRST_NAME = 'SC_FIRST_NAME',
  SC_LAST_NAME = 'SC_LAST_NAME',
  SC_EMAIL = 'SC_EMAIL',
  SC_CONTACT_NUMBER = 'SC_CONTACT_NUMBER',
  SC_ALGO_NAME = 'SC_ALGO_NAME',
  SC_ACCOUNT_USER_NAME = 'SC_ACCOUNT_USER_NAME',
  SC_SHORT_ID = 'SC_SHORT_ID',
  SC_SELECT_ORGANISATION_MESSAGE = 'SC_SELECT_ORGANISATION_MESSAGE',
  SC_NO_PRODUCTS_AVAILABLE = 'SC_NO_PRODUCTS_AVAILABLE',
  SC_ALL_TRADING_ENTITIES = 'SC_ALL_TRADING_ENTITIES',
  SC_AUTOMATICALLY_ADD_NEW_ENTITIES = 'SC_AUTOMATICALLY_ADD_NEW_ENTITIES',
  TC_PROMPT_TITLE_DELETE_USER = 'TC_PROMPT_TITLE_DELETE_USER',
  SC_PROMPT_MSG_DELETE_USER = 'SC_PROMPT_MSG_DELETE_USER',
  SC_OKTA_STATUS = 'SC_OKTA_STATUS',
  SC_OKTA_LAST_LOGIN = 'SC_OKTA_LAST_LOGIN',

  // Haircut Dialog
  TC_ADD_NEW_HAIRCUT = 'TC_ADD_NEW_HAIRCUT',
  TC_EDIT_HAIRCUT = 'TC_EDIT_HAIRCUT',
  TC_HAIRCUT_ALL_PRODUCTS = 'TC_HAIRCUT_ALL_PRODUCTS',
  TC_HAIRCUT_ALL_PRODUCT_SECTORS = 'TC_HAIRCUT_ALL_PRODUCT_SECTORS',
  TC_HAIRCUT_ALL_COLLATERAL_BANDS = 'TC_HAIRCUT_ALL_COLLATERAL_BANDS',
  SC_HAIRCUT_SELL_FIRM_LABEL = 'SC_HAIRCUT_SELL_FIRM_LABEL',
  SC_HAIRCUT_SELL_ENTITY_LABEL = 'SC_HAIRCUT_SELL_ENTITY_LABEL',
  SC_HAIRCUT_MY_FIRM_LABEL = 'SC_HAIRCUT_MY_FIRM_LABEL',
  SC_HAIRCUT_MY_ENTITY_LABEL = 'SC_HAIRCUT_MY_ENTITY_LABEL',
  SC_HAIRCUT_COUNTERPARTY_FIRM_LABEL = 'SC_HAIRCUT_COUNTERPARTY_FIRM_LABEL',
  SC_HAIRCUT_COUNTERPARTY_LABEL = 'SC_HAIRCUT_COUNTERPARTY_LABEL',
  SC_HAIRCUT_PRODUCT_LABEL = 'SC_HAIRCUT_PRODUCT_LABEL',
  SC_HAIRCUT_PRODUCT_SECTOR_LABEL = 'SC_HAIRCUT_PRODUCT_SECTOR_LABEL',
  SC_HAIRCUT_HAIRCUT_COLLATERAL_BAND_LABEL = 'SC_HAIRCUT_HAIRCUT_COLLATERAL_BAND_LABEL',
  TC_COLLATERAL_HAIRCUT = 'TC_COLLATERAL_HAIRCUT',

  // Trade Split/Sales Cover Dialog
  TC_NEW_TRADE_SPLIT = 'TC_NEW_TRADE_SPLIT',
  TC_NEW_SALES_COVERAGE = 'TC_NEW_SALES_COVERAGE',
  SC_ORGANISATION_META_MY_FIRM = 'SC_ORGANISATION_META_MY_FIRM',
  SC_ORGANISATION_META_MY_ENTITY = 'SC_ORGANISATION_META_MY_ENTITY',
  SC_ORGANISATION_META_COUNTERPARTY_FIRM = 'SC_ORGANISATION_META_COUNTERPARTY_FIRM',
  SC_ORGANISATION_META_COUNTERPARTY = 'SC_ORGANISATION_META_COUNTERPARTY',
  SC_ORGANISATION_META_PRODUCT = 'SC_ORGANISATION_META_PRODUCT',
  SC_ORGANISATION_META_PRODUCT_SECTOR = 'SC_ORGANISATION_META_PRODUCT_SECTOR',
  SC_TRADE_SPLIT_SPLIT_TRADES = 'SC_TRADE_SPLIT_SPLIT_TRADES',
  SC_TRADE_SPLIT_SPLIT_AMOUNT = 'SC_TRADE_SPLIT_SPLIT_AMOUNT',
  TC_ORGANISATION_META_ALL = 'TC_ORGANISATION_META_ALL',
  SC_BOTH_COVER_USERS_NOT_SET = 'SC_BOTH_COVER_USERS_NOT_SET',
  SC_DUPLICATE_SALES_COVER = 'SC_DUPLICATE_ORGANISATION_META',

  // Organisation Dialog
  TC_NEW_ORGANISATION = 'TC_NEW_ORGANISATION',
  TC_ORGANISATION_DETAILS = 'TC_ORGANISATION_DETAILS',
  TC_ORGANISATION_PRIME_BROKERS = 'TC_ORGANISATION_PRIME_BROKERS',
  TC_ORGANISATION_TRADE_SPLITS = 'TC_ORGANISATION_TRADE_SPLITS',
  TC_ORGANISATION_SALES_COVERAGE = 'TC_ORGANISATION_SALES_COVERAGE',
  TC_GFID = 'TC_GFID',
  TC_SMART_GROUPING_TOGGLE = 'TC_SMART_GROUPING_TOGGLE',
  TC_PRE_ASSIGNMENT_TOGGLE = 'TC_PRE_ASSIGNMENT_TOGGLE',
  TC_GRID_VIEW_TOGGLE = 'TC_GRID_VIEW_TOGGLE',
  TC_CUMULATIVE_RECONCILIATION_TOGGLE = 'TC_CUMULATIVE_RECONCILIATION_TOGGLE',
  TC_LOCK_FIX_TOGGLE = 'TC_LOCK_FIX_TOGGLE',
  SC_SHORT_CODE = 'SC_SHORT_CODE',
  SC_ORGANISATION_LEI = 'SC_ORGANISATION_LEI',
  SC_LEGAL_NAME = 'SC_LEGAL_NAME',
  SC_ORGANISATION_TYPE = 'SC_ORGANISATION_TYPE',
  SC_SELECT_ORGANISATION_TYPE = 'SC_SELECT_ORGANISATION_TYPE',
  SC_REMOVE_ORGANISATION_TYPES = 'SC_REMOVE_ORGANISATION_TYPES',
  SC_ORGANISATION_TYPE_PLACEHOLDER = 'SC_ORGANISATION_TYPE_PLACEHOLDER',
  SC_EMAIL_ENABLED = 'SC_EMAIL_ENABLED',
  SC_SFTP_ENABLED = 'SC_SFTP_ENABLED',
  SC_ADD_PRIME_BROKER = 'SC_ADD_PRIME_BROKER',
  SC_REMOVE_PRIME_BROKERS = 'SC_REMOVE_PRIME_BROKERS',
  SC_NO_TRADE_SPLITS = 'SC_NO_TRADE_SPLITS',
  SC_NO_SALES_COVERAGE = 'SC_NO_SALES_COVERAGE',
  SC_START_CONSIDERATION_OVERRIDE_ENABLED = 'SC_START_CONSIDERATION_OVERRIDE_ENABLED',
  SC_FIX_PERCENTAGE_FORMAT_ENABLED = 'SC_FIX_PERCENTAGE_FORMAT_ENABLED',
  SC_STOCK_BORROW_LENDING = 'SC_STOCK_BORROW_LENDING',
  SC_ADD_GFID = 'SC_ADD_GFID',
  SC_REMOVE_GFIDS = 'SC_REMOVE_GFIDS',

  // Add Prime Broker Dialog
  TC_ADD_PRIME_BROKER = 'TC_ADD_PRIME_BROKER',
  SC_ADD_PRIME_BROKER_MY_ENTITY = 'SC_ADD_PRIME_BROKER_MY_ENTITY',
  SC_ADD_PRIME_BROKER_COUNTERPARTY = 'SC_ADD_PRIME_BROKER_COUNTERPARTY',
  SC_ADD_PRIME_BROKER_PRIME_BROKER = 'SC_ADD_PRIME_BROKER_PRIME_BROKER',

  // Prime Broker Defaults
  TC_PRIME_BROKER_DEFAULTS_COUNTERPARTY_NAME = 'TC_PRIME_BROKER_DEFAULTS_COUNTERPARTY_NAME',
  TC_PRIME_BROKER_DEFAULTS_PRIME_BROKER = 'TC_PRIME_BROKER_DEFAULTS_PRIME_BROKER',

  // Add Alias Dialog
  TC_ADD_NEW_ALIAS = 'TC_ADD_NEW_ALIAS',
  TC_EDIT_ALIAS = 'TC_EDIT_ALIAS',
  UC_ALIAS_TYPE_ALL = 'UC_ALIAS_TYPE_ALL',
  UC_ALIAS_TYPE_FICC = 'UC_ALIAS_TYPE_FICC',
  SC_ALIAS_MY_ENTITY = 'SC_ALIAS_MY_ENTITY',
  SC_ALIAS_COUNTERPARTY = 'SC_ALIAS_COUNTERPARTY',
  SC_ALIAS_TYPE = 'SC_ALIAS_TYPE',

  // TradingEntity Dialog
  TC_TRADING_ENTITY_ALIAS = 'TC_TRADING_ENTITY_ALIAS',
  TC_NO_ALIASES = 'TC_NO_ALIASES',
  TC_NEW_TRADING_ENTITY = 'TC_NEW_TRADING_ENTITY',
  TC_TRADING_ENTITY_DETAILS = 'TC_TRADING_ENTITY_DETAILS',
  TC_INITIATOR_RELATIONSHIPS = 'TC_INITIATOR_RELATIONSHIPS',
  TC_RESPONDER_RELATIONSHIPS = 'TC_RESPONDER_RELATIONSHIPS',
  TC_ALIASES = 'TC_ALIASES',
  SC_SHORT_NAME = 'SC_SHORT_NAME',
  SC_FICC_SHORT_NAME = 'SC_FICC_SHORT_NAME',
  SC_PUBLISHED_NAME = 'SC_PUBLISHED_NAME',
  SC_TRADING_ENTITY_LEI = 'SC_TRADING_ENTITY_LEI',
  SC_BIC = 'SC_BIC',
  TC_TRADING_ENTITY_TYPE = 'TC_TRADING_ENTITY_TYPE',
  TC_DIRECT_TRADING_ENTITY_CLEARING = 'TC_DIRECT_TRADING_ENTITY_CLEARING',
  TC_SPONSORED_TRADING_ENTITY_CLEARING = 'TC_SPONSORED_TRADING_ENTITY_CLEARING',
  TC_BUTTON_NEW_DIRECT_TRADING_ENTITY_CLEARING = 'TC_BUTTON_NEW_DIRECT_TRADING_ENTITY_CLEARING',
  TC_BUTTON_NEW_SPONSORED_TRADING_ENTITY_CLEARING = 'TC_BUTTON_NEW_SPONSORED_TRADING_ENTITY_CLEARING',
  TC_BUTTON_EDIT_DIRECT_TRADING_ENTITY_CLEARING = 'TC_BUTTON_EDIT_DIRECT_TRADING_ENTITY_CLEARING',
  TC_BUTTON_EDIT_SPONSORED_TRADING_ENTITY_CLEARING = 'TC_BUTTON_EDIT_SPONSORED_TRADING_ENTITY_CLEARING',
  TC_PROMPT_TITLE_ACTIVATE_SINGLE_TRADING_ENTITY_CLEARING = 'TC_PROMPT_TITLE_ACTIVATE_SINGLE_TRADING_ENTITY_CLEARING',
  SC_PROMPT_MSG_ACTIVATE_SINGLE_TRADING_ENTITY_CLEARING = 'SC_PROMPT_MSG_ACTIVATE_SINGLE_TRADING_ENTITY_CLEARING',
  TC_PROMPT_TITLE_SUSPEND_SINGLE_TRADING_ENTITY_CLEARING = 'TC_PROMPT_TITLE_SUSPEND_SINGLE_TRADING_ENTITY_CLEARING',
  SC_PROMPT_MSG_SUSPEND_SINGLE_TRADING_ENTITY_CLEARING = 'SC_PROMPT_MSG_SUSPEND_SINGLE_TRADING_ENTITY_CLEARING',
  TC_PROMPT_TITLE_DELETE_SINGLE_TRADING_ENTITY_CLEARING = 'TC_PROMPT_TITLE_DELETE_SINGLE_TRADING_ENTITY_CLEARING',
  SC_PROMPT_MSG_DELETE_SINGLE_TRADING_ENTITY_CLEARING = 'SC_PROMPT_MSG_DELETE_SINGLE_TRADING_ENTITY_CLEARING',
  TC_15A6_ELIGIBLE = 'TC_15A6_ELIGIBLE',
  TC_COMBINED_EU_US_EOD_FILE = 'TC_COMBINED_EU_US_EOD_FILE',
  TC_CENTRAL_BANK = 'TC_CENTRAL_BANK',
  TC_NEGOTIATION_HISTORY_FILE = 'TC_NEGOTIATION_HISTORY_FILE',
  TC_ROUND_PRICE_TO_EIGHT = 'TC_ROUND_PRICE_TO_EIGHT',
  TC_TRADING_ENTITY_RELATIONSHIPS = 'TC_TRADING_ENTITY_RELATIONSHIPS',
  TC_NEW_TRADING_ENTITY_RELATIONSHIP = 'TC_NEW_TRADING_ENTITY_RELATIONSHIP',
  TC_EDIT_TRADING_ENTITY_RELATIONSHIP = 'TC_EDIT_TRADING_ENTITY_RELATIONSHIP',
  TC_PROMPT_TITLE_DELETE_SINGLE_TRADING_RELATIONSHIP = 'TC_PROMPT_TITLE_DELETE_SINGLE_TRADING_RELATIONSHIP',
  SC_PROMPT_MSG_DELETE_SINGLE_TRADING_RELATIONSHIP = 'SC_PROMPT_MSG_DELETE_SINGLE_TRADING_RELATIONSHIP',
  TC_BUTTON_VIEW_SPONSORED_TRADING_ENTITY_CLEARING = 'TC_BUTTON_VIEW_SPONSORED_TRADING_ENTITY_CLEARING',
  TC_BUTTON_VIEW_DIRECT_TRADING_ENTITY_CLEARING = 'TC_BUTTON_VIEW_DIRECT_TRADING_ENTITY_CLEARING',
  TC_EU_GFID = 'TC_EU_GFID',
  TC_US_GFID = 'TC_US_GFID',
  TC_OPERATING_COUNTRY = 'TC_OPERATING_COUNTRY',

  // TradingEntityAlias Dialog
  TC_PROMPT_TITLE_SET_TRADING_ENTITY_ALIAS = 'TC_PROMPT_TITLE_SET_TRADING_ENTITY_ALIAS',
  SC_PROMPT_MSG_SET_TRADING_ENTITY_ALIAS_FOR_ALL = 'SC_PROMPT_MSG_SET_TRADING_ENTITY_ALIAS_FOR_ALL',
  SC_PROMPT_MSG_REMOVE_TRADING_ENTITY_ALIAS_FOR_ALL = 'SC_PROMPT_MSG_REMOVE_TRADING_ENTITY_ALIAS_FOR_ALL',

  TC_PROMPT_TITLE_SET_TRADING_ENTITY_PRIME_BROKER = 'TC_PROMPT_TITLE_SET_TRADING_ENTITY_PRIME_BROKER',
  SC_PROMPT_MSG_SET_TRADING_ENTITY_PRIME_BROKER_FOR_ALL = 'SC_PROMPT_MSG_SET_TRADING_ENTITY_PRIME_BROKER_FOR_ALL',
  SC_PROMPT_MSG_REMOVE_TRADING_ENTITY_PRIME_BROKER_FOR_ALL = 'SC_PROMPT_MSG_REMOVE_TRADING_ENTITY_PRIME_BROKER_FOR_ALL',

  // Collateral Dialog
  TC_ADD_NEW_COLLATERAL = 'TC_ADD_NEW_COLLATERAL',
  SC_COLLATERAL_SHORT_ID = 'SC_COLLATERAL_SHORT_ID',
  SC_PLATFORM = 'SC_PLATFORM',
  SC_ISIN = 'SC_ISIN',
  SC_FISN = 'SC_FISN',
  SC_CFI = 'SC_CFI',
  SC_CUSIP = 'SC_CUSIP',
  SC_CURRENCY = 'SC_CURRENCY',
  SC_COUNTRY = 'SC_COUNTRY',
  SC_SECTOR = 'SC_SECTOR',
  SC_PRODUCT = 'SC_PRODUCT',
  SC_ISSUER = 'SC_ISSUER',
  TC_ISSUER_LEI = 'TC_ISSUER_LEI',
  TC_NOT_ISSUER_LEI = 'TC_NOT_ISSUER_LEI',
  TC_SECTOR_MAPPING_BASE_INDEX = 'TC_SECTOR_MAPPING_BASE_INDEX',
  SC_COLLATERAL_STATUS = 'SC_COLLATERAL_STATUS',
  SC_TRADING_TYPE = 'SC_TRADING_TYPE',
  SC_FIRST_SETTLEMENT_DATE = 'SC_FIRST_SETTLEMENT_DATE',
  SC_CLEAN_PRICE = 'SC_CLEAN_PRICE',
  SC_BASIS_CONVENTION = 'SC_BASIS_CONVENTION',
  TC_MINIMUM_TICKET_SIZE = 'TC_MINIMUM_TICKET_SIZE',
  TC_TICKET_SIZE_INCREMENT = 'TC_TICKET_SIZE_INCREMENT',
  SC_TICKET_SIZE = 'SC_TICKET_SIZE',
  SC_MAX_TICKET_SIZE = 'SC_MAX_TICKET_SIZE',
  SC_COLLATERAL_TYPE = 'SC_COLLATERAL_TYPE',
  SC_COLLATERAL_INDEX = 'SC_COLLATERAL_INDEX',
  SC_COLLATERAL_INDEX_LAG = 'SC_COLLATERAL_INDEX_LAG',
  SC_COLLATERAL_BASE_INDEX_VALUE = 'SC_COLLATERAL_BASE_INDEX_VALUE',
  SC_COUPON_TYPE = 'SC_COUPON_TYPE',
  SC_COUPON = 'SC_COUPON',
  SC_ACCRUAL_DATE = 'SC_ACCRUAL_DATE',
  SC_FIRST_COUPON_DATE = 'SC_FIRST_COUPON_DATE',
  SC_FIRST_TRADE_DATE = 'SC_FIRST_TRADE_DATE',
  SC_MATURITY_DATE = 'SC_MATURITY_DATE',
  SC_FREQUENCY = 'SC_FREQUENCY',
  SC_TOTAL_ISSUED_NOMINAL_AMOUNT = 'SC_TOTAL_ISSUED_NOMINAL_AMOUNT',
  TC_RFA = 'TC_RFA',
  SC_PROSPECTUS = 'SC_PROSPECTUS',
  SC_CORP_COLLATERAL_SUSPENDED_MESSAGE = 'SC_CORP_COLLATERAL_SUSPENDED_MESSAGE',
  SC_MORT_COLLATERAL_SUSPENDED_MESSAGE = 'SC_MORT_COLLATERAL_SUSPENDED_MESSAGE',
  SC_INDEX_SPREAD = 'SC_INDEX_SPREAD',
  SC_SENIORITY = 'SC_SENIORITY',
  SC_RIC = 'SC_RIC',
  SC_SYSTEM = 'SC_SYSTEM',
  TC_MAIN_DETAILS = 'TC_MAIN_DETAILS',
  TC_ADDITIONAL_DETAILS = 'TC_ADDITIONAL_DETAILS',
  TC_BOND_TYPE = 'TC_BOND_TYPE',
  TC_CALLABLE_FLAG = 'TC_CALLABLE_FLAG',
  TC_COUNTRY_OF_INCORPORATION = 'TC_COUNTRY_OF_INCORPORATION',
  TC_NOT_COUNTRY_OF_INCORPORATION = 'TC_NOT_COUNTRY_OF_INCORPORATION',
  TC_COUNTRY_OF_ISSUANCE = 'TC_COUNTRY_OF_ISSUANCE',
  TC_NOT_COUNTRY_OF_ISSUANCE = 'TC_NOT_COUNTRY_OF_ISSUANCE',
  TC_COUNTRY_OF_RISK_ALL = 'TC_COUNTRY_OF_RISK_ALL',
  TC_COUNTRY_OF_RISK_PRIMARY = 'TC_COUNTRY_OF_RISK_PRIMARY',
  TC_COUNTRY_OF_RISK_ULTIMATE_PARENT_ALL = 'TC_COUNTRY_OF_RISK_ULTIMATE_PARENT_ALL',
  TC_COUNTRY_OF_RISK_ULTIMATE_PARENT_PRIMARY = 'TC_COUNTRY_OF_RISK_ULTIMATE_PARENT_PRIMARY',
  TC_COUPON_RATE_EFFECTIVE_DATE = 'TC_COUPON_RATE_EFFECTIVE_DATE',
  TC_DOMICILE = 'TC_DOMICILE',
  TC_ECB_INDICATOR = 'TC_ECB_INDICATOR',
  TC_EX_DIVIDEND_CALENDAR = 'TC_EX_DIVIDEND_CALENDAR',
  TC_EX_DIVIDEND_RULE = 'TC_EX_DIVIDEND_RULE',
  TC_EX_DIVIDEND_VALUE = 'TC_EX_DIVIDEND_VALUE',
  TC_FACTOR = 'TC_FACTOR',
  TC_FACTOR_DATE = 'TC_FACTOR_DATE',
  TC_MBS_PRICE_DATE = 'TC_MBS_PRICE_DATE',
  TC_FITCH_RATING = 'TC_FITCH_RATING',
  TC_FLOAT_INDEX_TYPE = 'TC_FLOAT_INDEX_TYPE',
  TC_FLOAT_MULTIPLIER = 'TC_FLOAT_MULTIPLIER',
  TC_FLOAT_OFFSET = 'TC_FLOAT_OFFSET',
  TC_FLOATER_FLAG = 'TC_FLOATER_FLAG',
  TC_FLOATING_RATE_FIXING_DATE = 'TC_FLOATING_RATE_FIXING_DATE',
  TC_INDUSTRY_SECTOR_CODE = 'TC_INDUSTRY_SECTOR_CODE',
  TC_INDUSTRY_SUB_SECTOR_CODE = 'TC_INDUSTRY_SUB_SECTOR_CODE',
  TC_IS_SECURED_FLAG = 'TC_IS_SECURED_FLAG',
  TC_ISSUER_ORG_ID = 'TC_ISSUER_ORG_ID',
  TC_LOOK_BACK = 'TC_LOOK_BACK',
  TC_MIFID_INDEX_IDENTIFIER = 'TC_MIFID_INDEX_IDENTIFIER',
  TC_MIFID_INDEX_NAME = 'TC_MIFID_INDEX_NAME',
  TC_MIFID_INDEX_TERM = 'TC_MIFID_INDEX_TERM',
  TC_MOODYS_RATING = 'TC_MOODYS_RATING',
  TC_MULTI_STEP_FLOAT_FLAG = 'TC_MULTI_STEP_FLOAT_FLAG',
  TC_OFFERING_TYPE = 'TC_OFFERING_TYPE',
  TC_PERPETUAL_SECURITY_FLAG = 'TC_PERPETUAL_SECURITY_FLAG',
  TC_PRIVATE_PLACEMENT_FLAG = 'TC_PRIVATE_PLACEMENT_FLAG',
  TC_REFINITIV_CLASSIFICATION_SCHEME = 'TC_REFINITIV_CLASSIFICATION_SCHEME',
  TC_REGULATION_S_INDICATOR = 'TC_REGULATION_S_INDICATOR',
  TC_RULE_144A_INDICATOR = 'TC_RULE_144A_INDICATOR',
  TC_S_AND_P_RATING = 'TC_S_AND_P_RATING',
  TC_SETTLEMENT_DATE_CONVENTION = 'TC_SETTLEMENT_DATE_CONVENTION',
  TC_SINKABLE_FLAG = 'TC_SINKABLE_FLAG',
  TC_TOTAL_AMOUNT_OUTSTANDING = 'TC_TOTAL_AMOUNT_OUTSTANDING',
  TC_COLLATERAL_SAVE_CONFIRMATION = 'TC_COLLATERAL_SAVE_CONFIRMATION',
  TC_ASSET_TYPE = 'TC_ASSET_TYPE',
  TC_BTQ_ASSET_TYPE = 'TC_BTQ_ASSET_TYPE',
  TC_REFINITIV_ASSET_TYPE = 'TC_REFINITIV_ASSET_TYPE',
  TC_ASSET_SUB_TYPE = 'TC_ASSET_SUB_TYPE',
  TC_ASSET_DEBT_TYPE = 'TC_ASSET_DEBT_TYPE',
  TC_MORT_AGENCY_ASSET_TYPE = 'TC_MORT_AGENCY_ASSET_TYPE',
  TC_MORT_NON_AGENCY_ASSET_TYPE = 'TC_MORT_NON_AGENCY_ASSET_TYPE',
  TC_ASSET_STATUS = 'TC_ASSET_STATUS',
  TC_ASSET_STATUS_EFFECTIVE_DATE = 'TC_ASSET_STATUS_EFFECTIVE_DATE',
  TC_RECOGNISED_EXCHANGE = 'TC_RECOGNISED_EXCHANGE',
  TC_IN_ESMA_FIRDS = 'TC_IN_ESMA_FIRDS',
  TC_EEA_VENUE_ELIGIBLE = 'TC_EEA_VENUE_ELIGIBLE',
  TC_UK_VENUE_ELIGIBLE = 'TC_UK_VENUE_ELIGIBLE',
  TC_COMPLIANCE_OVERRIDE = 'TC_COMPLIANCE_OVERRIDE',
  TC_MIC_REPORT_DATE = 'TC_MIC_REPORT_DATE',
  SC_COLLATERAL_REPORTING_WARNING_MESSAGE = 'SC_COLLATERAL_REPORTING_WARNING_MESSAGE',
  TC_SERIES = 'TC_SERIES',
  TC_ISSUE = 'TC_ISSUE',
  TC_ROE = 'TC_ROE',
  TC_ROS = 'TC_ROS',
  TC_ISSUER_ULTIMATE_PARENT_SUSPENDED_MESSAGE = 'TC_ISSUER_ULTIMATE_PARENT_SUSPENDED_MESSAGE',
  TC_NEW_OR_OLD_COLLATERAL_PRICE = 'TC_NEW_OR_OLD_COLLATERAL_PRICE',
  // Collateral Basket Dialog
  TC_ADD_NEW_COLLATERAL_BASKET = 'TC_ADD_NEW_COLLATERAL_BASKET',
  TC_BASKET_OWNER = 'TC_BASKET_OWNER',
  TC_TRADING_TYPE = 'TC_TRADING_TYPE',
  TC_CALCULATE_ACCRUED_INTEREST_QUESTION = 'TC_CALCULATE_ACCRUED_INTEREST_QUESTION',
  TC_IS_DYNAMIC_BASKET_QUESTION = 'TC_IS_DYNAMIC_BASKET_QUESTION',
  TC_SELECTED_PRODUCTS = 'TC_SELECTED_PRODUCTS',
  TC_MATCHING_RESULTS = 'TC_MATCHING_RESULTS',
  TC_SELECTED_ORGANISATIONS = 'TC_SELECTED_ORGANISATIONS',
  TC_SECONDARY_COLLATERAL = 'TC_SECONDARY_COLLATERAL',
  TC_SELECTED_SECONDARY_COLLATERALS = 'TC_SELECTED_SECONDARY_COLLATERALS',
  SC_BASKET_NAME_PLACEHOLDER = 'SC_BASKET_NAME_PLACEHOLDER',
  SC_BASKET_DESCRIPTION_PLACEHOLDER = 'SC_BASKET_DESCRIPTION_PLACEHOLDER',
  SC_CME_BASKET_REFERENCE_PLACEHOLDER = 'SC_CME_BASKET_REFERENCE_PLACEHOLDER',
  SC_PLEASE_SELECT = 'SC_PLEASE_SELECT',
  SC_NO_COLLATERAL_EUROCLEAR = 'SC_NO_COLLATERAL_EUROCLEAR',
  SC_NO_COLLATERAL_DBV = 'SC_NO_COLLATERAL_DBV',
  SC_NO_COLLATERAL_BONY = 'SC_NO_COLLATERAL_BONY',
  SC_NO_COLLATERAL_GC_PLUS = 'SC_NO_COLLATERAL_GC_PLUS',
  SC_NO_COLLATERAL_COLLATERAL = 'SC_NO_COLLATERAL_COLLATERAL',
  SC_NO_COLLATERAL_CASH = 'SC_NO_COLLATERAL_CASH',
  SC_NO_COLLATERAL_CLEAR_STREAM = 'SC_NO_COLLATERAL_CLEAR_STREAM',
  SC_NO_PERMISSIONS_COLLATERAL = 'SC_NO_PERMISSIONS_COLLATERAL',
  SC_NO_PERMISSIONS_CASH = 'SC_NO_PERMISSIONS_CASH',

  // Clearing House Dialog
  SC_NO_COLLATERALS_AVAILABLE = 'SC_NO_COLLATERALS_AVAILABLE',
  SC_NO_BASKETS_AVAILABLE = 'SC_NO_BASKETS_AVAILABLE',
  TC_DIRECT_CLEARING = 'TC_DIRECT_CLEARING',
  TC_SPONSORED_CLEARING = 'TC_SPONSORED_CLEARING',
  UC_ON = 'UC_ON',
  UC_OFF = 'UC_OFF',
  TC_COLLATERAL_SHORT_ID = 'TC_COLLATERAL_SHORT_ID',
  TC_CLEARING = 'TC_CLEARING',
  TC_CLEARING_HOUSE_DETAILS = 'TC_CLEARING_HOUSE_DETAILS',
  TC_EDIT_CLEARING_HOUSE_DETAILS = 'TC_EDIT_CLEARING_HOUSE_DETAILS',
  TC_VIEW_CLEARING_HOUSE_DETAILS = 'TC_VIEW_CLEARING_HOUSE_DETAILS',

  // Clearing Info
  TC_CLEARING_INFO = 'TC_CLEARING_INFO',
  TC_CLEARING_MESSAGE_SUMMARY = 'TC_CLEARING_MESSAGE_SUMMARY',
  TC_CLEARING_MESSAGE_ID = 'TC_CLEARING_MESSAGE_ID',
  TC_CLEARING_MESSAGE_TYPE = 'TC_CLEARING_MESSAGE_TYPE',
  TC_CLEARING_REQUEST_DETAILS = 'TC_CLEARING_REQUEST_DETAILS',
  TC_CLEARING_REQUEST_SENT_AT = 'TC_CLEARING_REQUEST_SENT_AT',
  TC_CLEARING_REQUEST_CONTENT = 'TC_CLEARING_REQUEST_CONTENT',
  TC_CLEARING_PENDING_RESPONSE_DETAILS = 'TC_CLEARING_PENDING_RESPONSE_DETAILS',
  TC_CLEARING_PENDING_RESPONSE_RECEIVED_AT = 'TC_CLEARING_PENDING_RESPONSE_RECEIVED_AT',
  TC_CLEARING_PENDING_RESPONSE_CONTENT = 'TC_CLEARING_PENDING_RESPONSE_CONTENT',
  TC_CLEARING_RESPONSE_DETAILS = 'TC_CLEARING_RESPONSE_DETAILS',
  TC_CLEARING_RESPONSE_RECEIVED_AT = 'TC_CLEARING_RESPONSE_RECEIVED_AT',
  TC_CLEARING_RESPONSE_CONTENT = 'TC_CLEARING_RESPONSE_CONTENT',
  TC_CLEARING_ERROR_CONTENT = 'TC_CLEARING_ERROR_CONTENT',
  TC_CLEARING_ERROR_AT = 'TC_CLEARING_ERROR_AT',
  TC_CLEARING_ERROR_RESOLUTION_CONTENT = 'TC_CLEARING_ERROR_RESOLUTION_CONTENT',
  TC_CLEARING_ERROR_RESOLUTION_AT = 'TC_CLEARING_ERROR_RESOLUTION_AT',
  TC_CLEARING_MANUALLY_ACCEPTED = 'TC_CLEARING_MANUALLY_ACCEPTED',
  TC_CLEARING_MANUALLY_REJECTED = 'TC_CLEARING_MANUALLY_REJECTED',
  TC_VIEW_INTERACTION_DETAILS = 'TC_VIEW_INTERACTION_DETAILS',
  SC_NO_CLEARING_INTERACTIONS_AVAILABLE = 'SC_NO_CLEARING_INTERACTIONS_AVAILABLE',

  // Fat Finger Limit Dialog
  TC_NEW_FAT_FINGER_LIMIT = 'TC_NEW_FAT_FINGER_LIMIT',
  TC_EDIT_FAT_FINGER_LIMIT = 'TC_EDIT_FAT_FINGER_LIMIT',
  SC_FIXED_RATE_PRICE = 'SC_FIXED_RATE_PRICE',
  SC_FIXED_RATE_WARN_LEVEL = 'SC_FIXED_RATE_WARN_LEVEL',
  SC_FIXED_RATE_RESTRICTION = 'SC_FIXED_RATE_RESTRICTION',
  SC_FLOAT_RATE_SPREAD = 'SC_FLOAT_RATE_SPREAD',
  SC_FLOAT_RATE_WARN_LEVEL = 'SC_FLOAT_RATE_WARN_LEVEL',
  SC_FLOAT_RATE_RESTRICTION = 'SC_FLOAT_RATE_RESTRICTION',
  SC_NOTIONAL_AMOUNT_WARN = 'SC_NOTIONAL_AMOUNT_WARN',
  SC_NOTIONAL_AMOUNT_RESTRICTION = 'SC_NOTIONAL_AMOUNT_RESTRICTION',
  SC_CASH_AMOUNT_WARN = 'SC_CASH_AMOUNT_WARN',
  SC_CASH_AMOUNT_RESTRICTION = 'SC_CASH_AMOUNT_RESTRICTION',

  // Holiday Dialog
  TC_NEW_HOLIDAY = 'TC_NEW_HOLIDAY',
  SC_HOLIDAY_CURRENCY = 'SC_HOLIDAY_CURRENCY',
  SC_HOLIDAY = 'SC_HOLIDAY',

  // Index Dialog
  TC_NEW_INDEX = 'TC_NEW_INDEX',
  TC_VIEW_INDEX = 'TC_VIEW_INDEX',
  TC_BLOOMBERG_INDEX_CODE = 'TC_BLOOMBERG_INDEX_CODE',
  TC_REFINITIV_BASE_INDEX = 'TC_REFINITIV_BASE_INDEX',
  TC_HISTORICAL_PRICES = 'TC_HISTORICAL_PRICES',
  TC_INDEX_PRICE = 'TC_INDEX_PRICE',
  SC_NO_PRICES_ERROR = 'SC_NO_PRICES_ERROR',
  SC_ENTER_PRICES = 'SC_ENTER_PRICES',
  SC_BLOOMBERG_INDEX_CODE_PLACEHOLDER = 'SC_BLOOMBERG_INDEX_CODE_PLACEHOLDER',
  SC_BLOOMBERG_INDEX_DESCRIPTION_PLACEHOLDER = 'SC_BLOOMBERG_INDEX_DESCRIPTION_PLACEHOLDER',
  SC_VALID_FOR_PLACEHOLDER = 'SC_VALID_FOR_PLACEHOLDER',
  SC_PRICE_PLACEHOLDER = 'SC_PRICE_PLACEHOLDER',
  TC_LAG = 'SC_LAG',

  // Control Limit Dialog
  TC_NEW_TRADE_CONTROL_LIMIT = 'TC_NEW_TRADE_CONTROL_LIMIT',
  TC_EDIT_TRADE_CONTROL_LIMIT = 'TC_EDIT_TRADE_CONTROL_LIMIT',
  TC_PROMPT_DELETE_TRADE_CONTROL_LIMIT = 'TC_PROMPT_DELETE_TRADE_CONTROL_LIMIT',
  SC_PROMPT_MSG_DELETE_SINGLE_TRADE_CONTROL_LIMIT = 'SC_PROMPT_MSG_DELETE_SINGLE_TRADE_CONTROL_LIMIT',
  SC_PROMPT_MSG_DELETE_MULTI_TRADE_CONTROL_LIMIT = 'SC_PROMPT_MSG_DELETE_MULTI_TRADE_CONTROL_LIMIT',

  // Deal Download Dialog
  TC_DEAL_DOWNLOAD_TITLE = 'TC_DEAL_DOWNLOAD_TITLE',
  TC_CSV_DEAL_DOWNLOAD = 'TC_CSV_DEAL_DOWNLOAD',
  TC_CONTINGENCY_DEAL_DOWNLOAD = 'TC_CONTINGENCY_DEAL_DOWNLOAD',
  SC_DEAL_DOWNLOAD_DOWNLOAD_TYPE = 'SC_DEAL_DOWNLOAD_DOWNLOAD_TYPE',
  SC_DEAL_DOWNLOAD_CCP = 'SC_DEAL_DOWNLOAD_CCP',

  // Product Dialog
  TC_NEW_PRODUCT = 'TC_NEW_PRODUCT',
  TC_EDIT_PRODUCT = 'TC_EDIT_PRODUCT',

  // Sector Dialog
  TC_NEW_SECTOR = 'TC_NEW_SECTOR',
  TC_EDIT_SECTOR = 'TC_EDIT_SECTOR',
  TC_VIEW_SECTOR = 'TC_VIEW_SECTOR',
  SC_IS_EX_DIVIDEND = 'SC_IS_EX_DIVIDEND',
  TC_REFERENCE_RATE_DEFAULT_CRYSTALLISATION = 'TC_REFERENCE_RATE_DEFAULT_CRYSTALLISATION',

  // Dialogs
  TC_TREAT_AS_CURVE = 'TC_TREAT_AS_CURVE',
  SC_TREAT_AS_CURVE_CONFIRMATION = 'SC_TREAT_AS_CURVE_CONFIRMATION',
  TC_CANCEL_RFQ = 'TC_CANCEL_RFQ',
  SC_CANCEL_RFQ_CONFIRMATION = 'SC_CANCEL_RFQ_CONFIRMATION',
  TC_CANCEL_ROW_RFQ = 'TC_CANCEL_ROW_RFQ',
  SC_CANCEL_ROW_RFQ_CONFIRMATION = 'SC_CANCEL_ROW_RFQ_CONFIRMATION',
  TC_CANCEL_ALL_RFQ = 'TC_CANCEL_ALL_RFQ',
  SC_CANCEL_ALL_RFQ_CONFIRMATION_1 = 'SC_CANCEL_ALL_RFQ_CONFIRMATION_1',
  SC_CANCEL_ALL_RFQ_CONFIRMATION_2 = 'SC_CANCEL_ALL_RFQ_CONFIRMATION_2',
  SC_CANCEL_ALL_RFQ_CONFIRMATION_3 = 'SC_CANCEL_ALL_RFQ_CONFIRMATION_3',
  TC_CANCEL_DEAL = 'TC_CANCEL_DEAL',
  TC_RETRY_DEAL = 'TC_RETRY_DEAL',
  TC_COMPLETE_DEAL = 'TC_COMPLETE_DEAL',
  SC_CANCEL_DEAL_CONFIRMATION = 'SC_CANCEL_DEAL_CONFIRMATION',
  SC_RETRY_DEAL_CONFIRMATION = 'SC_RETRY_DEAL_CONFIRMATION',
  SC_COMPLETE_DEAL_CONFIRMATION = 'SC_COMPLETE_DEAL_CONFIRMATION',
  TC_STOP_AMEND_DEAL = 'TC_STOP_AMEND_DEAL',
  TC_FORCE_STOP_AMEND_DEAL = 'TC_FORCE_STOP_AMEND_DEAL',
  TC_AMEND_DEAL = 'TC_AMEND_DEAL',
  SC_AMEND_DEAL_CONFIRMATION = 'SC_AMEND_DEAL_CONFIRMATION',
  TC_DELETE_HAIRCUT_ENTRY = 'TC_DELETE_HAIRCUT_ENTRY',
  SC_DELETE_HAIRCUT_ENTRY_CONFIRMATION = 'SC_DELETE_HAIRCUT_ENTRY_CONFIRMATION',
  TC_DELETE_HAIRCUT_ENTRIES = 'TC_DELETE_HAIRCUT_ENTRIES',
  SC_DELETE_HAIRCUT_ENTRIES_CONFIRMATION = 'SC_DELETE_HAIRCUT_ENTRIES_CONFIRMATION',
  TC_RESTORE_DEFAULT_LAYOUT = 'TC_RESTORE_DEFAULT_LAYOUT',
  SC_RESTORE_DEFAULT_LAYOUT_CONFIRMATION = 'SC_RESTORE_DEFAULT_LAYOUT_CONFIRMATION',
  SC_CLOSE_TICKET_WITH_AMENDMENTS = 'SC_CLOSE_TICKET_WITH_AMENDMENTS',
  SC_FORCE_STOP_AMEND_TICKET = 'SC_FORCE_STOP_AMEND_TICKET',
  SC_DUPLICATE_ISIN_CONFIRMATION = 'SC_DUPLICATE_ISIN_CONFIRMATION',
  SC_ISIN_LENGTH_ERROR = 'SC_ISIN_LENGTH_ERROR',
  SC_CANNOT_MIX_RFQ_TYPE = 'SC_CANNOT_MIX_RFQ_TYPE',
  SC_COLLECTION_NAME_ALREADY_EXISTS = 'SC_COLLECTION_NAME_ALREADY_EXISTS',
  SC_CANNOT_MIX_RFQ_TYPE_MESSAGE = 'SC_CANNOT_MIX_RFQ_TYPE_MESSAGE',
  SC_FORCE_ADD_TO_EXISTING_COLLECTION = 'SC_FORCE_ADD_TO_EXISTING_COLLECTION',
  TC_CANCEL_RFQS = 'TC_CANCEL_RFQS',
  TC_BULK_PRICE = 'TC_BULK_PRICE',
  SC_BULK_PRICE_CONFIRMATION = 'SC_BULK_PRICE_CONFIRMATION',
  TC_BULK_DATE = 'TC_BULK_DATE',
  SC_BULK_DATE_UPDATE_CONFIRMATION = 'SC_BULK_DATE_UPDATE_CONFIRMATION',
  TC_BULK_APPLY_SALES_COVER = 'TC_BULK_APPLY_SALES_COVER',
  SC_BULK_APPLY_SALES_COVER_CONFIRMATION = 'SC_BULK_APPLY_SALES_COVER_CONFIRMATION',
  TC_BULK_APPLY_TRADING_ENTITY_DEFAULTS = 'TC_BULK_APPLY_TRADING_ENTITY_DEFAULTS',
  SC_BULK_APPLY_TRADING_ENTITY_DEFAULTS_CONFIRMATION = 'SC_BULK_APPLY_TRADING_ENTITY_DEFAULTS_CONFIRMATION',
  TC_DELETE_SPLIT_TRADE_ENTRY = 'TC_DELETE_SPLIT_TRADE_ENTRY',
  SC_DELETE_SPLIT_TRADE_ENTRY_CONFIRMATION = 'SC_DELETE_SPLIT_TRADE_ENTRY_CONFIRMATION',
  TC_DELETE_SPLIT_TRADE_ENTRIES = 'TC_DELETE_SPLIT_TRADE_ENTRIES',
  SC_DELETE_SPLIT_TRADE_ENTRIES_CONFIRMATION = 'SC_DELETE_SPLIT_TRADE_ENTRIES_CONFIRMATION',
  TC_DELETE_SALES_COVERAGE_ENTRY = 'TC_DELETE_SALES_COVERAGE_ENTRY',
  SC_DELETE_SALES_COVERAGE_ENTRY_CONFIRMATION = 'SC_DELETE_SALES_COVERAGE_ENTRY_CONFIRMATION',
  TC_DELETE_SALES_COVERAGE_ENTRIES = 'TC_DELETE_SALES_COVERAGE_ENTRIES',
  SC_DELETE_SALES_COVERAGE_ENTRIES_CONFIRMATION = 'SC_DELETE_SALES_COVERAGE_ENTRIES_CONFIRMATION',
  TC_COLLATERAL_WILL_BE_SUSPENDED = 'TC_COLLATERAL_WILL_BE_SUSPENDED',
  SC_ROLL_CONFIRMATION = 'SC_ROLL_CONFIRMATION',
  TC_ISSUER_ID_TYPE = 'TC_ISSUER_ID_TYPE',

  // Button Captions
  TC_BUTTON_OK = 'TC_BUTTON_OK',
  TC_BUTTON_CLOSE = 'TC_BUTTON_CLOSE',
  TC_BUTTON_CLOSE_TICKET = 'TC_BUTTON_CLOSE_TICKET',
  TC_BUTTON_CANCEL = 'TC_BUTTON_CANCEL',
  TC_BUTTON_RETRY = 'TC_BUTTON_RETRY',
  TC_BUTTON_SEND_RFQ = 'TC_BUTTON_SEND_RFQ',
  TC_BUTTON_SAVE = 'TC_BUTTON_SAVE',
  TC_BUTTON_ASSIGN = 'TC_BUTTON_ASSIGN',
  TC_BUTTON_ALLOCATE_COLLATERAL = 'TC_BUTTON_ALLOCATE_COLLATERAL',
  TC_BUTTON_UPLOAD = 'TC_BUTTON_UPLOAD',
  TC_BUTTON_MTE_UPLOAD = 'TC_BUTTON_MTE_UPLOAD',
  TC_BUTTON_ADD = 'TC_BUTTON_ADD',
  TC_BUTTON_DELETE = 'TC_BUTTON_DELETE',
  TC_BUTTON_CREATE = 'TC_BUTTON_CREATE',
  TC_BUTTON_CREATE_NEW = 'TC_BUTTON_CREATE_NEW',
  TC_BUTTON_UPDATE = 'TC_BUTTON_UPDATE',
  TC_BUTTON_YES = 'TC_BUTTON_YES',
  TC_BUTTON_NO = 'TC_BUTTON_NO',
  TC_BUTTON_DOWNLOAD = 'TC_BUTTON_DOWNLOAD',
  TC_BUTTON_DOWNLOAD_LOGS = 'TC_BUTTON_DOWNLOAD_LOGS',
  TC_BUTTON_CLOSE_APPLICATION = 'TC_BUTTON_CLOSE_APPLICATION',
  TC_BUTTON_NEW_USER = 'TC_BUTTON_NEW_USER',
  TC_BUTTON_NEW_HAIRCUT = 'TC_BUTTON_NEW_HAIRCUT',
  TC_BUTTON_NEW_ORGANISATION = 'TC_BUTTON_NEW_ORGANISATION',
  TC_BUTTON_NEW_TRADING_ENTITY = 'TC_BUTTON_NEW_TRADING_ENTITY',
  TC_BUTTON_NEW_COLLATERAL = 'TC_BUTTON_NEW_COLLATERAL',
  TC_BUTTON_NEW_FAT_FINGER_LIMIT = 'TC_BUTTON_NEW_FAT_FINGER_LIMIT',
  TC_BUTTON_NEW_HOLIDAY = 'TC_BUTTON_NEW_HOLIDAY',
  TC_BUTTON_NEW_INDEX = 'TC_BUTTON_NEW_INDEX',
  TC_BUTTON_NEW_TRADE_CONTROL = 'TC_BUTTON_NEW_TRADE_CONTROL',
  TC_BUTTON_NEW_TRADE_SPLIT = 'TC_BUTTON_NEW_TRADE_SPLIT',
  TC_BUTTON_NEW_SALES_COVERAGE = 'TC_BUTTON_NEW_SALES_COVERAGE',
  TC_BUTTON_NEW_TRADING_ENTITY_ALIAS = 'TC_BUTTON_NEW_TRADING_ENTITY_ALIAS',
  TC_BUTTON_NEW_PRIME_BROKER = 'TC_BUTTON_NEW_PRIME_BROKER',
  SC_BUTTON_CLEAR_ALL = 'SC_BUTTON_CLEAR_ALL',
  TC_BUTTON_VIEW_TICKET = 'TC_BUTTON_VIEW_TICKET',
  TC_BUTTON_CREATE_GROUP = 'TC_BUTTON_CREATE_GROUP',
  TC_BUTTON_SAVE_GROUP = 'TC_BUTTON_SAVE_GROUP',
  TC_REMOVE_ALL = 'TC_REMOVE_ALL',
  TC_BUTTON_AXE = 'TC_BUTTON_AXE',
  TC_BUTTON_ROLL = 'TC_BUTTON_ROLL',
  TC_BUTTON_UNWIND = 'TC_BUTTON_UNWIND',
  TC_BUTTON_SUB = 'TC_BUTTON_SUB',
  TC_BUTTON_SEND_REQUEST = 'TC_BUTTON_SEND_REQUEST',
  TC_BUTTON_SEARCH = 'TC_BUTTON_SEARCH',
  TC_BUTTON_NEW_PRODUCT = 'TC_BUTTON_NEW_PRODUCT',
  TC_BUTTON_NEW_SECTOR = 'TC_BUTTON_NEW_SECTOR',
  TC_BUTTON_NEW_SECTOR_MAPPING = 'TC_BUTTON_NEW_SECTOR_MAPPING',
  TC_BUTTON_MAPPINGS_REPORT = 'TC_BUTTON_MAPPINGS_REPORT',
  TC_BUTTON_COMMIT_MAPPINGS = 'TC_BUTTON_COMMIT_MAPPINGS',
  TC_BUTTON_DISCARD_MAPPINGS = 'TC_BUTTON_DISCARD_MAPPINGS',

  TC_BUTTON_APPLY = 'TC_BUTTON_APPLY',
  SC_BUTTON_YES_AND_STAGE = 'SC_BUTTON_YES_AND_STAGE',
  TC_BUTTON_REFRESH = 'TC_BUTTON_REFRESH',
  TC_ADD_ISSUER_ORGANISATION = 'TC_ADD_ISSUER_ORGANISATION',
  TC_EDIT_ISSUER_ORGANISATION = 'TC_EDIT_ISSUER_ORGANISATION',

  // Notifications
  TC_NOTIFICATION_CATEGORY = 'TC_NOTIFICATION_CATEGORY',
  TC_NOTIFICATION_SUCCESS = 'TC_NOTIFICATION_SUCCESS',
  TC_NOTIFICATION_ERROR = 'TC_NOTIFICATION_ERROR',
  TC_NOTIFICATION_WARNING = 'TC_NOTIFICATION_WARNING',

  SC_NOTIFICATION_UPLOAD_SUCCESS = 'SC_NOTIFICATION_UPLOAD_SUCCESS',
  SC_NOTIFICATION_RFQ_SEND_SUCCESS = 'SC_NOTIFICATION_RFQ_SEND_SUCCESS',
  SC_NOTIFICATION_USER_PREFERENCE_UPDATE_SUCCESS = 'SC_NOTIFICATION_USER_PREFERENCE_UPDATE_SUCCESS',
  SC_NOTIFICATION_RFQ_PLACED_SUCCESS = 'SC_NOTIFICATION_RFQ_PLACED_SUCCESS',
  SC_YOU_HAVE_RECEIVED_EVENTS = 'SC_YOU_HAVE_RECEIVED_EVENTS',
  TC_VIEW_QUEUE = 'TC_VIEW_QUEUE',

  // Connection Errors
  SC_CONNECTION_FAILED = 'SC_CONNECTION_FAILED',
  SC_CONNECTION_FAILED_AFTER_RETRIES = 'SC_CONNECTION_FAILED_AFTER_RETRIES',
  SC_CONNECTING_TO = 'SC_CONNECTING_TO',
  SC_CONNECTED_TO = 'SC_CONNECTED_TO',
  SC_DISCONNECTING_FROM = 'SC_DISCONNECTING_FROM',
  SC_DISCONNECTED_FROM = 'SC_DISCONNECTED_FROM',
  SC_FAILED_TO_CONNECT_TO = 'SC_FAILED_TO_CONNECT_TO',

  // Application Errors
  SC_ERROR_CAUGHT = 'SC_ERROR_CAUGHT',
  SC_LOGS_DOWNLOADED = 'SC_LOGS_DOWNLOADED',
  SC_DATA_INTEGRITY_ERROR = 'SC_DATA_INTEGRITY_ERROR',

  // Collections
  SC_COLLECTION_EMPTY = 'SC_COLLECTION_EMPTY',
  SC_COLLECTION_SUMMARY = 'SC_COLLECTION_SUMMARY',
  TC_ADD_TO_COLLECTION = 'TC_ADD_TO_COLLECTION',
  TC_EXISTING = 'TC_EXISTING',
  TC_NEW = 'TC_NEW',
  TC_COLLECTIONS = 'TC_COLLECTIONS',
  TC_COLLECTION_UNASSIGNED = 'TC_COLLECTION_UNASSIGNED',
  SC_ADD_TO_EXISTING_COLLECTION = 'SC_ADD_TO_EXISTING_COLLECTION',
  SC_SELECT_COLLECTION = 'SC_SELECT_COLLECTION',
  SC_SELECT_COLLECTION_TYPE = 'SC_SELECT_COLLECTION_TYPE',
  SC_NAME_COLLECTION = 'SC_NAME_COLLECTION',
  SC_UNIQUE_NAME = 'SC_UNIQUE_NAME',

  // Collateral Basket
  TC_SINGLE_TRADES = 'TC_SINGLE_TRADES',

  TC_ADD_NEW_ASSETS = 'TC_ADD_NEW_ASSETS',
  TC_ENTER_ASSET_DETAILS = 'TC_ENTER_ASSET_DETAILS',
  TC_FUND_LABEL = 'TC_FUND_LABEL',
  SC_FUND_PLACEHOLDER = 'SC_FUND_PLACEHOLDER',
  TC_COLLATERAL_LABEL = 'TC_COLLATERAL_LABEL',
  SC_COLLATERAL_PLACEHOLDER = 'SC_COLLATERAL_PLACEHOLDER',
  TC_INSTRUMENT_LABEL = 'TC_INSTRUMENT_LABEL',
  SC_INSTRUMENT_PLACEHOLDER = 'SC_INSTRUMENT_PLACEHOLDER',
  TC_NUMBER = 'TC_NUMBER',
  TC_STAGE_NEW_BASKET_ORDER = 'TC_STAGE_NEW_BASKET_ORDER',

  // Fund Assignments
  TC_ASSIGNMENT_LOCKED = 'TC_ASSIGNMENT_LOCKED',
  SC_ASSIGNMENT_LOCKED_TO_ANOTHER_USER = 'SC_ASSIGNMENT_LOCKED_TO_ANOTHER_USER',
  SC_NO_FUND_DETAILS = 'SC_NO_FUND_DETAILS',
  SC_NOT_ASSIGNMENT_AUTHOR = 'SC_NOT_ASSIGNMENT_AUTHOR',
  TC_REMAINING_ASSIGNMENT_TIME = 'TC_REMAINING_ASSIGNMENT_TIME',
  SC_AVAILABLE_TRADING_ENTITIES_TO_ALLOCATE = 'SC_AVAILABLE_TRADING_ENTITIES_TO_ALLOCATE',
  SC_SEARCH_TRADING_ENTITIES = 'SC_SEARCH_TRADING_ENTITIES',
  SC_NO_TRADING_ENTITIES_FOUND = 'SC_NO_TRADING_ENTITIES_FOUND',
  SC_SELECT_ASSIGNMENTS = 'SC_SELECT_ASSIGNMENTS',
  TC_ASSIGNMENT_REQUIRED = 'TC_ASSIGNMENT_REQUIRED',
  TC_AMOUNT_ASSIGNED = 'TC_AMOUNT_ASSIGNED',
  TC_REMAINING_ASSIGNMENT_REQUIRED = 'TC_REMAINING_ASSIGNMENT_REQUIRED',
  TC_ASSIGNED_TRADING_ENTITIES = 'TC_ASSIGNED_TRADING_ENTITIES',
  TC_TRADING_ENTITY = 'TC_TRADING_ENTITY',
  TC_PROMPT_TITLE_OVER_ASSIGNMENT = 'TC_PROMPT_TITLE_OVER_ASSIGNMENT',
  TC_PROMPT_TITLE_UNDER_ASSIGNMENT = 'TC_PROMPT_TITLE_UNDER_ASSIGNMENT',
  SC_PROMPT_MSG_ACCEPT_OVER_ASSIGNMENT = 'SC_PROMPT_MSG_ACCEPT_OVER_ASSIGNMENT',
  SC_PROMPT_MSG_ACCEPT_UNDER_ASSIGNMENT = 'SC_PROMPT_MSG_ACCEPT_UNDER_ASSIGNMENT',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_MAPPING_TITLE = 'TC_TRADING_ENTITY_ASSIGN_UPLOAD_MAPPING_TITLE',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_TITLE = 'TC_TRADING_ENTITY_ASSIGN_UPLOAD_TITLE',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_PENDING = 'TC_TRADING_ENTITY_ASSIGN_UPLOAD_PENDING',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_TEMPLATE_FILENAME = 'TC_TRADING_ENTITY_ASSIGN_UPLOAD_TEMPLATE_FILENAME',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_DOWNLOAD_SPREADSHEET = 'TC_TRADING_ENTITY_ASSIGN_UPLOAD_DOWNLOAD_SPREADSHEET',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_UPLOAD_BUTTON_LABEL = 'TC_TRADING_ENTITY_ASSIGN_UPLOAD_UPLOAD_BUTTON_LABEL',
  TC_TRADING_ENTITY_ASSIGN_UPLOAD_UPLOAD_DROPDOWN_LABEL = 'TC_TRADING_ENTITY_ASSIGN_UPLOAD_UPLOAD_DROPDOWN_LABEL',
  SC_TRADING_ENTITY_ASSIGN_UPLOAD_SUCCESS = 'SC_TRADING_ENTITY_ASSIGN_UPLOAD_SUCCESS',
  SC_TRADING_ENTITY_ASSIGN_UPLOAD_ERROR = 'SC_TRADING_ENTITY_ASSIGN_UPLOAD_ERROR',
  SC_TRADING_ENTITY_ASSIGN_UPLOAD_ERROR_NARRATIVE = 'SC_TRADING_ENTITY_ASSIGN_UPLOAD_ERROR_NARRATIVE',
  SC_TRADING_ENTITY_ASSIGN_UPLOAD_ERROR_ENTITY_NOT_FOUND = 'SC_TRADING_ENTITY_ASSIGN_UPLOAD_ERROR_ENTITY_NOT_FOUND',
  SC_TRADING_ENTITY_ASSIGN_UPLOAD_DUPLICATE = 'SC_TRADING_ENTITY_ASSIGN_UPLOAD_DUPLICATE',
  SC_TRADING_ENTITY_ASSIGN_UPLOAD_NO_NOTIONAL_FOR_CASH_TRADED = 'SC_TRADING_ENTITY_ASSIGN_UPLOAD_NO_NOTIONAL_FOR_CASH_TRADED',
  SC_TRADING_ENTITY_ASSIGN_UPLOAD_NO_SC_FOR_NOTIONAL_TRADED = 'SC_TRADING_ENTITY_ASSIGN_UPLOAD_NO_SC_FOR_NOTIONAL_TRADED',

  // Collateral Allocations
  TC_ALLOCATION_REQUIRED = 'TC_ALLOCATION_REQUIRED',
  TC_AMOUNT_ALLOCATED = 'TC_AMOUNT_ALLOCATED',
  TC_REMAINING_ALLOCATION_REQUIRED = 'TC_REMAINING_ALLOCATION_REQUIRED',
  TC_ALLOCATED_PRODUCTS = 'TC_ALLOCATED_PRODUCTS',
  SC_AVAILABLE_PRODUCTS_TO_ALLOCATE = 'SC_AVAILABLE_PRODUCTS_TO_ALLOCATE',
  TC_ALLOCATION_LOCKED = 'TC_ALLOCATION_LOCKED',
  SC_ALLOCATION_LOCKED_TO_ANOTHER_USER = 'SC_ALLOCATION_LOCKED_TO_ANOTHER_USER',
  SC_NO_BASKET_DETAILS = 'SC_NO_BASKET_DETAILS',
  SC_NOT_ALLOCATION_AUTHOR = 'SC_NOT_ALLOCATION_AUTHOR',
  SC_SEARCH_COLLATERALS = 'SC_SEARCH_COLLATERALS',
  SC_NO_COLLATERALS_FOUND = 'SC_NO_COLLATERALS_FOUND',
  SC_SELECT_ALLOCATIONS = 'SC_SELECT_ALLOCATIONS',
  TC_REMAINING_ALLOCATION_TIME = 'TC_REMAINING_ALLOCATION_TIME',
  TC_PROMPT_TITLE_OVER_ALLOCATION = 'TC_PROMPT_TITLE_OVER_ALLOCATION',
  TC_PROMPT_TITLE_UNDER_ALLOCATION = 'TC_PROMPT_TITLE_UNDER_ALLOCATION',
  SC_PROMPT_MSG_ACCEPT_OVER_ALLOCATION = 'SC_PROMPT_MSG_ACCEPT_OVER_ALLOCATION',
  SC_PROMPT_MSG_ACCEPT_UNDER_ALLOCATION = 'SC_PROMPT_MSG_ACCEPT_UNDER_ALLOCATION',

  SC_ERROR_CLIPBOARD_MIXED_TRADING_TYPE = 'SC_ERROR_CLIPBOARD_MIXED_TRADING_TYPE',
  SC_ERROR_CLIPBOARD_INVALID_ISIN = 'SC_ERROR_CLIPBOARD_INVALID_ISIN',
  SC_ERROR_CLIPBOARD_INVALID_HAIRCUT = 'SC_ERROR_CLIPBOARD_INVALID_HAIRCUT',
  SC_ALLOCATION_UPLOAD_ERROR_NO_HAIRCUT_SBL = 'SC_ALLOCATION_UPLOAD_ERROR_NO_HAIRCUT_SBL',
  SC_ALLOCATION_UPLOAD_ERROR_ALL_IN_PRICE_CLASSIC_ONLY = 'SC_ALLOCATION_UPLOAD_ERROR_ALL_IN_PRICE_CLASSIC_ONLY',
  TC_ALLOCATION_UPLOAD = 'TC_ALLOCATION_UPLOAD',
  TC_ALLOCATION_BUTTON_UPLOAD = 'TC_ALLOCATION_BUTTON_UPLOAD',
  TC_ALLOCATION_UPLOAD_PENDING = 'TC_ALLOCATION_UPLOAD_PENDING',
  SC_ALLOCATION_UPLOAD_ERROR_NARRATIVE = 'SC_ALLOCATION_UPLOAD_ERROR_NARRATIVE',
  TC_ALLOCATION_DOWNLOAD_SPREADSHEET = 'TC_ALLOCATION_DOWNLOAD_SPREADSHEET',
  TC_ALLOCATION_DOWNLOAD_TEMPLATE_FILENAME = 'TC_ALLOCATION_DOWNLOAD_TEMPLATE_FILENAME',
  SC_ALLOCATION_SPREADSHEET_SUCCESS = 'SC_ALLOCATION_SPREADSHEET_SUCCESS',
  SC_ALLOCATION_SPREADSHEET_ERROR = 'SC_ALLOCATION_SPREADSHEET_ERROR',

  // Deal Servicing Substitution
  SC_CURRENT_COLLATERAL = 'SC_CURRENT_COLLATERAL',
  SC_CURRENT_HAIRCUT = 'SC_CURRENT_HAIRCUT',
  SC_CURRENT_HAIRCUT_TYPE = 'SC_CURRENT_HAIRCUT_TYPE',
  SC_CURRENT_RATE = 'SC_CURRENT_RATE',
  SC_NEW_COLLATERAL = 'SC_NEW_COLLATERAL',
  SC_NEW_HAIRCUT = 'SC_NEW_HAIRCUT',
  SC_NEW_HAIRCUT_TYPE = 'SC_NEW_HAIRCUT_TYPE',
  SC_NEW_RATE = 'SC_NEW_RATE',
  SC_EFFECTIVE_DATE = 'SC_EFFECTIVE_DATE',
  SC_EFFECTIVE_DATE_TODAY_WARNING_MESSAGE = 'SC_EFFECTIVE_DATE_TODAY_WARNING_MESSAGE',
  SC_EFFECTIVE_DATE_AFTER_MAX_EFFECTIVE_DATE_ERROR_MESSAGE = 'SC_EFFECTIVE_DATE_AFTER_MAX_EFFECTIVE_DATE_ERROR_MESSAGE',
  SC_EFFECTIVE_DATE_CHANGED_FROM_DEFAULT = 'SC_EFFECTIVE_DATE_CHANGED_FROM_DEFAULT',
  SC_EFFECTIVE_DATE_INVALID = 'SC_EFFECTIVE_DATE_INVALID',
  SC_COLLATERAL_UNCHANGED = 'SC_COLLATERAL_UNCHANGED',
  TC_CURRENT_COLLATERAL = 'TC_CURRENT_COLLATERAL',
  TC_CURRENT_HAIRCUT = 'TC_CURRENT_HAIRCUT',
  TC_CURRENT_HAIRCUT_TYPE = 'TC_CURRENT_HAIRCUT_TYPE',
  TC_SUBSTITUTE = 'TC_SUBSTITUTE',
  TC_SUBSTITUTE_TRADE = 'TC_SUBSTITUTE_TRADE',
  SC_SUBSTITUTE_TRADE_CONFIRMATION = 'SC_SUBSTITUTE_TRADE_CONFIRMATION',

  // Deal Servicing Rerate
  SC_ADJUST_ALL_RATES = 'SC_ADJUST_ALL_RATES',
  SC_UPDATE_ALL_RATES = 'SC_UPDATE_ALL_RATES',
  SC_BPS = 'SC_BPS',
  SC_OR_ENTER_MANUALLY = 'SC_OR_ENTER_MANUALLY',
  TC_CALCULATE = 'TC_CALCULATE',
  TC_CURRENT_RATE = 'TC_CURRENT_RATE',
  TC_CURRENT_HAIRCUT_ABBREVIATED = 'TC_CURRENT_HAIRCUT_ABBREVIATED',
  TC_NEW_HAIRCUT_ABBREVIATED = 'TC_NEW_HAIRCUT_ABBREVIATED',
  SC_OUT_OF_RANGE_HAIRCUT_ERROR_MESSAGE = 'SC_OUT_OF_RANGE_HAIRCUT_ERROR_MESSAGE',
  TC_CURRENT_FEE = 'TC_CURRENT_FEE',
  TC_NEW_FEE = 'TC_NEW_FEE',
  SC_RERATE_CONFIRM = 'SC_RERATE_CONFIRM',
  TC_RERATE_TRADE = 'TC_RERATE_TRADE',

  // Deal Servicing Close/Open
  SC_NEGATIVE_NOTIONAL_ERROR_MESSAGE = 'SC_NEGATIVE_NOTIONAL_ERROR_MESSAGE',
  SC_NOTIONAL_TICKET_SIZE_ERROR_MESSAGE = 'SC_NOTIONAL_TICKET_SIZE_ERROR_MESSAGE',
  SC_HAIRCUT_WITHOUT_HAIRCUT_TYPE_ERROR_MESSAGE = 'SC_HAIRCUT_WITHOUT_HAIRCUT_TYPE_ERROR_MESSAGE',
  TC_NEW_SECONDARY_COLLATERAL = 'TC_NEW_SECONDARY_COLLATERAL',
  TC_NEW_STOCK_BORROW_LENDING_TYPE = 'TC_NEW_STOCK_BORROW_LENDING_TYPE',
  SC_CLOSE_OPEN_CONFIRMATION = 'SC_CLOSE_OPEN_CONFIRMATION',
  TC_CLOSE_OPEN_TRADE = 'TC_CLOSE_OPEN_TRADE',

  // Deal Servicing Termination
  TC_TERMINATION_REQUEST = 'TC_TERMINATION_REQUEST',
  TC_TERMINATE_TRADE = 'TC_TERMINATE_TRADE',
  SC_TERMINATE_TRADE_CONFIRMATION = 'SC_TERMINATE_TRADE_CONFIRMATION',
  SC_REQUEST_INITIATED_AFTER_CUT_OFF_TIME = 'SC_REQUEST_INITIATED_AFTER_CUT_OFF_TIME',
  SC_REQUEST_HAS_NO_ROE = 'SC_REQUEST_HAS_NO_ROE',
  SC_REQUEST_HAS_NO_ROS = 'SC_REQUEST_HAS_NO_ROS',
  SC_SET_ALL_EFFECTIVE_DATES = 'SC_SET_ALL_EFFECTIVE_DATES',
  TC_EVERGREEN_NOTICE_PERIOD_INFO_MESSAGE = 'TC_EVERGREEN_NOTICE_PERIOD_INFO_MESSAGE',

  // Deal Servicing Roll In Place
  SC_START_DATE = 'SC_START_DATE',
  SC_NOTIONAL = 'SC_NOTIONAL',
  SC_START_CONSIDERATION = 'SC_START_CONSIDERATION',
  SC_RATE = 'SC_RATE',
  SC_HAIRCUT = 'SC_HAIRCUT',
  SC_HAIRCUT_TYPE = 'SC_HAIRCUT_TYPE',

  // Deal Servicing Trade Amend
  SC_REQUEST_INITIATED_AFTER_MARKET_CLOSE = 'SC_REQUEST_INITIATED_AFTER_MARKET_CLOSE',

  // Deal Servicing General
  SC_DECISION_MAKER_NOT_ACTIVE_ERROR_MESSAGE = 'SC_DECISION_MAKER_NOT_ACTIVE_ERROR_MESSAGE',

  // --------------------
  // Blotters & grids
  // --------------------
  // toolbar and controls
  TC_COLUMNS = 'TC_COLUMNS',
  SC_SHOW_DELTAS = 'SC_SHOW_DELTAS',
  TC_HIDE_EXPIRED_REJECTED = 'TC_HIDE_EXPIRED_REJECTED',
  TC_INCLUDE_TERMINATED = 'TC_INCLUDE_TERMINATED',
  SC_GROUP_ITEMS = 'SC_GROUP_ITEMS',
  SC_DISPLAY_HIDE_COLUMNS = 'SC_DISPLAY_HIDE_COLUMNS',
  SC_FILTER_ROWS = 'SC_FILTER_ROWS',
  SC_FILTER = 'SC_FILTER',
  SC_EXPORT_ALL_ROWS = 'SC_EXPORT_ALL_ROWS',
  SC_EXTRACT_REPORT = 'SC_EXTRACT_REPORT',
  SC_EXTRACT_REPORT_SUCCESS = 'SC_EXTRACT_REPORT_SUCCESS',
  TC_PERMISSIONS_REPORT = 'TC_PERMISSIONS_REPORT',
  TC_PURGE_ENTITY = 'TC_PURGE_ENTITY',
  SC_PERMISSIONS_REPORT_SUCCESS = 'SC_PERMISSIONS_REPORT_SUCCESS',
  SC_PURGE_ENTITY_SUCCESS = 'SC_PURGE_ENTITY_SUCCESS',
  SC_PERMISSIONS_REPORT_WARNING = 'SC_PERMISSIONS_REPORT_WARNING',
  SC_RESTORE_DEFAULT_LAYOUT = 'SC_RESTORE_DEFAULT_LAYOUT',
  SC_AUTO_FIT_COLUMNS = 'SC_AUTO_FIT_COLUMNS',
  SC_SEARCH_ALL_FIELDS = 'SC_SEARCH_ALL_FIELDS',
  SC_EXPAND_COLLAPSE_ROW = 'SC_EXPAND_COLLAPSE_ROW',
  SC_EXPAND_COLLAPSE_ALL_ROWS = 'SC_EXPAND_COLLAPSE_ALL_ROWS',
  SC_SELECT_BY_STATUS = 'SC_SELECT_BY_STATUS',
  TC_NO_DATA = 'TC_NO_DATA',
  TC_SHOW_CANCELLED_AXES = 'TC_SHOW_CANCELLED_AXES',
  SC_SHOW_ORGANISATION_ACTIVITY = 'SC_SHOW_ORGANISATION_ACTIVITY',
  SC_SHOW_MY_SALES_RFQS = 'SC_SHOW_MY_SALES_RFQS',
  SC_SHOW_MY_SALES_RFQS_TOOLTIP = 'SC_SHOW_MY_SALES_RFQS_TOOLTIP',
  SC_SHOW_MATURED_COLLATERALS = 'SC_SHOW_MATURED_COLLATERALS',
  TC_GROUPING_UNGROUPED = 'TC_GROUPING_UNGROUPED',
  TC_GROUPING_BASKETS = 'TC_GROUPING_BASKETS',
  TC_GROUPING_COLLECTIONS = 'TC_GROUPING_COLLECTIONS',
  TC_GROUPING_COUNTERPARTY = 'TC_GROUPING_COUNTERPARTY',
  TC_GROUPING_RFQ_ID = 'TC_GROUPING_RFQ_ID',
  TC_GROUPING_CUSTOM = 'TC_GROUPING_CUSTOM',
  TC_BEST_PRICE_CALCULATION = 'TC_BEST_PRICE_CALCULATION',
  TC_BEST_PRICE = 'TC_BEST_PRICE',
  UC_WAS = 'UC_WAS',
  TC_VIEW_RELATED_TRADES = 'TC_VIEW_RELATED_TRADES',
  TC_FILTER_OPEN = 'TC_FILTER_OPEN',
  TC_FILTER_TODAYS = 'TC_FILTER_TODAYS',
  TC_FILTER_SEARCH = 'TC_FILTER_SEARCH',
  SC_FILTER_SEARCH_BY = 'SC_FILTER_SEARCH_BY',
  SC_FILTER_TRADE_ID_EQUALS = 'SC_FILTER_TRADE_ID_EQUALS',
  SC_FILTER_AXE_ID_EQUALS = 'SC_FILTER_AXE_ID_EQUALS',
  SC_FILTER_EXTERNAL_AXE_ID_EQUALS = 'SC_FILTER_EXTERNAL_AXE_ID_EQUALS',
  SC_FILTER_ISIN_BUI_CUSIP_EQUALS = 'SC_FILTER_ISIN_BUI_CUSIP_EQUALS',
  SC_FILTER_CUSIP_EQUALS = 'SC_FILTER_CUSIP_EQUALS',
  SC_FILTER_MY_ENTITY_EQUALS = 'SC_FILTER_MY_ENTITY_EQUALS',
  SC_FILTER_MY_FIRM_EQUALS = 'SC_FILTER_MY_FIRM_EQUALS',
  SC_FILTER_COUNTERPARTY_EQUALS = 'SC_FILTER_COUNTERPARTY_EQUALS',
  SC_FILTER_COUNTERPARTY_FIRM_EQUALS = 'SC_FILTER_COUNTERPARTY_FIRM_EQUALS',
  SC_FILTER_RATE_FROM = 'SC_FILTER_RATE_FROM',
  SC_FILTER_RATE_TO = 'SC_FILTER_RATE_TO',
  SC_FILTER_CURRENCY_EQUALS = 'SC_FILTER_CURRENCY_EQUALS',
  SC_FILTER_TERM_EQUALS = 'SC_FILTER_TERM_EQUALS',
  SC_FILTER_DIRECTION_EQUALS = 'SC_FILTER_DIRECTION_EQUALS',
  SC_FILTER_PRODUCT_EQUALS = 'SC_FILTER_PRODUCT_EQUALS',
  SC_FILTER_SECTOR_EQUALS = 'SC_FILTER_SECTOR_EQUALS',
  SC_FILTER_MY_TRADER_EQUALS = 'SC_FILTER_MY_TRADER_EQUALS',
  SC_FILTER_COUNTERPARTY_TRADER_EQUALS = 'SC_FILTER_COUNTERPARTY_TRADER_EQUALS',
  SC_FILTER_COLLECTION_NAME_EQUALS = 'SC_FILTER_COLLECTION_NAME_EQUALS',
  SC_FILTER_RATE_EQUALS = 'SC_FILTER_RATE_EQUALS',
  SC_FILTER_TRADE_DATE_AFTER = 'SC_FILTER_TRADE_DATE_AFTER',
  TC_FILTER_TRADE_DATE = 'TC_FILTER_TRADE_DATE',
  SC_FILTER_AXE_AFTER = 'SC_FILTER_AXE_AFTER',
  SC_FILTER_CREATED_AFTER = 'SC_FILTER_CREATED_AFTER',
  TC_FILTER_CREATED = 'TC_FILTER_CREATED',
  SC_FILTER_START_DATE_AFTER = 'SC_FILTER_START_DATE_AFTER',
  SC_FILTER_END_DATE_AFTER = 'SC_FILTER_END_DATE_AFTER',
  SC_FILTER_AND_OR_BEFORE = 'SC_FILTER_AND_OR_BEFORE',
  SC_FILTER_AXE_CREATED_AND_OR_BEFORE = 'SC_FILTER_AXE_CREATED_AND_OR_BEFORE',
  SC_FILTER_INVALID_TRADE_DATE_RANGE = 'SC_FILTER_INVALID_TRADE_DATE_RANGE',
  SC_FILTER_INVALID_CREATED_AT_DATE_RANGE = 'SC_FILTER_INVALID_CREATED_AT_DATE_RANGE',
  SC_FILTER_INVALID_START_DATE_RANGE = 'SC_FILTER_INVALID_START_DATE_RANGE',
  SC_FILTER_INVALID_END_DATE_RANGE = 'SC_FILTER_INVALID_END_DATE_RANGE',
  SC_FILTER_INVALID_DATE_RANGE = 'SC_FILTER_INVALID_DATE_RANGE',
  SC_FILTER_SECOND_DATE_MISSING = 'SC_FILTER_SECOND_DATE_MISSING',
  SC_SELECT_COLUMNS_TO_COPY = 'SC_SELECT_COLUMNS_TO_COPY',
  SC_COPY_SELECTED_COLUMNS = 'SC_COPY_SELECTED_COLUMNS',
  SC_SHOW_ONLY_ENABLED_USERS = 'SC_SHOW_ONLY_ENABLED_USERS',
  TC_BULK_DATE_UPDATE_TERM = 'TC_BULK_DATE_UPDATE_TERM',

  // columns
  TC_GROUPING = 'TC_GROUPING',
  TC_EMPTY_HEADER = 'TC_EMPTY_HEADER',
  TC_COLLECTION_NAME = 'TC_COLLECTION_NAME',
  TC_COLLECTION_TYPE = 'TC_COLLECTION_TYPE',
  TC_COLLECTION_ID = 'TC_COLLECTION_ID',
  TC_CONTAINER_COLLECTION_ID = 'TC_CONTAINER_COLLECTION_ID',
  TC_PREV_RATE = 'TC_PREV_RATE',
  TC_CONTAINER_COLLECTION_NAME = 'TC_CONTAINER_COLLECTION_NAME',
  TC_CURVE = 'TC_CURVE',
  TC_CLEARING_VENUE = 'TC_CLEARING_VENUE',
  TC_COUNTERPARTY_CLEARED = 'TC_COUNTERPARTY_CLEARED',
  TC_COUNTERPARTY_SPONSOR = 'TC_COUNTERPARTY_SPONSOR',
  TC_COUNTERPARTY = 'TC_COUNTERPARTY',
  TC_EXECUTING_COUNTERPARTY = 'TC_EXECUTING_COUNTERPARTY',
  TC_EXECUTING_COUNTERPARTY_SPONSOR = 'TC_EXECUTING_COUNTERPARTY_SPONSOR',
  TC_EXECUTING_COUNTERPARTY_SPONSOR_SHORT = 'TC_EXECUTING_COUNTERPARTY_SPONSOR_SHORT',
  TC_COUNTERPARTY_LEI = 'TC_COUNTERPARTY_LEI',
  TC_STATUS = 'TC_STATUS',
  TC_OTW = 'TC_OTW',
  TC_OTW_TIME = 'TC_OTW_TIME',
  TC_RFQ = 'TC_RFQ',
  TC_RFQ_TIME = 'TC_RFQ_TIME',
  TC_DIRECTION = 'TC_DIRECTION',
  TC_ABBREVIATED_DIRECTION = 'TC_ABBREVIATED_DIRECTION',
  TC_ISIN = 'TC_ISIN',
  TC_ISIN_CUSIP = 'TC_ISIN_CUSIP',
  TC_ISIN_CUSIP_BUI = 'TC_ISIN_CUSIP_BUI',
  TC_ISIN_BUI = 'TC_ISIN_BUI',
  TC_NEW_ISIN_BUI = 'TC_NEW_ISIN_BUI',
  TC_SECONDARY_ISIN_BUI = 'TC_SECONDARY_ISIN_BUI',
  TC_BUI = 'TC_BUI',
  TC_CUSIP = 'TC_CUSIP',
  TC_COLLATERAL = 'TC_COLLATERAL',
  TC_COLLATERAL_ID = 'TC_COLLATERAL_ID',
  TC_STOCK_BORROW_LENDING_TYPE = 'TC_STOCK_BORROW_LENDING_TYPE',
  TC_NEW_COLLATERAL = 'TC_NEW_COLLATERAL',
  TC_NEW_CUSIP = 'TC_NEW_CUSIP',
  TC_ALLOCATION_TIME = 'TC_ALLOCATION_TIME',
  TC_CURRENCY = 'TC_CURRENCY',
  TC_NOT_CURRENCY = 'TC_NOT_CURRENCY',
  TC_CCY = 'TC_CCY',
  TC_REFERENCE_RATE = 'TC_REFERENCE_RATE',
  TC_FLOAT_CRYSTALLISATION_DAYS = 'TC_FLOAT_CRYSTALLISATION_DAYS',
  TC_BILLING_CURRENCY = 'TC_BILLING_CURRENCY',
  TC_PRIMARY_BILLING_CURRENCY = 'TC_PRIMARY_BILLING_CURRENCY',
  TC_SECONDARY_BILLING_CURRENCY = 'TC_SECONDARY_BILLING_CURRENCY',
  TC_REFERENCE_RATES = 'TC_REFERENCE_RATES',
  TC_EX_DIVIDEND_DAY_CONVENTION = 'TC_EX_DIVIDEND_DAY_CONVENTION',
  TC_NOTIONAL = 'TC_NOTIONAL',
  TC_MULTIPLE_NOTIONAL = 'TC_MULTIPLE_NOTIONAL',
  TC_NEW_NOTIONAL = 'TC_NEW_NOTIONAL',
  TC_NEW_NOTIONAL_SHORT = 'TC_NEW_NOTIONAL_SHORT',
  TC_NOTIONAL_SHORT = 'TC_NOTIONAL_SHORT',
  TC_ORIGINAL = 'TC_ORIGINAL',
  TC_ORIGINAL_SHORT = 'TC_ORIGINAL_SHORT',
  TC_RATE = 'TC_RATE',
  TC_NEW_RATE = 'TC_NEW_RATE',
  TC_RATE_VS_REFERENCE_RATE = 'TC_RATE_VS_REFERENCE_RATE',
  TC_LAST_QUOTED = 'TC_LAST_QUOTED',
  TC_START_DATE = 'TC_START_DATE',
  TC_NEW_START_DATE = 'TC_NEW_START_DATE',
  TC_END_DATE = 'TC_END_DATE',
  TC_NEW_END_DATE = 'TC_NEW_END_DATE',
  TC_EFFECTIVE_DATE = 'TC_EFFECTIVE_DATE',
  TC_HAIRCUT = 'TC_HAIRCUT',
  TC_BID_HAIRCUT = 'TC_BID_HAIRCUT',
  TC_OFFER_HAIRCUT = 'TC_OFFER_HAIRCUT',
  TC_NEW_HAIRCUT = 'TC_NEW_HAIRCUT',
  TC_HAIRCUT_TYPE = 'TC_HAIRCUT_TYPE',
  TC_NEW_HAIRCUT_TYPE = 'TC_NEW_HAIRCUT_TYPE',
  TC_ACTIONS = 'TC_ACTIONS',
  TC_ENTITY = 'TC_ENTITY',
  TC_MY_ENTITY = 'TC_MY_ENTITY',
  TC_MY_ENTITY_LEI = 'TC_MY_ENTITY_LEI',
  TC_MY_ENTITY_BIC = 'TC_MY_ENTITY_BIC',
  TC_MY_ENTITY_ID = 'TC_MY_ENTITY_ID',
  TC_MY_FIRM = 'TC_MY_FIRM',
  TC_MY_FIRM_LEI = 'TC_MY_FIRM_LEI',
  TC_MY_INVESTMENT_DECISION_MAKER = 'TC_MY_INVESTMENT_DECISION_MAKER',
  TC_MY_EXECUTION_DECISION_MAKER = 'TC_MY_EXECUTION_DECISION_MAKER',
  TC_SECTOR = 'TC_SECTOR',
  TC_HAIRCUT_COLLATERAL_BAND = 'TC_HAIRCUT_COLLATERAL_BAND',
  TC_HAIRCUT_COLLATERAL_BAND_MIN = 'TC_HAIRCUT_COLLATERAL_BAND_MIN',
  TC_HAIRCUT_COLLATERAL_BAND_MAX = 'TC_HAIRCUT_COLLATERAL_BAND_MAX',
  TC_HAIRCUT_ALL_VALUES = 'TC_HAIRCUT_ALL_VALUES',
  TC_TERM = 'TC_TERM',
  TC_EVERGREEN_NOTICE_PERIOD = 'TC_EVERGREEN_NOTICE_PERIOD',
  TC_NEW_TERM = 'TC_NEW_TERM',
  TC_CREATION_TIMESTAMP = 'TC_CREATION_TIMESTAMP',
  TC_CREATION_TIME = 'TC_CREATION_TIME',
  TC_CREATION_DATE = 'TC_CREATION_DATE',
  TC_SUBMITTING_USER = 'TC_SUBMITTING_USER',
  TC_TARGET = 'TC_TARGET',
  TC_DELTA = 'TC_DELTA',
  TC_COMPETITION = 'TC_COMPETITION',
  TC_COUPON = 'TC_COUPON',
  TC_BOOK = 'TC_BOOK',
  TC_NOTE = 'TC_NOTE',
  TC_STRATEGY = 'TC_STRATEGY',
  TC_PRIME_BROKER = 'TC_PRIME_BROKER',
  TC_BUNDLE = 'TC_BUNDLE',
  TC_ISSUER = 'TC_ISSUER',
  TC_UPLOAD_ROW_INDEX = 'TC_UPLOAD_ROW_INDEX',
  TC_REPO_TYPE = 'TC_REPO_TYPE',
  TC_NEW_REPO_TYPE = 'TC_NEW_REPO_TYPE',
  TC_CALLABLE = 'TC_CALLABLE',
  TC_NOTICE_PERIOD_DAYS = 'TC_NOTICE_PERIOD_DAYS',
  TC_DEFAULT_NOTICE_TIME = 'TC_DEFAULT_NOTICE_TIME',
  TC_DEFAULT_NOTICE_PERIOD = 'TC_DEFAULT_NOTICE_PERIOD',
  TC_EX_DIVIDEND_DAYS = 'TC_EX_DIVIDEND_DAYS',
  TC_DEFAULT_REPO_TYPE = 'TC_DEFAULT_REPO_TYPE',
  TC_SUPPORT_REPO_TYPES = 'TC_SUPPORT_REPO_TYPES',
  TC_CALL_DAYS = 'TC_CALL_DAYS',
  TC_COLLATERAL_PRICE = 'TC_COLLATERAL_PRICE',
  TC_NEW_COLLATERAL_PRICE = 'TC_NEW_COLLATERAL_PRICE',
  TC_NEW_FACTOR = 'TC_NEW_FACTOR',
  TC_ABBR_COLLATERAL_PRICE = 'TC_ABBR_COLLATERAL_PRICE',
  TC_ALL_IN_PRICE = 'TC_ALL_IN_PRICE',
  TC_INDEX_RATIO = 'TC_INDEX_RATIO',
  TC_ABBR_ALL_IN_PRICE = 'TC_ABBR_ALL_IN_PRICE',
  TC_COLLATERAL_ACCRUED_INTEREST = 'TC_COLLATERAL_ACCRUED_INTEREST',
  TC_REPO_INTEREST = 'TC_REPO_INTEREST',
  TC_PREVIOUS_REPO_INTEREST = 'TC_PREVIOUS_REPO_INTEREST',
  TC_NEW_REPO_INTEREST = 'TC_NEW_REPO_INTEREST',
  TC_ABBR_COLLATERAL_ACCRUED_INTEREST = 'TC_ABBR_COLLATERAL_ACCRUED_INTEREST',
  TC_START_CONSIDERATION = 'TC_START_CONSIDERATION',
  TC_ABSOLUTE_CONSIDERATION = 'TC_ABSOLUTE_CONSIDERATION',
  TC_START_CONSIDERATION_ORIGINAL = 'TC_START_CONSIDERATION_ORIGINAL',
  TC_NEW_START_CONSIDERATION = 'TC_NEW_START_CONSIDERATION',
  TC_END_CONSIDERATION = 'TC_END_CONSIDERATION',
  TC_NEW_END_CONSIDERATION = 'TC_NEW_END_CONSIDERATION',
  TC_ABBR_START_CONSIDERATION = 'TC_ABBR_START_CONSIDERATION',
  TC_ABBR_START_CONSIDERATION_OVERRIDE = 'TC_ABBR_START_CONSIDERATION_OVERRIDE',
  TC_ABBR_END_CONSIDERATION = 'TC_ABBR_END_CONSIDERATION',
  TC_PRODUCT = 'TC_PRODUCT',
  TC_PRODUCT_NAME = 'TC_PRODUCT_NAME',
  TC_SECTOR_NAME = 'TC_SECTOR_NAME',
  TC_SECTOR_STATUS = 'TC_SECTOR_STATUS',
  TC_MARKET = 'TC_MARKET',
  TC_PRIMARY = 'TC_PRIMARY',
  TC_SECONDARY = 'TC_SECONDARY',
  TC_MARKET_TYPE = 'TC_MARKET_TYPE',
  TC_PRIMARY_MARKET = 'TC_PRIMARY_MARKET',
  TC_SECONDARY_MARKET = 'TC_SECONDARY_MARKET',
  TC_CREATED_BY = 'TC_CREATED_BY',
  TC_LAST_UPDATED_BY = 'TC_LAST_UPDATED_BY',
  TC_LAST_UPDATED_AT = 'TC_LAST_UPDATED_AT',
  TC_LAST_UPDATED_AT_DATE = 'TC_LAST_UPDATED_AT_DATE',
  TC_LAST_UPDATED_AT_TIME = 'TC_LAST_UPDATED_AT_TIME',
  TC_LAST_UPDATED_AT_DATE_AND_TIME = 'TC_LAST_UPDATED_AT_DATE_AND_TIME',
  TC_LAST_INITIATOR = 'TC_LAST_INITIATOR',
  TC_LAST_RESPONDER = 'TC_LAST_RESPONDER',
  TC_ORIGINATOR = 'TC_ORIGINATOR',
  TC_POSITION_ID = 'TC_POSITION_ID',
  TC_AXE_ROLL_UNWIND = 'TC_AXE_ROLL_UNWIND',
  TC_AXE_ROLL_UNWIND_SUMMARY = 'TC_AXE_ROLL_UNWIND_SUMMARY',
  TC_ROLL_UNWIND = 'TC_ROLL_UNWIND',
  TC_ROLL = 'TC_ROLL',
  TC_SUB = 'TC_SUB',
  TC_UNWIND = 'TC_UNWIND',
  TC_AXE = 'TC_AXE',
  TC_COUNTERPARTY_BIC = 'TC_COUNTERPARTY_BIC',
  TC_COUNTERPARTY_TRADER = 'TC_COUNTERPARTY_TRADER',
  TC_COUNTERPARTY_FIRM = 'TC_COUNTERPARTY_FIRM',
  TC_COUNTERPARTY_FIRM_LEI = 'TC_COUNTERPARTY_FIRM_LEI',
  TC_COUNTERPARTY_INVESTMENT_DECISION_MAKER = 'TC_COUNTERPARTY_INVESTMENT_DECISION_MAKER',
  TC_COUNTERPARTY_EXECUTION_DECISION_MAKER = 'TC_COUNTERPARTY_EXECUTION_DECISION_MAKER',
  TC_DEAL_ID = 'TC_DEAL_ID',
  TC_BLOCK_TRADE_ID = 'TC_BLOCK_TRADE_ID',
  TC_PARENT_DEAL_ID = 'TC_PARENT_DEAL_ID',
  TC_CHILD_DEAL_ID = 'TC_CHILD_DEAL_ID',
  TC_ORIGINAL_DEAL_ID = 'TC_ORIGINAL_DEAL_ID',
  TC_RFQ_ID = 'TC_RFQ_ID',
  TC_NEGOTIATION_ID = 'TC_NEGOTIATION_ID',
  TC_UTI = 'TC_UTI',
  TC_LEI = 'TC_LEI',
  TC_BIC = 'TC_BIC',
  TC_MIC = 'TC_MIC',
  TC_PRIMARY_MIC = 'TC_PRIMARY_MIC',
  TC_SECONDARY_MIC = 'TC_SECONDARY_MIC',
  TC_TRADER = 'TC_TRADER',
  TC_DEAL_DATE = 'TC_DEAL_DATE',
  TC_DEAL_TIME = 'TC_DEAL_TIME',
  TC_DEAL_TIMESTAMP = 'TC_DEAL_TIMESTAMP',
  TC_MASTER_LEGAL_AGREEMENT = 'TC_MASTER_LEGAL_AGREEMENT',
  TC_PRIMARY_SALES_COVER = 'TC_PRIMARY_SALES_COVER',
  TC_SECONDARY_SALES_COVER = 'TC_SECONDARY_SALES_COVER',
  TC_TRADING_ACTIVE = 'TC_TRADING_ACTIVE',
  TC_LOGGED_IN = 'TC_LOGGED_IN',
  TC_USER_NAME = 'TC_USER_NAME',
  TC_FIRST_NAME = 'TC_FIRST_NAME',
  TC_LAST_NAME = 'TC_LAST_NAME',
  TC_ORGANISATION = 'TC_ORGANISATION',
  TC_ORGANISATION_SHORT_CODE = 'TC_ORGANISATION_SHORT_CODE',
  TC_LEGAL_NAME = 'TC_LEGAL_NAME',
  TC_SHORT_ID = 'TC_SHORT_ID',
  TC_ORGANISATION_TYPES = 'TC_ORGANISATION_TYPES',
  TC_EMAIL_ENABLED = 'TC_EMAIL_ENABLED',
  TC_EMAIL = 'TC_EMAIL',
  TC_SFTP_ENABLED = 'TC_SFTP_ENABLED',
  TC_PHONE_NUMBER = 'TC_PHONE_NUMBER',
  TC_HAIRCUT_BAND_GREATER_THAN = 'TC_HAIRCUT_BAND_GREATER_THAN',
  TC_HAIRCUT_BAND_UNIQUE = 'TC_HAIRCUT_BAND_UNIQUE',
  TC_HAIRCUT_BAND_RANGE = 'TC_HAIRCUT_BAND_RANGE',
  TC_HAIRCUT_COLLATERAL_BAND_LESS_THAN = 'TC_HAIRCUT_COLLATERAL_BAND_LESS_THAN',
  TC_HAIRCUT_COLLATERAL_BAND_GREATER_THAN = 'TC_HAIRCUT_COLLATERAL_BAND_GREATER_THAN',
  TC_HAIRCUT_COLLATERAL_BAND_RANGE = 'TC_HAIRCUT_COLLATERAL_BAND_RANGE',
  TC_COUNTRY = 'TC_COUNTRY',
  TC_FIRST_SETTLEMENT_DATE = 'TC_FIRST_SETTLEMENT_DATE',
  TC_DIRTY_PRICE = 'TC_DIRTY_PRICE',
  TC_CLEAN_PRICE = 'TC_CLEAN_PRICE',
  TC_CLEAN_PRICE_UPDATED = 'TC_CLEAN_PRICE_UPDATED',
  TC_TICKET_SIZE = 'TC_TICKET_SIZE',
  TC_BASIS_CONVENTION = 'TC_BASIS_CONVENTION',
  TC_ACCRUED_INTEREST_DATE = 'TC_ACCRUED_INTEREST_DATE',
  TC_FIRST_COUPON_DATE = 'TC_FIRST_COUPON_DATE',
  TC_MATURITY_DATE = 'TC_MATURITY_DATE',
  TC_FREQUENCY = 'TC_FREQUENCY',
  TC_COUPON_TYPE = 'TC_COUPON_TYPE',
  TC_FIXED_RATE_PRICE = 'TC_FIXED_RATE_PRICE',
  TC_FIXED_RATE_WARN_LEVEL = 'TC_FIXED_RATE_WARN_LEVEL',
  TC_FIXED_RATE_RESTRICTION = 'TC_FIXED_RATE_RESTRICTION',
  TC_FLOAT_RATE_SPREAD = 'TC_FLOAT_RATE_SPREAD',
  TC_FLOAT_RATE_WARN_LEVEL = 'TC_FLOAT_RATE_WARN_LEVEL',
  TC_FLOAT_RATE_RESTRICTION = 'TC_FLOAT_RATE_RESTRICTION',
  TC_NOTIONAL_AMOUNT_WARN = 'TC_NOTIONAL_AMOUNT_WARN',
  TC_NOTIONAL_AMOUNT_RESTRICTION = 'TC_NOTIONAL_AMOUNT_RESTRICTION',
  TC_CASH_AMOUNT_WARN = 'TC_CASH_AMOUNT_WARN',
  TC_CASH_AMOUNT_RESTRICTION = 'TC_CASH_AMOUNT_RESTRICTION',
  TC_HOLIDAY = 'TC_HOLIDAY',
  TC_ALIAS = 'TC_ALIAS',
  TC_BASKET_ID = 'TC_BASKET_ID',
  TC_BASKET_NAME = 'TC_BASKET_NAME',
  TC_BASKET_TYPE = 'TC_BASKET_TYPE',
  TC_BASKET_CURRENCY = 'TC_BASKET_CURRENCY',
  TC_BASKET_DESCRIPTION = 'TC_BASKET_DESCRIPTION',
  TC_BASKET_CME_BASKET_REFERENCE = 'TC_BASKET_CME_BASKET_REFERENCE',
  TC_BASKET_DEAL_ID = 'TC_BASKET_DEAL_ID',
  TC_MINIMUM_CONCENTRATION_LEVEL = 'TC_MINIMUM_CONCENTRATION_LEVEL',
  TC_MAXIMUM_CONCENTRATION_LEVEL = 'TC_MAXIMUM_CONCENTRATION_LEVEL',
  TC_MINIMUM_AMOUNT = 'TC_MINIMUM_AMOUNT',
  TC_SUBSTITUTION_ALLOWED = 'TC_SUBSTITUTION_ALLOWED',
  TC_SUBSTITUTION_NUM = 'TC_SUBSTITUTION_NUM',
  TC_CALCULATE_ACCRUED_INTEREST = 'TC_CALCULATE_ACCRUED_INTEREST',
  TC_TO_DATE = 'TC_TO_DATE',
  TC_FROM_DATE = 'TC_FROM_DATE',
  TC_DBV_CLASS = 'TC_DBV_CLASS',
  TC_INDEX_DESCRIPTION = 'TC_INDEX_DESCRIPTION',
  TC_BLOOMBERG_CODE = 'TC_BLOOMBERG_CODE',
  TC_VALID_FOR = 'TC_VALID_FOR',
  TC_PRICE = 'TC_PRICE',
  TC_INVESTMENT_DECISION_MAKER = 'TC_INVESTMENT_DECISION_MAKER',
  TC_EXECUTION_DECISION_MAKER = 'TC_EXECUTION_DECISION_MAKER',
  TC_INVESTMENT_DECISION_MAKER_ABBR = 'TC_INVESTMENT_DECISION_MAKER_ABBR',
  TC_EXECUTION_DECISION_MAKER_ABBR = 'TC_EXECUTION_DECISION_MAKER_ABBR',
  TC_BEST_QUOTE_RECEIVED = 'TC_BEST_QUOTE_RECEIVED',
  TC_TRADE_TYPE = 'TC_TRADE_TYPE',
  TC_EVENT_TYPE = 'TC_EVENT_TYPE',
  TC_LIMIT = 'TC_LIMIT',
  TC_UTILISATION = 'TC_UTILISATION',
  TC_AVAILABLE = 'TC_AVAILABLE',
  TC_PRIMARY_COVER = 'TC_PRIMARY_COVER',
  TC_SECONDARY_COVER = 'TC_SECONDARY_COVER',
  TC_ACTION = 'TC_ACTION',
  TC_RESPONSE = 'TC_RESPONSE',
  TC_RFQ_TYPE = 'TC_RFQ_TYPE',
  TC_TRADING = 'TC_TRADING',
  TC_PLATFORM = 'TC_PLATFORM',
  TC_FISN = 'TC_FISN',
  TC_CFI = 'TC_CFI',
  TC_ACCRUAL_DATE = 'TC_ACCRUAL_DATE',
  TC_COLLATERAL_TYPE = 'TC_COLLATERAL_TYPE',
  TC_INDEX = 'TC_INDEX',
  TC_INDEX_LAG = 'TC_INDEX_LAG',
  TC_BASE_INDEX_VALUE = 'TC_BASE_INDEX_VALUE',
  TC_ALLOW_PARTIAL = 'TC_ALLOW_PARTIAL',
  TC_TOTAL_FILL_NOTIONAL = 'TC_TOTAL_FILL_NOTIONAL',
  TC_TARGET_FILL_NOTIONAL = 'TC_TARGET_FILL_NOTIONAL',
  TC_TOTAL_FILL_START_CONSIDERATION = 'TC_TOTAL_FILL_START_CONSIDERATION',
  TC_TARGET_FILL_START_CONSIDERATION = 'TC_TARGET_FILL_START_CONSIDERATION',
  TC_PRE_AGREED = 'TC_PRE_AGREED',
  TC_PERMISSION = 'TC_PERMISSION',
  TC_RELATIONSHIP_ACTION = 'TC_RELATIONSHIP_ACTION',
  TC_BUY_ORGANISATION = 'TC_BUY_ORGANISATION',
  TC_BUY_TRADING_ENTITY = 'TC_BUY_TRADING_ENTITY',
  TC_SELL_ORGANISATION = 'TC_SELL_ORGANISATION',
  TC_SELL_TRADING_ENTITY = 'TC_SELL_TRADING_ENTITY',
  TC_US_SC_ENABLED = 'TC_US_SC_ENABLED',
  TC_US_SC_DEFAULT = 'TC_US_SC_DEFAULT',
  TC_CURRENCY_PAIR = 'TC_CURRENCY_PAIR',
  TC_FX_RATE = 'TC_FX_RATE',
  TC_DATE_TIME_UPDATED = 'TC_DATE_TIME_UPDATED',
  TC_ORGANISATION_META_ALL_VALUES = 'TC_ORGANISATION_META_ALL_VALUES',
  TC_SETTLEMENT_TYPE = 'TC_SETTLEMENT_TYPE',
  TC_EXTERNAL_NEGOTIATION_ID = 'TC_EXTERNAL_NEGOTIATION_ID',
  TC_EXTERNAL_ORDER_ID = 'TC_EXTERNAL_ORDER_ID',
  TC_ORDER_ID = 'TC_ORDER_ID',
  TC_EXTERNAL_QUOTE_ID = 'TC_EXTERNAL_QUOTE_ID',
  TC_EXTERNAL_QUOTE_RESPONSE_ID = 'TC_EXTERNAL_QUOTE_RESPONSE_ID',
  TC_START_CONSIDERATION_OVERRIDE_THRESHOLD = 'TC_START_CONSIDERATION_OVERRIDE_THRESHOLD',
  TC_START_CONSIDERATION_OVERRIDE = 'TC_START_CONSIDERATION_OVERRIDE',
  TC_NEW_START_CONSIDERATION_OVERRIDE = 'TC_NEW_START_CONSIDERATION_OVERRIDE',
  TC_OKTA_STATUS = 'TC_OKTA_STATUS',
  TC_OKTA_LAST_LOGIN = 'TC_OKTA_LAST_LOGIN',
  TC_FEE = 'TC_FEE',
  TC_MY_ENTITY_SHORT_NAME = 'TC_MY_ENTITY_SHORT_NAME',
  TC_MY_FICC_ENTITY_SHORT_NAME = 'TC_MY_FICC_ENTITY_SHORT_NAME',
  TC_BATCH_ID = 'TC_BATCH_ID',
  TC_LAG_AMOUNT = 'TC_LAG_AMOUNT',
  TC_LAG_TYPE = 'TC_LAG_TYPE',
  TC_START_TIME = 'TC_START_TIME',
  TC_PRIMARY_START_TIME = 'TC_PRIMARY_START_TIME',
  TC_SECONDARY_START_TIME = 'TC_SECONDARY_START_TIME',
  TC_TIME_ZONE = 'TC_TIME_ZONE',
  TC_PRIMARY_TIME_ZONE = 'TC_PRIMARY_TIME_ZONE',
  TC_SECONDARY_TIME_ZONE = 'TC_SECONDARY_TIME_ZONE',
  TC_TRADING_STATUS = 'TC_TRADING_STATUS',
  TC_PRIMARY_TRADING_STATUS = 'TC_PRIMARY_TRADING_STATUS',
  TC_SECONDARY_TRADING_STATUS = 'TC_SECONDARY_TRADING_STATUS',
  TC_ISSUER_ORG_NAME = 'TC_ISSUER_ORG_NAME',
  TC_ULTIMATE_PARENT_ORG_ID = 'TC_ULTIMATE_PARENT_ORG_ID',
  TC_ULTIMATE_PARENT_NAME = 'TC_ULTIMATE_PARENT_NAME',
  TC_ULTIMATE_PARENT_LEI = 'TC_ULTIMATE_PARENT_LEI',
  TC_ULTIMATE_PARENT_PERM_ID = 'TC_ULTIMATE_PARENT_PERM_ID',
  TC_TRADED_ON_US_EXCHANGE = 'TC_TRADED_ON_US_EXCHANGE',
  TC_SANCTIONED_SCREENED = 'TC_SANCTIONED_SCREENED',
  TC_COMPLIANCE_SUSPENDED = 'TC_COMPLIANCE_SUSPENDED',
  TC_COMPLIANCE_EUROPE = 'TC_COMPLIANCE_EUROPE',
  TC_MARKET_TRADE_DATE = 'TC_MARKET_TRADE_DATE',
  TC_MARKET_MID_TRADE_DATE = 'TC_MARKET_MID_TRADE_DATE',
  TC_TRADING_LIMIT = 'TC_TRADING_LIMIT',
  TC_GROSS_UTILISATION = 'TC_GROSS_UTILISATION',
  TC_GROSS_AVAILABLE = 'TC_GROSS_AVAILABLE',
  TC_NET_UTILISATION = 'TC_NET_UTILISATION',
  TC_NET_AVAILABLE_BUY = 'TC_NET_AVAILABLE_BUY',
  TC_NET_AVAILABLE_SELL = 'TC_NET_AVAILABLE_SELL',
  TC_USER_LIMITS = 'TC_USER_LIMITS',
  TC_FAT_FINGER_LIMITS = 'TC_FAT_FINGER_LIMITS',
  TC_TRADING_LIMIT_TYPE = 'TC_TRADING_LIMIT_TYPE',
  TC_APPLY_FAT_FINGER_LIMITS = 'TC_APPLY_FAT_FINGER_LIMITS',
  TC_ADD_FAT_FINGER_LIMITS = 'TC_ADD_FAT_FINGER_LIMITS',
  // renderers
  // * Actions column renderer
  TC_ACTION_ADD_ASSETS = 'TC_ACTION_ADD_ASSETS',
  TC_ACTION_UPLOAD_SPREADSHEET = 'TC_ACTION_UPLOAD_SPREADSHEET',
  TC_ACTION_UPLOAD_PRICES = 'TC_ACTION_UPLOAD_PRICES',
  TC_ACTION_UPLOAD_EVENTS = 'TC_ACTION_UPLOAD_EVENTS',
  TC_ACTION_UPLOAD_RESPONSES = 'TC_ACTION_UPLOAD_RESPONSES',
  TC_ACTION_UPLOAD_TRADING_ENTITIES = 'TC_ACTION_UPLOAD_TRADING_ENTITIES',
  TC_ACTION_UPLOAD_TRADING_ENTITY_PRODUCTS = 'TC_ACTION_UPLOAD_TRADING_ENTITY_PRODUCTS',
  TC_ACTION_UPLOAD_TRADING_RELATIONSHIPS = 'TC_ACTION_UPLOAD_TRADING_RELATIONSHIPS',
  TC_ACTION_DOWNLOAD_SPREADSHEET = 'TC_ACTION_DOWNLOAD_SPREADSHEET',
  TC_ACTION_DOWNLOAD_RESPONSE_SPREADSHEET = 'TC_ACTION_DOWNLOAD_RESPONSE_SPREADSHEET',
  TC_ACTION_DOWNLOAD_TRADING_ENTITIES_SPREADSHEET = 'TC_ACTION_DOWNLOAD_TRADING_ENTITIES_SPREADSHEET',
  TC_ACTION_DOWNLOAD_TRADING_ENTITY_PRODUCTS_SPREADSHEET = 'TC_ACTION_DOWNLOAD_TRADING_ENTITY_PRODUCTS_SPREADSHEET',
  TC_ACTION_DOWNLOAD_TRADING_RELATIONSHIPS_SPREADSHEET = 'TC_ACTION_DOWNLOAD_TRADING_RELATIONSHIPS_SPREADSHEET',
  TC_ACTION_PREPARE = 'TC_ACTION_PREPARE',
  TC_ACTION_STOP_PREPARE = 'TC_ACTION_STOP_PREPARE',
  TC_ACTION_DELETE = 'TC_ACTION_DELETE',
  TC_ACTION_CLONE = 'TC_ACTION_CLONE',
  TC_ACTION_ASSIGN_COLLECTION = 'TC_ACTION_ASSIGN_COLLECTION',
  TC_ACTION_REMOVE_COLLECTION = 'TC_ACTION_REMOVE_COLLECTION',
  TC_ACTION_BULK_PRICE = 'TC_ACTION_BULK_PRICE',
  TC_ACTION_SEND = 'TC_ACTION_SEND',
  TC_ACTION_SEND_QUOTE = 'TC_ACTION_SEND_QUOTE',
  TC_ACTION_COUNTER = 'TC_ACTION_COUNTER',
  TC_ACTION_UNDO = 'TC_ACTION_UNDO',
  TC_ACTION_ACCEPT = 'TC_ACTION_ACCEPT',
  TC_ACTION_ACCEPT_NEW = 'TC_ACTION_ACCEPT_NEW',
  TC_ACTION_ACCEPT_COUNTER = 'TC_ACTION_ACCEPT_COUNTER',
  TC_ACTION_REJECT = 'TC_ACTION_REJECT',
  TC_ACTION_WITHDRAW = 'TC_ACTION_WITHDRAW',
  TC_ACTION_ACCEPT_COUNTERPARTY = 'TC_ACTION_ACCEPT_COUNTERPARTY',
  TC_ACTION_CANCEL_RFQ = 'TC_ACTION_CANCEL_RFQ',
  TC_ACTION_CANCEL_ALL = 'TC_ACTION_CANCEL_ALL',
  TC_ACTION_BACK_TO_STAGING = 'TC_ACTION_BACK_TO_STAGING',
  TC_ACTION_BACK_TO_STAGING_ALL = 'TC_ACTION_BACK_TO_STAGING_ALL',
  TC_ACTION_CANCEL_TRADE = 'TC_ACTION_CANCEL_TRADE',
  TC_ACTION_RETRY_TRADE = 'TC_ACTION_RETRY_TRADE',
  TC_ACTION_COMPLETE_TRADE = 'TC_ACTION_COMPLETE_TRADE',
  TC_ACTION_REFRESH = 'TC_ACTION_REFRESH',
  TC_ACTION_OPEN_TICKET = 'TC_ACTION_OPEN_TICKET',
  TC_ACTION_START_AMEND = 'TC_ACTION_START_AMEND',
  TC_ACTION_STOP_AMEND = 'TC_ACTION_STOP_AMEND',
  TC_ACTION_FORCE_STOP_AMEND = 'TC_ACTION_FORCE_STOP_AMEND',
  TC_ACTION_AMEND = 'TC_ACTION_AMEND',
  TC_ACTION_AMEND_TRADE = 'TC_ACTION_AMEND_TRADE',
  TC_ACTION_SUSPEND_TRADING = 'TC_ACTION_SUSPEND_TRADING',
  TC_ACTION_ACTIVATE_TRADING = 'TC_ACTION_ACTIVATE_TRADING',
  TC_ACTION_SUSPEND_TRADING_EU = 'TC_ACTION_SUSPEND_TRADING_EU',
  TC_ACTION_ACTIVATE_TRADING_EU = 'TC_ACTION_ACTIVATE_TRADING_EU',
  TC_ACTION_SUSPEND_TRADING_US = 'TC_ACTION_SUSPEND_TRADING_US',
  TC_ACTION_ACTIVATE_TRADING_US = 'TC_ACTION_ACTIVATE_TRADING_US',
  TC_ACTION_END_DAY_EU = 'TC_ACTION_END_DAY_EU',
  TC_ACTION_START_DAY_EU = 'TC_ACTION_START_DAY_EU',
  TC_ACTION_START_DAY_EU_TOMORROW = 'TC_ACTION_START_DAY_EU_TOMORROW',
  TC_ACTION_END_DAY_US = 'TC_ACTION_END_DAY_US',
  TC_ACTION_START_DAY_US = 'TC_ACTION_START_DAY_US',
  TC_ACTION_PRE_START_DAY_US = 'TC_ACTION_PRE_START_DAY_US',
  TC_ACTION_VIEW_DETAILS = 'TC_ACTION_VIEW_DETAILS',
  TC_ACTION_EDIT_DETAILS = 'TC_ACTION_EDIT_DETAILS',
  TC_ACTION_EDIT = 'TC_ACTION_EDIT',
  TC_ACTION_ORDER_RECORD_KEEPING_DUMP = 'TC_ACTION_ORDER_RECORD_KEEPING_DUMP',
  TC_ACTION_TRANSACTION_REPORTING_DUMP = 'TC_ACTION_TRANSACTION_REPORTING_DUMP',
  TC_ACTION_REFINITIV_IMPORT_REPORT = 'TC_ACTION_REFINITIV_IMPORT_REPORT',
  TC_ACTION_NEGOTIATION_EXPORT_DUMP = 'TC_ACTION_NEGOTIATION_EXPORT_DUMP',
  TC_ACTION_DEAL_EXPORT_DUMP = 'TC_ACTION_DEAL_EXPORT_DUMP',
  TC_ACTION_PERMISSIONS_REPORT = 'TC_ACTION_PERMISSIONS_REPORT',
  TC_ACTION_PURGE_ENTITY = 'TC_ACTION_PURGE_ENTITY',
  TC_ACTION_SOTW = 'TC_ACTION_SOTW',
  TC_ACTION_CALCULATE_END_CONSIDERATION = 'TC_ACTION_CALCULATE_END_CONSIDERATION',
  TC_ACTION_COMPLETE_DEALS = 'TC_ACTION_COMPLETE_DEALS',
  TC_ACTION_FAILED_EXPORTS_RETRY = 'TC_ACTION_FAILED_EXPORTS_RETRY',
  TC_ACTION_FAILED_EXPORTS_DELETE = 'TC_ACTION_FAILED_EXPORTS_DELETE',
  TC_ACTION_PURGE_TRADE_DATA = 'TC_ACTION_PURGE_TRADE_DATA',
  TC_ACTION_RESET_TEST_DATA = 'TC_ACTION_RESET_TEST_DATA',
  TC_ACTION_EOD_PURGE = 'TC_ACTION_EOD_PURGE',
  TC_ACTION_SET_CURRENT_TRADE_DATE = 'TC_ACTION_SET_CURRENT_TRADE_DATE',
  TC_ACTION_SET_CURRENT_TRADE_DATE_TO_PREVIOUS_BUSINESS_DAY = 'TC_ACTION_SET_CURRENT_TRADE_DATE_TO_PREVIOUS_BUSINESS_DAY',
  TC_ACTION_SKIP_HOLIDAYS = 'TC_ACTION_SKIP_HOLIDAYS',
  TC_ACTION_TRIGGER_FIRDS_REPORT = 'TC_ACTION_TRIGGER_FIRDS_REPORT',
  TC_ACTION_TRIGGER_BOND_NOTE_UPDATE = 'TC_ACTION_TRIGGER_BOND_NOTE_UPDATE',
  TC_ACTION_TRIGGER_INCREMENT_IDS = 'TC_ACTION_TRIGGER_INCREMENT_IDS',
  TC_ACTION_TRIGGER_OKTA_USERS_REPORT = 'TC_ACTION_TRIGGER_OKTA_USERS_REPORT',
  TC_ACTION_TRIGGER_UPDATE_MORTGAGE_FACTORS = 'TC_ACTION_TRIGGER_UPDATE_MORTGAGE_FACTORS',
  TC_ACTION_TRIGGER_COLLATERAL_MIGRATION = 'TC_ACTION_TRIGGER_COLLATERAL_MIGRATION',
  TC_ACTION_TRIGGER_COLLATERAL_CLEAR_TRADE_DATE = 'TC_ACTION_TRIGGER_COLLATERAL_CLEAR_TRADE_DATE',
  TC_ACTION_TRIGGER_GENERATE_SCHEDULE_REPORT = 'TC_ACTION_TRIGGER_GENERATE_SCHEDULE_REPORT',
  TC_ACTION_TRIGGER_REFINITIV_PRICE_REQUEST = 'TC_ACTION_TRIGGER_REFINITIV_PRICE_REQUEST',
  TC_ACTION_TRIGGER_REFINITIV_COLLATERAL_REQUEST = 'TC_ACTION_TRIGGER_REFINITIV_COLLATERAL_REQUEST',
  TC_ACTION_TRIGGER_REFINITIV_RIC_CODE_REQUEST = 'TC_ACTION_TRIGGER_REFINITIV_RIC_CODE_REQUEST',
  TC_ACTION_TRIGGER_REFINITIV_ISSUER_REFRESH_REQUEST = 'TC_ACTION_TRIGGER_REFINITIV_ISSUER_REFRESH_REQUEST',
  TC_ACTION_TRIGGER_REFINITIV_NEW_FIELDS_REQUEST = 'TC_ACTION_TRIGGER_REFINITIV_NEW_FIELDS_REQUEST',
  TC_ACTION_TRIGGER_REFINITIV_CORPS_REFRESH_REQUEST = 'TC_ACTION_TRIGGER_REFINITIV_CORPS_REFRESH_REQUEST',
  TC_ACTION_ENABLE = 'TC_ACTION_ENABLE',
  TC_ACTION_DISABLE = 'TC_ACTION_DISABLE',
  TC_ACTION_SUSPEND = 'TC_ACTION_SUSPEND',
  TC_ACTION_ACTIVATE = 'TC_ACTION_ACTIVATE',
  TC_ACTION_OPEN_PROFILE = 'TC_ACTION_OPEN_PROFILE',
  TC_ACTION_CLOSE_PROFILE = 'TC_ACTION_CLOSE_PROFILE',
  TC_ACTION_USER_PREFERENCES = 'TC_ACTION_USER_PREFERENCES',
  TC_ACTION_ABOUT = 'TC_ACTION_ABOUT',
  TC_ACTION_LOGOUT = 'TC_ACTION_LOGOUT',
  TC_ACTION_SIGN_OUT_USER = 'TC_ACTION_SIGN_OUT_USER',
  TC_ACTION_SHOW_CLEARING_INFO = 'TC_ACTION_SHOW_CLEARING_INFO',
  TC_ACTION_SEND_DIAGNOSTICS = 'TC_ACTION_SEND_DIAGNOSTICS',
  TC_ACTION_STAGE = 'TC_ACTION_STAGE',
  TC_ACTION_ASSIGN = 'TC_ACTION_ASSIGN',
  TC_ACTION_ALLOCATE_COLLATERAL = 'TC_ACTION_ALLOCATE_COLLATERAL',
  TC_ACTION_EXTEND_ALLOCATION_TIME = 'TC_ACTION_EXTEND_ALLOCATION_TIME',
  TC_ACTION_SUBSTITUTE = 'TC_ACTION_SUBSTITUTE',
  TC_ACTION_RERATE = 'TC_ACTION_RERATE',
  TC_ACTION_CLOSE_OPEN = 'TC_ACTION_CLOSE_OPEN',
  TC_ACTION_RETURN_RECALL = 'TC_ACTION_RETURN_RECALL',
  TC_ACTION_TERMINATE = 'TC_ACTION_TERMINATE',
  TC_ACTION_ROLL_IN_PLACE = 'TC_ACTION_ROLL_IN_PLACE',
  TC_ACTION_CANCEL = 'TC_ACTION_CANCEL',
  TC_ACTION_REJECT_TERMINATE = 'TC_ACTION_REJECT_TERMINATE',
  TC_ACTION_REJECT_RERATE = 'TC_ACTION_REJECT_RERATE',
  TC_ACTION_BULK_APPLY = 'TC_ACTION_BULK_APPLY',
  TC_ACTION_UPDATE_FROM_RIFINITIV = 'TC_ACTION_UPDATE_FROM_RIFINITIV',
  TC_ACTION_TRADE_HISTORY = 'TC_ACTION_TRADE_HISTORY',
  SC_ACTION_NOT_BEST_PRICE = 'SC_ACTION_NOT_BEST_PRICE',
  SC_ACTION_PRICE_MATCHED = 'SC_ACTION_PRICE_MATCHED',
  SC_CANCEL_RFQS = 'SC_CANCEL_RFQS',
  TC_SPLIT_TRADES = 'TC_SPLIT_TRADES',
  TC_SPLIT_TRADE_AMOUNT = 'TC_SPLIT_TRADE_AMOUNT',
  TC_ACTION_ROLL = 'TC_ACTION_ROLL',
  TC_LINKED_TRADE_ID = 'TC_LINKED_TRADE_ID',
  TC_INFLIGHT = 'TC_INFLIGHT',

  // context menus
  TC_CONTEXT_MENU_PIN = 'TC_CONTEXT_MENU_PIN',
  TC_CONTEXT_MENU_UNPIN = 'TC_CONTEXT_MENU_UNPIN',
  TC_CONTEXT_MENU_MOVE_DOWN = 'TC_CONTEXT_MENU_MOVE_DOWN',
  TC_CONTEXT_MENU_MOVE_UP = 'TC_CONTEXT_MENU_MOVE_UP',
  TC_CONTEXT_MENU_MOVE_TO_TOP = 'TC_CONTEXT_MENU_MOVE_TO_TOP',
  TC_CONTEXT_MENU_MOVE_TO_BOTTOM = 'TC_CONTEXT_MENU_MOVE_TO_BOTTOM',

  // action tooltips
  SC_MAX_ORDERS_ACTIONS_TOOLTIP = 'SC_MAX_ORDERS_ACTIONS_TOOLTIP',
  SC_MAX_ORDERS_PREPARE_TOOLTIP = 'SC_MAX_ORDERS_PREPARE_TOOLTIP',
  SC_MAX_COLLECTION_SIZE_TOOLTIP = 'SC_MAX_COLLECTION_SIZE_TOOLTIP',
  SC_MAX_NAMED_COLLECTION_SIZE_TOOLTIP = 'SC_MAX_NAMED_COLLECTION_SIZE_TOOLTIP',

  // Multiple notional renderer
  TC_MULTIPLE_NOTIONAL_MULTIPLE = 'TC_MULTIPLE_NOTIONAL_MULTIPLE',

  // * Axe and trade condition renderer
  TC_AXED = 'TC_AXED',

  // lock
  SC_UNLOCKED = 'SC_UNLOCKED',
  SC_LOCKED_TO = 'SC_LOCKED_TO',

  // otw timer
  SC_AS_RFQ = 'SC_AS_RFQ',
  SC_LAST_LOOK = 'SC_LAST_LOOK',

  // delta
  SC_DELTA_DAYS = 'SC_DELTA_DAYS',

  // error messages
  SC_MISSING_MANDATORY = 'SC_MISSING_MANDATORY',
  SC_INVALID_VALUE = 'SC_INVALID_VALUE',
  SC_GENERIC_ERROR = 'SC_GENERIC_ERROR',
  SC_INVALID_OTW = 'SC_INVALID_OTW',
  SC_SUBSCRIPTION_RESPONSE_ERROR = 'SC_SUBSCRIPTION_RESPONSE_ERROR',
  SC_SUBSCRIPTION_RESPONSE_TOO_LARGE_ERROR = 'SC_SUBSCRIPTION_RESPONSE_TOO_LARGE_ERROR',

  // boolean values
  TC_TRUE = 'TC_TRUE',
  TC_FALSE = 'TC_FALSE',

  // Initiated screen views
  TC_GRID_DEFAULT = 'TC_GRID_DEFAULT',
  TC_GRID_COUNTERPARTY = 'TC_GRID_COUNTERPARTY',

  // Grid view screen
  SC_NOT_AVAILABLE_FOR_THIS_PROFILE = 'SC_NOT_AVAILABLE_FOR_THIS_PROFILE',

  // Sector mapping screen
  TC_SECTOR_MAPPING_RULE_NAME = 'TC_SECTOR_MAPPING_RULE_NAME',
  TC_SECTOR_MAPPING_DEBT_TYPE = 'TC_SECTOR_MAPPING_DEBT_TYPE',
  TC_SECTOR_MAPPING_GOVERNMENT_BOND_TYPE = 'TC_SECTOR_MAPPING_GOVERNMENT_BOND_TYPE',
  TC_SECTOR_MAPPING_NOT_GOVERNMENT_BOND_TYPE = 'TC_SECTOR_MAPPING_NOT_GOVERNMENT_BOND_TYPE',
  TC_SECTOR_MAPPING_HAS_CUSIP = 'TC_SECTOR_MAPPING_HAS_CUSIP',
  TC_SECTOR_MAPPING_RULE_ID = 'TC_SECTOR_MAPPING_RULE_ID',
  TC_SECTOR_CURRENT_MAPPINGS = 'TC_SECTOR_CURRENT_MAPPINGS',
  TC_SECTOR_DRAFT_MAPPINGS = 'TC_SECTOR_DRAFT_MAPPINGS',
  TC_SECTOR_CREATE_MAPPINGS = 'TC_SECTOR_CREATE_MAPPINGS',
  TC_SECTOR_EDIT_MAPPINGS = 'TC_SECTOR_EDIT_MAPPINGS',
  TC_SECTOR_COMMIT_MAPPINGS = 'TC_SECTOR_COMMIT_MAPPINGS',
  TC_SECTOR_DISCARD_MAPPINGS = 'TC_SECTOR_DISCARD_MAPPINGS',
  // Trade Condition
  SC_NONE = 'SC_NONE',
  SC_ROLL = 'SC_ROLL',
  SC_UNWIND = 'SC_UNWIND',
  SC_SUB = 'SC_SUB',

  // Repo Type
  TC_REPO_TYPE_BSB = 'TC_REPO_TYPE_BSB',
  TC_REPO_TYPE_CLASSIC = 'TC_REPO_TYPE_CLASSIC',
  TC_REPO_TYPE_STOCK_BORROWING_LENDING = 'TC_REPO_TYPE_STOCK_BORROWING_LENDING',

  // Direction
  TC_BUY = 'TC_BUY',
  TC_SELL = 'TC_SELL',
  TC_REV_REPO = 'TC_REV_REPO',
  TC_REPO = 'TC_REPO',
  TC_BID = 'TC_BID',
  TC_OFFER = 'TC_OFFER',
  TC_BORROW = 'TC_BORROW',
  TC_LEND = 'TC_LEND',
  TC_MULTI = 'TC_MULTI',

  // Collection Type
  TC_ALL_OR_NOTHING = 'TC_ALL_OR_NOTHING',
  TC_NON_CONTINGENT = 'TC_NON_CONTINGENT',
  TC_SEND_INDIVIDUALLY = 'TC_SEND_INDIVIDUALLY',
  TC_SEND_INDIVIDUALLY_ABBR = 'TC_SEND_INDIVIDUALLY_ABBR',
  TC_ONE_CANCELS_OTHERS = 'TC_ONE_CANCELS_OTHERS',
  TC_SMART_GROUPING = 'TC_SMART_GROUPING',
  TC_ALL_OR_NOTHING_COLLECTION = 'TC_ALL_OR_NOTHING_COLLECTION',
  TC_ALL_OR_NOTHING_X = 'TC_ALL_OR_NOTHING_X',

  // Organisation Type
  SC_BUY_SIDE = 'SC_BUY_SIDE',
  SC_SELL_SIDE = 'SC_SELL_SIDE',

  // Collateral Type
  TC_COLLATERAL_TYPE_STANDARD = 'TC_COLLATERAL_TYPE_STANDARD',
  TC_COLLATERAL_TYPE_INDEX_LINKED = 'TC_COLLATERAL_TYPE_INDEX_LINKED',

  // Coupon Type
  TC_FIXED = 'TC_FIXED',
  TC_FLOATING = 'TC_FLOATING',

  // Coupon Frequency
  TC_ANNUAL = 'TC_ANNUAL',
  TC_SEMI_ANNUAL = 'TC_SEMI_ANNUAL',
  TC_QUARTERLY = 'TC_QUARTERLY',
  TC_MONTHLY = 'TC_MONTHLY',

  // Trading Entity Type
  TC_STANDARD = 'TC_STANDARD',
  TC_BLOCK = 'TC_BLOCK',
  TC_BOTH = 'TC_BOTH',

  // Index Lag
  TC_INDEX_LAG_THREE_MONTHS = 'TC_INDEX_LAG_THREE_MONTHS',
  TC_INDEX_LAG_EIGHT_MONTHS = 'TC_INDEX_LAG_EIGHT_MONTHS',

  // other
  UC_NOT_APPLICABLE = 'UC_NOT_APPLICABLE',
  SC_MULTIPLE = 'SC_MULTIPLE',
  TC_PRE_ASSIGNED = 'TC_PRE_ASSIGNED',

  // Derived data columns
  TC_COUNT = 'TC_COUNT',

  // Repo Classification
  TC_REPO_CLASSIFICATION_FIXED = 'TC_REPO_CLASSIFICATION_FIXED',
  TC_REPO_CLASSIFICATION_OPEN = 'TC_REPO_CLASSIFICATION_OPEN',
  TC_REPO_CLASSIFICATION_OPEN_EVERGREEN = 'TC_REPO_CLASSIFICATION_OPEN_EVERGREEN',

  // Currency types
  TC_CURRENCY_AUD = 'TC_CURRENCY_AUD',
  TC_CURRENCY_CAD = 'TC_CURRENCY_CAD',
  TC_CURRENCY_DKK = 'TC_CURRENCY_DKK',
  TC_CURRENCY_EUR = 'TC_CURRENCY_EUR',
  TC_CURRENCY_GBP = 'TC_CURRENCY_GBP',
  TC_CURRENCY_JPY = 'TC_CURRENCY_JPY',
  TC_CURRENCY_SEK = 'TC_CURRENCY_SEK',
  TC_CURRENCY_USD = 'TC_CURRENCY_USD',
  TC_CURRENCY_NZD = 'TC_CURRENCY_NZD',
  TC_CURRENCY_CHF = 'TC_CURRENCY_CHF',
  TC_CURRENCY_NOK = 'TC_CURRENCY_NOK',
  TC_CURRENCY_HUF = 'TC_CURRENCY_HUF',
  TC_CURRENCY_PLN = 'TC_CURRENCY_PLN',
  TC_CURRENCY_ZAR = 'TC_CURRENCY_ZAR',
  TC_CURRENCY_SGD = 'TC_CURRENCY_SGD',
  TC_CURRENCY_ARS = 'TC_CURRENCY_ARS',
  TC_CURRENCY_BRL = 'TC_CURRENCY_BRL',
  TC_CURRENCY_CLP = 'TC_CURRENCY_CLP',
  TC_CURRENCY_COP = 'TC_CURRENCY_COP',
  TC_CURRENCY_MXN = 'TC_CURRENCY_MXN',
  TC_CURRENCY_VEF = 'TC_CURRENCY_VEF',

  TC_CURRENCY_CZK = 'TC_CURRENCY_CZK',
  TC_CURRENCY_AED = 'TC_CURRENCY_AED',
  TC_CURRENCY_TRY = 'TC_CURRENCY_TRY',
  TC_CURRENCY_KRW = 'TC_CURRENCY_KRW',
  TC_CURRENCY_ILS = 'TC_CURRENCY_ILS',
  TC_CURRENCY_BGN = 'TC_CURRENCY_BGN',
  TC_CURRENCY_ISK = 'TC_CURRENCY_ISK',
  TC_CURRENCY_RON = 'TC_CURRENCY_RON',
  TC_CURRENCY_QAR = 'TC_CURRENCY_QAR',
  TC_CURRENCY_HKD = 'TC_CURRENCY_HKD',
  TC_CURRENCY_KWD = 'TC_CURRENCY_KWD',
  TC_CURRENCY_BHD = 'TC_CURRENCY_BHD',
  TC_CURRENCY_CNH = 'TC_CURRENCY_CNH',
  TC_CURRENCY_CNY = 'TC_CURRENCY_CNY',
  TC_CURRENCY_EGP = 'TC_CURRENCY_EGP',
  TC_CURRENCY_IDR = 'TC_CURRENCY_IDR',
  TC_CURRENCY_INR = 'TC_CURRENCY_INR',
  TC_CURRENCY_JOD = 'TC_CURRENCY_JOD',
  TC_CURRENCY_KZT = 'TC_CURRENCY_KZT',
  TC_CURRENCY_MAD = 'TC_CURRENCY_MAD',
  TC_CURRENCY_MYR = 'TC_CURRENCY_MYR',
  TC_CURRENCY_PEN = 'TC_CURRENCY_PEN',
  TC_CURRENCY_PHP = 'TC_CURRENCY_PHP',
  TC_CURRENCY_PYG = 'TC_CURRENCY_PYG',
  TC_CURRENCY_RUB = 'TC_CURRENCY_RUB',
  TC_CURRENCY_SAR = 'TC_CURRENCY_SAR',
  TC_CURRENCY_SDG = 'TC_CURRENCY_SDG',
  TC_CURRENCY_THB = 'TC_CURRENCY_THB',
  TC_CURRENCY_TND = 'TC_CURRENCY_TND',
  TC_CURRENCY_TWD = 'TC_CURRENCY_TWD',
  TC_CURRENCY_UAH = 'TC_CURRENCY_UAH',
  TC_CURRENCY_UYU = 'TC_CURRENCY_UYU',
  TC_CURRENCY_VND = 'TC_CURRENCY_VND',

  // Market
  TC_MARKET_EUROPE = 'TC_MARKET_EUROPE',
  TC_MARKET_US = 'TC_MARKET_US',

  // Mid trade event action
  TC_MTE_CLOSE = 'TC_MTE_CLOSE',
  TC_MTE_RESIZE = 'TC_MTE_RESIZE',
  TC_MTE_REPRICE = 'TC_MTE_REPRICE',
  TC_MTE_ROLL = 'TC_MTE_ROLL',

  // RFQ Type
  TC_RFQ_TYPE_FIRM = 'TC_RFQ_TYPE_FIRM',
  TC_RFQ_TYPE_INDICATIVE = 'TC_RFQ_TYPE_INDICATIVE',

  // Callable Type
  TC_CALLABLE_TYPE_BILATERAL = 'TC_CALLABLE_TYPE_BILATERAL',
  TC_CALLABLE_TYPE_UNILATERAL = 'TC_CALLABLE_TYPE_UNILATERAL',

  // Notification preference type
  TC_USERS_SALES_COVER_ONLY = 'TC_USERS_SALES_COVER_ONLY',

  // Ex dividend day convention
  TC_BUSINESS_DAYS = 'TC_BUSINESS_DAYS',
  TC_CALENDAR_DAYS = 'TC_CALENDAR_DAYS',

  // Haircut type
  TC_HAIRCUT_TYPE_HAIRCUT = 'TC_HAIRCUT_TYPE_HAIRCUT',
  TC_HAIRCUT_TYPE_COLLATERAL = 'TC_HAIRCUT_TYPE_COLLATERAL',

  // Haircut sign
  TC_ACTUAL_SELL_SIDE = 'TC_ACTUAL_SELL_SIDE',
  TC_DIRECTIONAL = 'TC_DIRECTIONAL',
  TC_ABSOLUTE = 'TC_ABSOLUTE',
  TC_NEGATIVE_REV_REPO = 'TC_NEGATIVE_REV_REPO',

  // Date picker
  SC_UNRECOGNISED_DATE_FORMAT = 'SC_UNRECOGNISED_DATE_FORMAT',
  SC_DATE_NOT_ALLOWED = 'SC_DATE_NOT_ALLOWED',
  SC_DATE_MUST_BE_AFTER = 'SC_DATE_MUST_BE_AFTER',
  SC_DATE_MUST_BE_BEFORE = 'SC_DATE_MUST_BE_BEFORE',

  // Page control toolbar
  SC_PAGE_CONTROL_OF = 'SC_PAGE_CONTROL_OF',
  SC_PAGE_CONTROL_PAGE = 'SC_PAGE_CONTROL_PAGE',

  // Start Time Zones
  TC_START_TIME_ZONE_AMSTERDAM = 'TC_START_TIME_ZONE_AMSTERDAM',
  TC_START_TIME_ZONE_LONDON = 'TC_START_TIME_ZONE_LONDON',
  TC_START_TIME_ZONE_NEW_YORK = 'TC_START_TIME_ZONE_NEW_YORK',
  TC_START_TIME_ZONE_TOKYO = 'TC_START_TIME_ZONE_TOKYO',

  // Trades Related Panel
  TC_REPO_RATE = 'TC_REPO_RATE',
  TC_EVENT = 'TC_EVENT',
  TC_REPO_INTEREST_START_DATE = 'TC_REPO_INTEREST_START_DATE',
  TC_ORIGINATING_EVENT = 'TC_ORIGINATING_EVENT',
  TC_PREV_REPO_INTEREST_TO_DATE = 'TC_PREV_REPO_INTEREST_TO_DATE',
  TC_PREV_REPO_INTEREST_RATE = 'TC_PREV_REPO_INTEREST_RATE',
  TC_PREV_REPO_INTEREST_START_DATE = 'TC_PREV_REPO_INTEREST_START_DATE',
  TC_PREV_REPO_INTEREST_END_DATE = 'TC_PREV_REPO_INTEREST_END_DATE',
  TC_PREV_REPO_INTEREST_IN_PERIOD = 'TC_PREV_REPO_INTEREST_IN_PERIOD'
}

export type TranslationLookup = Record<Translation, string>
